var _style, _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _path5, _path6, _rect4, _rect5, _path7, _path8, _path9, _path10, _path11, _path12, _rect6, _path13, _rect7, _path14, _rect8, _path15, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path16, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path17, _path18, _path19, _path20, _rect23, _rect24, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _rect25, _rect26, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _rect27, _path142, _rect28, _rect29, _rect30, _path143, _path144, _rect31, _rect32, _rect33, _rect34, _path145, _path146, _rect35, _rect36, _rect37, _path147, _path148, _path149, _rect38, _rect39, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _defs, _path160, _path161, _rect40, _rect41, _path162, _path163, _rect42, _rect43, _path164, _path165, _path166, _path167, _path168, _path169, _rect44, _rect45, _path170, _rect46, _path171, _path172, _path173, _path174, _path175, _rect47, _path176, _defs2, _path177, _rect48, _path178, _path179, _rect49, _rect50, _path180, _path181, _path182, _path183, _rect51, _rect52, _rect53, _path184, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _defs3, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _rect87, _rect88, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _rect89, _rect90, _path232, _rect91, _rect92, _rect93, _rect94, _rect95, _path233, _rect96, _path234, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _path235, _rect104, _rect105, _rect106, _path236, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _path237, _path238, _rect119, _rect120, _rect121, _rect122, _path239, _path240, _rect123, _rect124, _rect125, _rect126, _path241, _path242, _rect127, _rect128, _rect129, _rect130, _path243, _path244, _rect131, _path245, _path246, _rect132, _rect133, _path247, _path248, _path249, _rect134, _path250, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _path251, _rect141, _rect142, _rect143, _rect144, _path252, _path253, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _path254, _path255, _path256, _path257, _path258, _path259, _rect157, _rect158, _rect159, _rect160, _path260, _rect161, _path261, _path262, _rect162, _path263, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _defs4, _path264, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _path265, _path266, _path267, _rect177, _path268, _path269, _path270, _path271, _path272, _path273, _rect178, _rect179, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _path370, _path371, _rect192, _rect193, _path372, _path373, _defs5, _rect194, _rect195, _rect196, _rect197, _rect198, _path374, _path375, _rect199, _rect200, _rect201, _path376, _path377, _path378, _path379, _path380, _path381, _rect202, _rect203, _path382, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _path383, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _rect224, _rect225, _path445, _rect226, _rect227, _rect228, _rect229, _path446, _rect230, _rect231, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _rect232, _rect233, _path454, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _path455, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _path456, _path457, _rect250, _rect251, _path458, _path459, _path460, _rect252, _rect253, _rect254, _rect255, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _path491, _path492, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _path493, _rect280, _rect281, _rect282, _path494, _path495, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _path496, _defs6, _path497, _rect290, _rect291, _rect292, _rect293, _path498, _path499, _rect294, _rect295, _path500, _path501, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSection2Arrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 83.9 74.7",
    style: {
      enableBackground: "new 0 0 83.9 74.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:url(#Union_22_00000065064102708445592140000001208766545143810220_);}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:#B3E1C0;}\n\t.st4{fill:#ADB895;}\n\t.st5{fill:#CD938D;}\n\t.st6{fill:#609C5A;}\n\t.st7{fill:#69A755;}\n\t.st8{fill:#8FD5D3;}\n\t.st9{fill:#90E4E3;}\n\t.st10{fill:#67B1BA;}\n\t.st11{fill:#4B9A97;}\n\t.st12{fill:#6AC4D1;}\n\t.st13{fill:#57959B;}\n\t.st14{fill:#F4BDAC;}\n\t.st15{fill:#EBAD9F;}\n\t.st16{fill:#C4807C;}\n\t.st17{fill:#C46F6D;}\n\t.st18{fill:#91B5C2;}\n\t.st19{fill:#FFFFFF;}\n\t.st20{fill:#9ED67E;}\n\t.st21{fill:#73B857;}\n\t.st22{fill:#3B8A02;}\n\t.st23{fill:#357800;}\n\t.st24{fill:#404215;}\n\t.st25{fill:#57AE2B;}\n\t.st26{fill:#4F4F31;}\n\t.st27{fill:#2A6800;}\n\t.st28{fill:#52A311;}\n\t.st29{fill:#399307;}\n\t.st30{fill:#6BBA0F;}\n\t.st31{fill:#A93E43;}\n\t.st32{fill:#FFDC63;}\n\t.st33{fill:#FCA44C;}\n\t.st34{fill:#CE6048;}\n\t.st35{fill:#8D3B15;}\n\t.st36{fill:#6BCDD8;}\n\t.st37{fill:#88E2E0;}\n\t.st38{fill:#FBDECC;}\n\t.st39{fill:#66ADB3;}\n\t.st40{fill:#578100;}\n\t.st41{fill:#35696B;}\n\t.st42{fill:#58969F;}\n\t.st43{fill:#BD7252;}\n\t.st44{fill:#A45941;}\n\t.st45{fill:#A04F42;}\n\t.st46{opacity:0.3;}\n\t.st47{clip-path:url(#SVGID_00000082361210847810755440000003553043969552781209_);}\n\t.st48{fill:#6B9F7E;}\n\t.st49{fill:#DE7E52;}\n\t.st50{opacity:0.5;}\n\t.st51{clip-path:url(#SVGID_00000103975409287545065050000015233604703707474081_);}\n\t.st52{fill:#FFC85C;}\n\t.st53{fill:#FFB35C;}\n\t.st54{fill:#E79F5B;}\n\t.st55{fill:#D68D5B;}\n\t.st56{fill:#924D48;}\n\t.st57{fill:#724839;}\n\t.st58{fill:#6BABAE;}\n\t.st59{clip-path:url(#SVGID_00000062872018824799715820000002575703213452798883_);}\n\t.st60{fill:#7BBF2D;}\n\t.st61{fill:#62AF23;}\n\t.st62{fill:#94D62B;}\n\t.st63{fill:#FDB640;}\n\t.st64{fill:#F09353;}\n\t.st65{fill:#FFC646;}\n\t.st66{fill:#F09A53;}\n\t.st67{fill:#79A7AC;}\n\t.st68{fill:#FBCAA2;}\n\t.st69{fill:#C3C4BA;}\n\t.st70{fill:#A4A4A4;}\n\t.st71{fill:#454A60;}\n\t.st72{fill:#835C39;}\n\t.st73{fill:#634734;}\n\t.st74{fill:#382B2C;}\n\t.st75{opacity:0.4;}\n\t.st76{clip-path:url(#SVGID_00000031172261002166373710000001087226050299383947_);}\n\t.st77{fill:#452F2E;}\n\t.st78{fill:#5FA133;}\n\t.st79{fill:#4F6F6B;}\n\t.st80{fill:#A4B5AE;}\n\t.st81{fill:#397C07;}\n\t.st82{fill:#50B507;}\n\t.st83{fill:#C83B31;}\n\t.st84{fill:#E74A31;}\n\t.st85{fill:#354C48;}\n\t.st86{opacity:0.2;}\n\t.st87{clip-path:url(#SVGID_00000052809517687766235300000005034473549482868395_);}\n\t.st88{fill:#403B31;}\n\t.st89{fill:#AFB99F;}\n\t.st90{fill:#65B029;}\n\t.st91{fill:#684215;}\n\t.st92{fill:#D43B31;}\n\t.st93{fill:#903B31;}\n\t.st94{fill:#EC8154;}\n\t.st95{fill:#54A220;}\n\t.st96{fill:#7C9AA9;}\n\t.st97{fill:#637789;}\n\t.st98{fill:#D1DEE3;}\n\t.st99{fill:#9AA1A7;}\n\t.st100{fill:#A3A9A9;}\n\t.st101{fill:#A04D34;}\n\t.st102{fill:#EA9748;}\n\t.st103{fill:#F0FFFF;}\n\t.st104{fill:#B56D52;}\n\t.st105{fill:#C78B52;}\n\t.st106{fill:#5996A6;}\n\t.st107{clip-path:url(#SVGID_00000026124388572895864250000006680193844072134039_);}\n\t.st108{fill:#7A4348;}\n\t.st109{fill:#00A3DA;stroke:#00A3DA;stroke-width:0.5;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Union_22_00000025405212755667654610000015337398268289165734_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.7404,
    y1: 916.5816,
    x2: 423.6494,
    y2: 916.3546,
    gradientTransform: "matrix(1440 0 0 -994 -608696 911463.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBE7F5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_22",
    style: {
      display: "none",
      fill: "url(#Union_22_00000025405212755667654610000015337398268289165734_)"
    },
    d: "M1,0h1440 v994H1V0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Illustration_homepage",
    transform: "translate(-84.902 1656)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2901",
    transform: "translate(0 0)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2997"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_947",
    className: "st3",
    d: "M1230.1-711.3C1133-739,989.6-884.5,758.6-879c-154.5,3.6-208.9,64.2-341.2,25.5 c0.6-0.2,13.9,154.9,13.9,154.9l719.3,7L1230.1-711.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673",
    x: 585.2,
    y: -827.4,
    className: "st4",
    width: 30.3,
    height: 21
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_948",
    className: "st4",
    d: "M617.3-826.4l-17-16.7l-17,16.7H617.3z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674",
    x: 1050.3,
    y: -767.9,
    className: "st4",
    width: 78.1,
    height: 54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_949",
    className: "st4",
    d: "M1132.9-765.3l-43.7-43l-43.7,43H1132.9z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675",
    x: 1110.2,
    y: -775.5,
    className: "st5",
    width: 77,
    height: 41.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_950",
    className: "st6",
    d: "M586.8-811.5c-2.7-6.1-2.5-15.5-7.9-20.2c-4-3.6-11.5,1-10.2,6.2c-1.3-0.6-4.2-4.2-5.8-4 c-2,0.4-2.1,4.5-4.1,5.8c0-0.4-0.2-0.8-0.4-1c-0.6,1.8-1.1,1.3-2,1.9c-1.5-5.1-4.2-14-9.4-16.3c-5.8-2.6-8.5,6.2-8.1,11 c-1.6-1.3-4.9-3.5-7.1-3.2c-0.7,2.7-3.1,5.4-2.9,7.8c-2.8-0.3-2.2-5-5.9-4.6c-3.2,0.3-3.9,4.2-4.6,6.6c-2.7-1.6-3.9-5.6-7.3-6.6 c-4.4-1.2-5.7,2.2-7.1,5.3c-1-4.2-1.4-9-4.7-12.2c-1.7-1.6-9.2-6.3-8.8-1.2c0.4-4.4-3.4-16.4-9.6-15.1c-4.5,0.9-6.4,12.7-7,16.3 c-6.6-7.7-10.5,1.1-12.4,7.3c-1.3-1.7-4.1-6.4-6.9-6.3c-2.8,0.2-2.4,3.6-3.4,5.8c-2.3-1.2-2.5-5.2-3.8-7.4 c-1.5-2.4-3.8-5.5-6.5-6.6c-6.9-2.6-7.9,6.5-8.2,11.3c-5.4-0.2-7,2.8-7.8,8c-0.5,2.9,0.5,9.7-2,11.5c-3.2-2.8-4.7-4.7-8.6-2.1 c-2.4,1.6-5.7,5.7-5.5,8.6c-2.2-5-9-12.2-12.7-4c-2.4-6.6-5-20.1-11.8-23.5c-8.5-4.3-7.1,6.9-9.1,11.5c-2.4-6-6.4-1.5-8.1,2.4 c-1.6,3.5-1.8,7.7-2.2,11.6c-1.3-1.9-2.1-4.8-4.5-5.3c-3.4-0.8-5.8,2.9-5.5,5.9c-0.5,0.3-1.1,0.5-1.7,0.7c-1.3-2-0.5-4.1-1.1-6.2 c-0.7-2.2-2.4-3.5-3-5.4c-1.7,1.4-3.6,1.9-5.5,2.8c-2.5-6.1-3.8-18-10.6-21.4c-6.8-3.4-7.5,9.1-9.3,13c-2.7-1.6-4.2-8.7-9-7.1 c-4.9,1.5-4.2,8.1-6.8,11.3c-5.3-7.6-10.5-0.5-9.9,6.3c-18.4-14.2-26.2,19.2-24.9,32c1,9.2,8.2,10.6,16.3,11.8 c9.8,1.4,19.1,4.1,28.7,6.1c13,2.7,26.5,3.2,39.7,4.9L586.8-811.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_951",
    className: "st7",
    d: "M592-814.5c0.1-3-0.3-8.2-2.2-10.6c-2.6-3.1-6.2-0.5-7.8,2.4c-1.2-1.3-1.6-3.9-3.9-3.2 c-1.5,0.5-2.3,3.4-3.5,4.3c-2.7-5-2.8-18.9-10.2-19.8c-4.6-0.6-6.4,13.1-6.4,16.7c-0.8-4.9-6.5,1.7-7.5,2.5 c-0.4-1.5-2.3-3.1-3.9-2.8c-2.4,0.4-1.9,3.3-3.9,3.9c-2.6-3.4-4.8,1.4-6.9,2c-0.6-3.8-1.1-6.8-5-8.7c-3.7-1.8-7.8-0.2-8.7,4.1 c0-2.6-3.6-9.2-6.4-10c-5.4-1.4-4.8,5.6-7.4,7.6c-1-4.3-5.7-1.7-7.5,0c-2.2,2-3.2,4.5-4.9,7c-1.5-4.8-1.8-10.4-7.1-12.8 c-5.8-2.6-8.1,3.5-9.5,7.8c-2.7-3.3-4.1,3.5-5,5.4c-2.1,0.5-2.7-2.7-4-4c-2.1-2.2-4.5-2.4-7.1-1.1c-4.5,2.1-3.9,8.6-8.1,10.7 c-2.2-4.8-3.1-12.1-10.4-11.4c-5.7,0.5-7.7,7.7-8.7,12.3c-1-5.8-3.1-23.2-10.1-24.8c-6.6-1.5-5.5,13.8-5.5,17.4 c-4.6-9.5-6.8,10.8-8.6,11.5c-1.2,0.5-4-1.7-5.7-1.5c-1.9,0.3-3.5,1.4-4.6,3c-1.9,2.4-2.3,5.9-2.9,8.8c-0.6-1.3-1.6-4.9-3.1-5.4 c-2.5-0.7-3.3,2.5-4.9,3.5c-5.4-8.3-12.9,0.4-15,6.5c0-3.7-2.8-11.1-6.5-12.7c-4.8-2-6.2,4.7-6.6,8.1c-0.6-2.6-4.2-3-6.2-1.8 c-2,1.2-3.1,4.5-3.4,6.8c-2.2-2.4-2.9-7-4.4-9.5c-2.4-4.1-3.5-3.6-5.9-0.3c0-1.4-1.6-4.2-2.8-4.7c-2.8-1.2-4.1,1.6-6.3,2.6 c-1.7-2.8-4.3-9.2-7.9-10.2c-3-0.8-5.4,2.3-7.3,4.1c-7,6.8-14.2,12.8-15.2,23.2c-0.5,5.2,0.2,10.5,0.9,15.6 c0.4,3.2,0.4,7.5,2.3,10.2c2.6,3.8,8.2,4,12.3,4.3c10.9,0.6,22-0.7,32.8-1.9c19.7-2.2,42.1-3.3,60.4-11.4L592-814.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_952",
    className: "st8",
    d: "M993.8-784.1l38.6-42.9l38.6,42.9h0.2v0.2l0.1,0.1c-0.1,0-0.1,65.4-0.1,65.4h-77.8v-65.7 H993.8z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676",
    x: 993.4,
    y: -728.8,
    className: "st9",
    width: 77.9,
    height: 4.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677",
    x: 993.4,
    y: -783,
    className: "st9",
    width: 77.7,
    height: 7.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_953",
    className: "st10",
    d: "M1066.4-718.3h4.8v-64.3l-4.8-6L1066.4-718.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_954",
    className: "st11",
    d: "M1032.4-823.5l44.2,49.1l3.5-3.1l-47.7-52.9V-823.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_955",
    className: "st11",
    d: "M1032.4-823.5l-44.2,49.1l-3.5-3.1l47.7-52.9L1032.4-823.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_956",
    className: "st12",
    d: "M1044.8-737.1v-21.5c-0.1-6.8-5.6-12.3-12.5-12.3c-6.7,0.1-12.2,5.5-12.3,12.3v21.5H1044.8 z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_957",
    className: "st10",
    d: "M1032.4-769c5.8,0,10.5,4.7,10.5,10.5v19.6h-20.9v-19.6 C1021.9-764.3,1026.6-769,1032.4-769C1032.4-769,1032.4-769,1032.4-769"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_958",
    className: "st13",
    d: "M1040.2-740.6l-0.1-17.9c0-4.3-3.5-7.8-7.8-7.7c-4.3,0-7.7,3.5-7.7,7.7l0.1,17.9H1040.2z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678",
    x: 1031.9,
    y: -767,
    className: "st10",
    width: 1,
    height: 26.7
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_959",
    className: "st10",
    d: "M1026.6-797.4c0,3.2,2.6,5.8,5.8,5.8c3.2,0,5.8-2.6,5.8-5.8c0-3.2-2.6-5.8-5.8-5.8 C1029.2-803.2,1026.6-800.6,1026.6-797.4C1026.6-797.4,1026.6-797.4,1026.6-797.4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679",
    x: 1018.3,
    y: -739,
    className: "st9",
    width: 28.2,
    height: 3.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_960",
    className: "st10",
    d: "M1071.2-780.5l-38.8-36.1l-39.1,36.4l39-43.3L1071.2-780.5z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680",
    x: 771.6,
    y: -790.8,
    className: "st4",
    width: 78.1,
    height: 54
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_961",
    className: "st4",
    d: "M854.1-788.2l-43.7-43l-43.7,43H854.1z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681",
    x: 1343.1,
    y: -836.3,
    className: "st14",
    width: 6.5,
    height: 15.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1682",
    x: 1342.8,
    y: -836.9,
    className: "st5",
    width: 7.2,
    height: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1683",
    x: 1332.7,
    y: -833.4,
    className: "st14",
    width: 6.5,
    height: 15.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684",
    x: 1332.3,
    y: -834,
    className: "st5",
    width: 7.2,
    height: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1685",
    x: 1268.6,
    y: -800.6,
    className: "st14",
    width: 93.5,
    height: 67.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1686",
    x: 1268.6,
    y: -800.6,
    className: "st15",
    width: 93.5,
    height: 8.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687",
    x: 1268.6,
    y: -758.5,
    className: "st5",
    width: 93.5,
    height: 25.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_962",
    className: "st5",
    d: "M1265.9-796.3h97.7l-3.5-28.2h-90.6L1265.9-796.3z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1688",
    x: 1295,
    y: -825.6,
    className: "st16",
    width: 39.3,
    height: 25.9
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1689",
    x: 1264.4,
    y: -801.1,
    className: "st17",
    width: 100.6,
    height: 5.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1690",
    x: 1345.3,
    y: -790.1,
    className: "st17",
    width: 7.8,
    height: 26.7
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1691",
    x: 1346.1,
    y: -786.6,
    className: "st18",
    width: 7,
    height: 19.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1692",
    x: 1325.8,
    y: -790.1,
    className: "st17",
    width: 7.8,
    height: 26.7
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1693",
    x: 1326.6,
    y: -786.6,
    className: "st18",
    width: 7,
    height: 19.2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1694",
    x: 1269.4,
    y: -826.7,
    className: "st17",
    width: 90.6,
    height: 2.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_963",
    className: "st17",
    d: "M1350.5-803v-11c0-3.5-2.8-6.3-6.3-6.3s-6.3,2.8-6.3,6.3l0,0v11H1350.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_964",
    className: "st18",
    d: "M1348.2-804.9l0-9.2c0-2.2-1.8-4-4-4s-4,1.8-4,4l0,9.2H1348.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_965",
    className: "st17",
    d: "M1291.5-803v-11c0-3.5-2.8-6.3-6.3-6.3c-3.5,0-6.3,2.8-6.3,6.3l0,0v11H1291.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_966",
    className: "st18",
    d: "M1289.2-804.9l0-9.2c0-2.2-1.8-3.9-4-3.9c-2.1,0-3.9,1.8-3.9,3.9l0,9.2H1289.2z"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1695",
    x: 1345.3,
    y: -767.3,
    className: "st19",
    width: 7.8,
    height: 3.9
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1696",
    x: 1325.8,
    y: -767.2,
    className: "st19",
    width: 7.8,
    height: 3.9
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_967",
    className: "st20",
    d: "M1397.3-756.4c71,0,128.5,26.3,128.5,58.8h-257C1268.8-730.1,1326.4-756.4,1397.3-756.4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_968",
    className: "st21",
    d: "M1462.3-699c5-53.1-428.5-16.6-718.3-94.1c-287.7-77-360.8,28-573.2,70 c-37.2,7.4-34.6,23.8-86,25.1c1.5,0.8,1377.4,1.6,1377.4,1.6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_969",
    className: "st22",
    d: "M544.4-781.2c7.7-2.7,14.2-7.9,15.7-17c1.3-7.9-3.3-14.1-8.5-19.4 c-3.4-3.5-2.3-7.8-3.3-12.2c-1.3-5.3-5.9-10.1-11.6-10.6c-5.7-0.5-6.8,4.6-9.2,8.5c-3.2,5.3-8.6,5.9-13.6,8.7 c-5.8,3.3-1.5,10.8-3.4,16.3c-2,5.8-5,9.3-2.8,15.5c2.9,8.1,13.8,12.5,20.8,12.6C534-778.7,539.3-779.5,544.4-781.2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_970",
    className: "st23",
    d: "M513.7-823.1c7.7,2.7,9.3,6.4,10.9,20.6c2.1,10.7,21.3-2.1,32,4.3c0.8,0.8,1.9,1.6,3,2.5 c-2.2,7.5-8.1,12.1-15.1,14.5c-5.1,1.7-10.5,2.5-15.8,2.4c-7-0.1-17.9-4.5-20.8-12.6c-2.2-6.3,0.8-9.8,2.8-15.5 C512.5-812.4,508.4-819.6,513.7-823.1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_971",
    className: "st24",
    d: "M537.6-742.3h-7.2l1.5-54c-0.6-13.4,2.8-15.5,4-15.1L537.6-742.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_972",
    className: "st24",
    d: "M534.8-788.4c2.9-0.4,5.9-1,7.8-3.5c2.2-2.9,2.2-6.9,2.2-10.4c0-0.8,0-1.6,0-2.3l-2.1-0.1 c0,0.7,0,1.5,0,2.4c0,3.2,0,6.8-1.7,9.1c-1.4,1.8-3.8,2.3-6.4,2.6L534.8-788.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_973",
    className: "st24",
    d: "M533.1-772.2c0.2,0,0.4,0,0.6,0l-0.2-2.1c-3.4,0.1-6.6-1.8-8.1-4.9 c-1.5-3.4-1.9-7.3-1.1-12l-2.1-0.4c-0.9,5.1-0.5,9.4,1.3,13.2C525.3-774.7,529-772.3,533.1-772.2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_974",
    className: "st24",
    d: "M522.6-781.8c0.1,0,0.2,0,0.3,0l-0.2-2.1c-1.2-0.2-2.4-0.8-3.1-1.8c-0.6-1-1-2.2-1.1-3.3 c-0.1-0.5,0-1,0-1.4c0.1-0.6,0.1-1.2,0.1-1.7l-2.1,0.2c0,0.4,0,0.8-0.1,1.2c-0.1,0.7-0.1,1.4,0,2c0.2,1.5,0.7,2.9,1.5,4.1 C518.9-783,520.6-782,522.6-781.8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_975",
    className: "st24",
    d: "M532.1-804l0.9-2c-1-0.3-1.9-0.9-2.7-1.7c-1-1.3-0.8-3.5,0-5l-1.9-1 c-1.1,2.1-1.5,5.3,0.2,7.4C529.6-805.2,530.8-804.4,532.1-804"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_976",
    className: "st22",
    d: "M547-733.8c1.1-3.1-2.5-9.4-6-9.2c-0.4,0.8-0.6,1.8-0.4,2.7c0.2-1.8-0.7-5-2.5-5.5 c-0.2,0.3-0.5,0.6-0.7,0.9c-1.4-2.5-0.9-5.7-4-7.3c-2.2-1.2-5.5,0.3-5,3.2c-1.3-2.2-3.4-6.2-6.6-4.6c-2.7,1.3-2.4,4.9-2.5,7.4 c-0.8-2.4-2.7-3-4.5-1.2c-1.8,1.9-1.5,4.5-1.5,6.9c-2.6-3.8-5.2,1.9-5.1,4.3c-1.1-0.6-1.8-1.7-2.8-0.2c-0.3,0.9-0.1,1.9,0.3,2.7 H547z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_977",
    className: "st23",
    d: "M508.2-819.7c-0.1,0.5,0,1.1,0.1,1.6c0.1,1.1,0.6,2,1.4,2.8c1.5,1.5,2.8,2.1,3.9,1.7 c0.5-0.2,0.7-0.9,0.6-1.8c-0.2-1.1-0.8-2.1-1.6-2.9c-0.8-0.7-1.7-1.1-2.8-1.3C509.2-819.6,508.7-819.6,508.2-819.7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_978",
    className: "st23",
    d: "M507.6-813.6c0,0.5,0.1,0.9,0.2,1.4c0.2,0.8,0.6,1.6,1.1,2.3c1.3,1.3,3.1,2,3.7,1.3 c0.7-0.7,0.2-2.4-1.2-3.8c-0.7-0.7-1.6-1.1-2.6-1.1C508.5-813.7,508-813.7,507.6-813.6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_979",
    className: "st23",
    d: "M523.2-818.2c-0.3,0.1-0.6,0.3-0.9,0.4c-0.6,0.3-1,0.7-1.4,1.2c-0.7,1.3-0.7,2.7-0.1,2.9 c0.7,0.2,1.7-0.5,2.3-1.6c0.3-0.6,0.4-1.3,0.3-2C523.4-817.6,523.4-817.9,523.2-818.2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_980",
    className: "st23",
    d: "M554.6-804.7c0,0-0.5,0.4-1.3,1c-0.8,0.5-1.5,1.3-2,2.1c-0.5,1-0.7,2.1-0.6,3.2 c0.1,1,0.6,1.6,1.2,1.6c0.7,0,1.3-0.3,1.7-0.8c0.7-0.6,1.2-1.4,1.6-2.2c0.5-1.1,0.5-2.3,0.2-3.4 C555.2-803.8,555-804.3,554.6-804.7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_981",
    className: "st23",
    d: "M558.6-788.4c-0.2-0.4-0.4-0.8-0.7-1.1c-0.6-0.7-1.5-1.1-2.4-1.2c-2.1-0.1-3.5,0.9-3.4,1.8 c0.1,0.9,1.6,1.5,3.3,1.5c0.7,0,1.5-0.2,2.1-0.5C558.1-788.1,558.6-788.4,558.6-788.4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_982",
    className: "st23",
    d: "M553.3-783.3c-0.1-0.4-0.2-0.7-0.4-1c-0.4-0.7-1.1-1.2-1.9-1.5c-1.6-0.4-2.8-0.1-3.2,0.7 s0.9,1.8,2.4,2.1c0.6,0.1,1.3,0.1,1.9,0C552.8-783.2,553.3-783.3,553.3-783.3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_983",
    className: "st23",
    d: "M506.1-787.3c0.4,0,0.7,0,1.1,0.1c0.6,0.2,1.3,0.2,2,0.1c0.8-0.1,1.5-0.5,2.1-0.9 c0.5-0.5,0.8-1,0.5-1.4c-0.5-0.7-1.5-1-3.3-0.7c-0.9,0.2-1.6,0.8-2.1,1.5C506.2-788.1,506.1-787.7,506.1-787.3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_984",
    className: "st23",
    d: "M511.1-783.3c0.8,0.1,1.7,0,2.4-0.4c0.3-0.2,0.6-0.4,0.9-0.6c0.3-0.2,0.5-0.4,0.6-0.7 c0.1-0.3-0.1-0.6-0.6-0.9c-0.7-0.2-1.5-0.1-2.1,0.3C511.6-785.2,511.1-784.3,511.1-783.3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_985",
    className: "st22",
    d: "M552.7-824.2c-0.4-0.1-0.9-0.1-1.3,0c-0.9,0.1-1.8,0.5-2.5,1.1c-1.3,1.2-1.9,2.8-1.4,3.6 c0.5,0.8,2.3,0.3,3.8-1.1c0.6-0.6,1-1.4,1.2-2.2C552.6-823.2,552.7-823.7,552.7-824.2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_986",
    className: "st22",
    d: "M549.3-833.9c0,0-0.5,0.4-1.1,1c-0.7,0.5-1.3,1-1.8,1.7c-1,1.4-1.7,3.1-1,4 c0.7,0.8,2.8,0.4,4.2-1.8c0.7-1,0.8-2.3,0.4-3.4C549.9-833,549.6-833.5,549.3-833.9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_987",
    className: "st22",
    d: "M543.6-844.9c-0.5,0.4-0.9,0.8-1.2,1.2c-0.8,0.8-1.3,1.8-1.6,2.8c-0.4,2.2-0.2,4.2,0.9,4.7 c0.6,0.3,1.3,0,2-0.7c0.8-0.9,1.4-2,1.6-3.1c0.2-1.2,0-2.5-0.6-3.5C544.3-844,544-844.5,543.6-844.9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_988",
    className: "st22",
    d: "M526.8-836.5c-0.6,1.3-0.8,2.7-0.5,4.1c0.7,1.9,2,3.1,3,2.8c1-0.3,1.2-2.2,0.5-4.1 C529.2-835,528.1-836,526.8-836.5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_989",
    className: "st22",
    d: "M522.2-831.5c-0.3,1.3-0.1,2.6,0.6,3.8c1.1,1.5,2.6,2.3,3.4,1.8c0.8-0.6,0.5-2.2-0.6-3.8 C524.7-830.8,523.5-831.4,522.2-831.5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_990",
    className: "st22",
    d: "M534.7-843.5c-1.1,1.1-1.7,2.6-1.5,4.1c0.1,1,0.6,2,1.3,2.8c0.6,0.7,1.2,0.9,1.7,0.6 c0.5-0.4,0.8-0.9,0.9-1.6c0.2-0.8,0.2-1.7,0-2.5c-0.2-0.9-0.7-1.8-1.3-2.4C535.2-843,534.7-843.5,534.7-843.5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_991",
    className: "st25",
    d: "M546.5-817.9c-0.3,0.2-0.5,0.5-0.8,0.7c-0.5,0.5-0.8,1-1,1.6c-0.4,1.3-0.4,2.4,0.3,2.9 c0.6,0.4,2-0.4,2.4-2.1c0.2-0.8,0.1-1.5-0.3-2.2C547-817.3,546.8-817.6,546.5-817.9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_992",
    className: "st25",
    d: "M542.1-821.9c0,0-0.4,0.5-0.8,1.1c-0.5,0.7-0.8,1.4-0.9,2.3c0,0.5,0,0.9,0,1.4 c0,0.4,0.2,0.9,0.4,1.3c0.4,0.8,0.9,1.1,1.3,1c0.5-0.2,0.9-0.6,1.1-1.1c0.3-0.7,0.5-1.5,0.6-2.2c0-1-0.2-1.9-0.8-2.7 C542.8-821.3,542.5-821.6,542.1-821.9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_993",
    className: "st25",
    d: "M536.7-820.1c0,0,0,0.4,0,0.9c0,0.5,0.1,1.1,0.3,1.6c0.5,1,1.6,2,2.1,1.6 c0.5-0.4,0.6-1.4,0-2.7c-0.3-0.6-0.9-1-1.6-1.2C537.3-820.1,537-820.2,536.7-820.1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_994",
    className: "st25",
    d: "M531.9-819.6c0,0,0.2,0.4,0.3,0.8c0.1,0.5,0.3,1,0.6,1.4c0.7,1,2.1,1.6,2.5,1 c0.3-0.6,0.2-1.4-0.7-2.5c-0.5-0.5-1.1-0.8-1.8-0.9C532.5-819.8,532.2-819.8,531.9-819.6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_995",
    className: "st25",
    d: "M539.4-834.1c-0.2,0.2-0.5,0.5-0.6,0.7c-0.4,0.5-0.6,1.1-0.7,1.7c-0.1,0.5-0.1,0.9,0,1.4 c0,0.4,0.2,0.7,0.4,1c0.2,0.2,0.7,0.2,1.2-0.1c0.5-0.5,0.9-1.2,0.9-2c0-0.7-0.2-1.3-0.6-1.9C539.8-833.6,539.6-833.9,539.4-834.1 "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_996",
    className: "st25",
    d: "M534.9-834.9c0,0-0.1,0.5-0.1,1c-0.2,0.5-0.4,1.1-0.4,1.6c0,0.7,0.2,1.4,0.5,2 c0.4,0.6,0.9,0.8,1.2,0.6c0.3-0.3,0.5-0.6,0.6-1c0.2-0.5,0.3-1.1,0.3-1.7c0-0.8-0.4-1.6-1.1-2.1 C535.7-834.7,535.3-834.9,534.9-834.9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_997",
    className: "st25",
    d: "M531-832c-0.1,0.7,0,1.4,0.4,2c0.6,0.9,1.4,1.3,1.8,0.9s0.2-1.3-0.4-2.1 C532.3-831.6,531.7-831.9,531-832"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_998",
    className: "st22",
    d: "M635.6-764.6c0.4-0.2,0.9-0.4,1.3-0.6c5.6-2.6,9.8-10,7.6-16.1c-1.2-3.2-4.8-4.7-5.3-8.3 c-0.6-4.6-4.6-7.9-8.4-3.3c-4.1,5-12.8,2.7-15.6,9c-1.4,3.2,2,9.2-3.6,9.2c-3.4,0-12.2,4.1-4.8,7 C615.3-764.4,626.6-761.1,635.6-764.6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_999",
    className: "st23",
    d: "M611.5-774.8c4.6,0,3-4.1,3.2-7.4c1.3,4.3,2.7,8.7,7.3,10.5c7.8,2,15.7-6.2,23-5.8 c-0.4,5.2-3.4,9.9-8.1,12.3c-0.4,0.2-0.8,0.4-1.3,0.6c-9,3.5-20.3,0.2-28.9-3.1C599.3-770.6,608.1-774.8,611.5-774.8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1000",
    className: "st26",
    d: "M630.1-728.9h-5.3l1.3-76.5c0.9,0.7,1.8,1.4,2.8,1.9L630.1-728.9z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1001",
    className: "st22",
    d: "M624.1-829.4c10.4-4.2,13.8,12.4,8.9,12.7C629-816.4,617.5-826.7,624.1-829.4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1002",
    className: "st22",
    d: "M628.9-796c2.3-0.9,4.4-2.1,6.4-3.4c2-1.3,5.4-4.1,3.5-6.8c-2.1-3-6.3-3.6-8.7-6.9 c-2.4-3.3-6.5-2.5-8.3,1c-1.7,3.3-1.5,5.4-5.6,6.2c-3.7,0.7-7.2,2.6-6.8,6.9c0.7,8.6,10.4,5.6,15.9,4.2 C626.6-795.1,627.8-795.5,628.9-796"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1003",
    className: "st23",
    d: "M615.6-805.8c0.3,0.8,0.7,1.6,1.2,2.3c4,8,13.3,1.3,21.3,1.3c-0.2,0.2-0.3,0.5-0.2,0.8 c-0.7,0.7-1.6,1.4-2.4,2c-2,1.4-4.2,2.5-6.4,3.4c-1.1,0.4-2.3,0.8-3.4,1.1c-5.6,1.4-15.2,4.4-15.9-4.2 C609.2-803.1,612.1-805,615.6-805.8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1004",
    className: "st27",
    d: "M654.3-721.9c0.7-2.1,1-1.3,0.5-3.5c-0.4-1.9-3.5-5.9-5.2-2.7c-0.9-1.4,0-3.2-1.5-4.6 c-1.1-1-3-1.4-4.1-0.2c-0.2-2.2-0.2-4.5-1.6-6.4c-0.4-0.5-3.8-3.5-5.1,1c0.6-1.9-1.2-2.4-2.4-1.8c-0.9,0.5-1.5,2.3-2.2,3.1 c-0.6-1.6-0.7-4-2.2-5c-1.9-1.2-3.2,0.1-3.7,2c-0.6-2.2-2.7-2.9-4.2-1.2c-1.3,1.7-1.9,3.8-1.8,5.9c-2.5-2.9-5.2,1-5.7,3.5 c-0.6,3,0.1,6.8,0.1,9.8L654.3-721.9z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1005",
    className: "st26",
    d: "M625.1-790.8c0.8,0,1.6-0.1,2.4-0.2l-0.1-1.3c-1.4,0.1-4.3,0.5-5.5-0.8 c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.2,0-0.4,0-0.6c-0.1-1.2,0-2.3,0.2-3.5l-1.3-0.2c-0.2,1.2-0.3,2.5-0.2,3.8c0,0.1,0,0.3,0,0.5 c-0.1,0.8,0.2,1.7,0.7,2.3C621-792,625.4-790.8,625.1-790.8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1006",
    className: "st26",
    d: "M630.6-768.9c1.4,0.1,2.8-0.3,4-1.2c1-0.9,1.6-2.1,1.8-3.4l-0.3-0.1 c0.3-2.1,0.3-4.3,0-6.4l-1.3,0.1c0.3,2,0.2,4,0,6.1l-0.1,0.4c0,0.8-0.4,1.7-1,2.3c-1.6,1.3-4.4,0.8-5.9,0.6l-0.2,1.3 C628.6-769.1,629.6-769,630.6-768.9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1007",
    className: "st26",
    d: "M636.4-774.7h0.2c1,0,2.3,0,3.1-1.2c0.7-1.1,0.5-2.9,0.2-4.4l-1.3,0.2 c0.1,0.9,0.5,2.7,0,3.5c-0.3,0.5-1,0.6-2,0.6h-0.2L636.4-774.7z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1008",
    className: "st26",
    d: "M624.3-776.1c0.3,0,0.7,0,1,0c0.3,0,0.5,0,0.8,0l0-1.3c-0.2,0-0.5,0-0.8,0 c-1,0-2.1,0.1-2.7-0.4c-0.2-0.2-0.2-0.5-0.2-1l0-0.6c0-0.6,0-1.2,0.1-1.8l-1.3-0.3c-0.1,0.7-0.2,1.4-0.1,2.1l0,0.6 c-0.1,0.7,0.2,1.4,0.7,2C622.4-776.3,623.4-776,624.3-776.1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1009",
    className: "st26",
    d: "M627.9-811.7c0-2.1,0.1-4.2,0.2-6.3c0.1-1.8,0.2-3.7,0.2-5.6l-1.3,0 c0,1.8-0.1,3.7-0.2,5.6c-0.1,1.7-0.2,3.8-0.2,6.3L627.9-811.7z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1010",
    className: "st26",
    d: "M620.7-795.2c0.1,0,0.3,0,0.4,0l-0.2-1.3c-0.5,0.1-1-0.1-1.4-0.5 c-0.4-0.8-0.5-1.6-0.3-2.4l-1.3-0.2c-0.3,1.2-0.1,2.4,0.6,3.5C619.1-795.5,619.9-795.2,620.7-795.2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1011",
    className: "st26",
    d: "M628-818.1c1,0,1.9-0.2,2.8-0.6c1.2-0.5,1.7-1.8,1.7-3.7l-1.3,0c0,1.4-0.2,2.2-0.9,2.4 c-0.8,0.3-1.7,0.5-2.6,0.4l-0.2,1.3C627.6-818.1,627.8-818.1,628-818.1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1012",
    className: "st26",
    d: "M626.9-820.6c0.1,0,0.1,0,0.2,0l0-1.3c-0.6,0.1-1.3-0.1-1.7-0.5c-0.3-0.8-0.5-1.7-0.5-2.6 c0-0.4,0-0.7-0.1-1l-1.3,0.2c0,0.3,0.1,0.6,0.1,0.9c0,1.1,0.2,2.2,0.7,3.2C624.8-821,625.8-820.6,626.9-820.6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1013",
    className: "st22",
    d: "M635.7-811.7c-0.8,0.3-1.5,0.9-1.9,1.6c-0.5,1-0.4,2.1,0.1,2.4c0.5,0.3,1.4-0.4,1.9-1.6 c0.2-0.5,0.2-1.1,0.1-1.6C635.9-811.2,635.8-811.4,635.7-811.7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1014",
    className: "st22",
    d: "M633.1-812.8c-0.6,0.4-0.9,1-1.1,1.7c-0.2,1,0.1,1.8,0.6,1.9c0.5,0.1,1.1-0.6,1.3-1.7 C633.9-811.6,633.6-812.3,633.1-812.8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1015",
    className: "st22",
    d: "M619.6-811.6c-0.1,0.7,0,1.4,0.4,2c0.6,0.7,1,1,1.5,1c0.2,0,0.4-0.3,0.5-0.7 c0-0.5-0.2-1-0.6-1.4C620.9-811.2,620.3-811.5,619.6-811.6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1016",
    className: "st22",
    d: "M618.2-809.6c0,0,0,0.3,0.1,0.7c0,0.4,0.2,0.8,0.4,1.2c0.3,0.4,0.7,0.7,1.1,0.9 c0.4,0.1,0.7,0.1,0.8-0.1c0.1-0.3,0.1-0.6,0-0.8c-0.1-0.4-0.3-0.7-0.5-1c-0.3-0.4-0.7-0.7-1.2-0.8 C618.7-809.6,618.5-809.6,618.2-809.6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1017",
    className: "st22",
    d: "M641-788.7c-0.3,0-0.6,0.1-0.9,0.2c-0.6,0.2-1,0.5-1.4,0.9c-0.8,0.9-1.1,2-0.6,2.5 s1.6,0,2.5-1c0.4-0.5,0.6-1.1,0.6-1.7C641.1-788.2,641.1-788.4,641-788.7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1018",
    className: "st22",
    d: "M640.4-791.8c-0.8,0.1-1.6,0.6-2.1,1.2c-0.7,0.9-0.9,1.7-0.6,2.2c0.2,0.2,0.5,0.3,1,0.2 c0.6-0.2,1-0.6,1.4-1.1C640.5-790.1,640.7-791,640.4-791.8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1019",
    className: "st22",
    d: "M632.9-796.5c-0.3,0.4-0.4,0.8-0.4,1.3c0.1,0.6,0.5,1.1,0.8,1.1s0.5-0.6,0.4-1.3 C633.5-795.8,633.3-796.2,632.9-796.5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1020",
    className: "st22",
    d: "M618.1-790c0,0.3,0,0.6,0,0.9c0.1,0.6,0.3,1.1,0.7,1.5c0.8,0.8,1.5,1.3,2.1,1.1 c0.3-0.1,0.4-0.5,0.4-1c-0.1-0.6-0.4-1.2-0.8-1.6c-0.4-0.4-0.9-0.7-1.5-0.8C618.7-790,618.4-790,618.1-790"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1021",
    className: "st22",
    d: "M616.1-789c0,0.3,0,0.5,0,0.8c0.1,0.6,0.3,1.1,0.7,1.5c0.9,0.9,2,1.2,2.4,0.7 s0-1.5-0.9-2.2c-0.4-0.4-0.9-0.6-1.4-0.7C616.7-788.9,616.4-789,616.1-789"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1022",
    className: "st22",
    d: "M614.2-785.9c0.1,0.5,0.4,0.9,0.9,1.2c0.6,0.3,1.3,0.3,1.5,0c0.2-0.3-0.2-0.8-0.9-1.2 C615.2-786,614.7-786.1,614.2-785.9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1023",
    className: "st22",
    d: "M645.3-783.4c-0.2-0.1-0.3-0.2-0.5-0.2c-0.4-0.1-0.8-0.1-1.2,0c-0.7,0.3-1.2,0.9-1,1.3 s0.9,0.4,1.6,0.1c0.3-0.1,0.6-0.4,0.8-0.7C645.1-783.1,645.2-783.2,645.3-783.4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1024",
    className: "st22",
    d: "M624.3-832.9c-0.2,0.3-0.3,0.6-0.4,0.9c-0.2,0.6-0.2,1.3,0,2c0.5,1.3,1.3,2,2,1.9 c0.7-0.1,0.9-1.5,0.3-2.8c-0.3-0.5-0.7-1-1.2-1.4C624.8-832.6,624.6-832.8,624.3-832.9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1025",
    className: "st22",
    d: "M628.8-832.1c-0.2,0.1-0.4,0.3-0.6,0.5c-0.3,0.4-0.6,0.8-0.6,1.3c-0.1,1,0.1,1.5,0.5,1.9 c0.2,0.2,0.6,0.1,0.9-0.3c0.3-0.4,0.5-0.9,0.6-1.4C629.5-830.8,629.3-831.5,628.8-832.1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1026",
    className: "st22",
    d: "M631.7-830c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0.1-0.7,0.4-0.9,0.7c-0.4,0.7-0.3,1.5,0,1.6 c0.4,0.2,0.9-0.3,1.2-1c0.2-0.3,0.2-0.6,0.2-1C631.8-829.6,631.8-829.8,631.7-830"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1027",
    className: "st22",
    d: "M637.5-821.5c-0.1-0.2-0.3-0.3-0.5-0.4c-0.4-0.2-1-0.2-1.4,0c-0.9,0.5-1.2,1-1.1,1.4 c0.1,0.5,1.1,0.5,1.8,0c0.3-0.2,0.6-0.4,0.8-0.7C637.3-821.3,637.5-821.5,637.5-821.5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1028",
    className: "st25",
    d: "M638.7-786.9c-0.6,0.4-1.1,1-1.4,1.7c-0.2,1,0,1.9,0.5,2.1c0.5,0.2,1.2-0.6,1.4-1.7 C639.3-785.5,639.1-786.3,638.7-786.9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1029",
    className: "st25",
    d: "M635.3-787.5c0,0-0.2,0.3-0.4,0.6c-0.3,0.4-0.4,0.8-0.5,1.2c-0.1,1.1,0.5,2.2,1,2 c0.3-0.1,0.5-0.3,0.6-0.6c0.2-0.4,0.3-0.8,0.3-1.2c0-0.5-0.1-1-0.4-1.5C635.7-787.2,635.5-787.4,635.3-787.5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1030",
    className: "st25",
    d: "M631.7-786c0,0,0,0.3,0,0.6c0,0.4,0.1,0.7,0.2,1.1c0.3,0.7,0.9,1.3,1.3,1.1 c0.4-0.2,0.5-0.9,0.1-1.8c-0.2-0.4-0.6-0.7-1-0.8C632.2-785.9,631.9-786,631.7-786"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1031",
    className: "st25",
    d: "M630.3-784.2c0,0.2,0,0.3,0,0.5c0,0.3,0.1,0.6,0.3,0.8c0.3,0.6,0.8,0.9,1.2,0.7 c0.3-0.2,0.3-0.8-0.1-1.5c-0.2-0.3-0.5-0.5-0.9-0.6C630.6-784.2,630.4-784.2,630.3-784.2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1032",
    className: "st25",
    d: "M630.8-809.2c-0.7,0.5-1.2,1.2-1.4,2c-0.2,1.2,0.2,2.2,0.8,2.3c0.6,0.1,1.2-0.8,1.4-2 C631.6-807.7,631.3-808.5,630.8-809.2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1033",
    className: "st25",
    d: "M627.3-808.5c-0.4,0.5-0.6,1-0.5,1.6c0.1,0.8,0.5,1.5,1,1.4s0.7-0.8,0.6-1.6 C628.2-807.7,627.8-808.2,627.3-808.5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1034",
    className: "st25",
    d: "M624.1-808.1c0,0,0.1,0.3,0.1,0.8c0,0.4,0.1,0.9,0.2,1.3c0.4,0.9,1.2,1.7,1.7,1.4 c0.5-0.3,0.7-1.1,0.2-2.3c-0.3-0.6-0.8-1-1.4-1.1C624.6-808.1,624.4-808.1,624.1-808.1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1035",
    className: "st25",
    d: "M622.2-805.9c0.2,0.3,0.4,0.6,0.6,0.9c0.4,0.3,0.9,0.4,1.1,0.2c0.2-0.2,0-0.7-0.5-1.1 C623-806.1,622.5-806.1,622.2-805.9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1036",
    className: "st25",
    d: "M631.6-827.5c-0.4,0.3-0.7,0.7-0.8,1.2c-0.1,0.6-0.2,1.1,0.1,1.4c0.3,0.2,0.9-0.2,1.1-1 c0.1-0.4,0-0.7-0.2-1.1C631.9-827.2,631.8-827.3,631.6-827.5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1037",
    className: "st25",
    d: "M628.6-828c-0.3,0.4-0.4,0.9-0.4,1.4c0.1,0.7,0.5,1.4,0.8,1.3c0.4-0.1,0.6-0.7,0.5-1.4 C629.5-827.3,629.1-827.8,628.6-828"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1038",
    className: "st23",
    d: "M645.8-773.4c-0.7-0.4-1.6-0.6-2.5-0.4c-1.1,0.3-1.9,1-1.8,1.7s1.2,0.8,2.5,0.4 C644.8-772,645.4-772.6,645.8-773.4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1039",
    className: "st23",
    d: "M643.1-768.9c-0.1-0.2-0.2-0.3-0.3-0.4c-0.3-0.3-0.7-0.5-1.1-0.5c-1,0.1-1.5,0.8-1.3,1.1 c0.4,0.3,0.9,0.4,1.4,0.3c0.3,0,0.6-0.2,0.8-0.3C642.9-768.8,643.1-768.9,643.1-768.9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1040",
    className: "st23",
    d: "M640.4-764.7c0-0.3-0.1-0.6-0.2-0.9c-0.2-0.6-0.6-1.2-1.2-1.5c-1.3-0.7-2.5-0.6-2.8,0 s0.5,1.5,1.6,2.1c0.5,0.3,1.1,0.4,1.7,0.3C639.8-764.6,640.1-764.7,640.4-764.7"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1041",
    className: "st23",
    d: "M621.7-761.7c0.5-0.4,0.9-0.9,1.1-1.6c0.1-0.9-0.3-1.7-0.7-1.7s-0.9,0.7-0.9,1.6 C621.1-762.8,621.3-762.2,621.7-761.7"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1042",
    className: "st23",
    d: "M608.1-805l0.3,1c0.2,0.6,0.4,1.2,0.8,1.6c0.9,1,2.1,1.6,2.7,1.1c0.6-0.5,0.4-1.8-0.7-3 c-0.5-0.5-1.3-0.9-2-0.9c-0.3,0-0.5,0-0.8,0.1C608.3-805.1,608.2-805,608.1-805"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1043",
    className: "st23",
    d: "M607.6-799.3c0.2,0.1,0.4,0.1,0.6,0.3c0.3,0.2,0.4,0.5,0.9,0.7c0.5,0.2,1,0.3,1.5,0.3 c0.5-0.1,0.8-0.3,0.8-0.6c-0.1-0.3-0.2-0.5-0.4-0.7c-0.3-0.3-0.6-0.6-1-0.7c-0.6-0.3-1.3-0.2-1.8,0.1 C607.9-799.8,607.7-799.6,607.6-799.3"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1044",
    className: "st23",
    d: "M608-794.3c0.3,0.1,0.5,0.2,0.8,0.2c0.5,0.1,1,0.2,1.5,0.1c1.1-0.3,2-1.1,1.8-1.6 s-1.2-0.8-2.3-0.5C608.9-795.8,608.3-795.1,608-794.3"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1045",
    className: "st23",
    d: "M618.4-803.8c-0.2,0.1-0.5,0.2-0.7,0.3c-0.4,0.2-0.8,0.5-1,0.8c-0.5,0.8-0.8,1.5-0.4,2 c0.3,0.4,1.3,0.1,2-0.9c0.3-0.4,0.4-0.9,0.3-1.5C618.5-803.4,618.5-803.6,618.4-803.8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1046",
    className: "st23",
    d: "M626.2-802.5c-0.2,0-0.5,0.1-0.7,0.2c-0.5,0.2-0.8,0.7-0.9,1.2c-0.2,1.2,0.3,2.1,0.8,2 c0.5-0.1,0.8-0.8,1-1.6c0.1-0.4,0.1-0.8,0-1.2C626.3-802.2,626.2-802.5,626.2-802.5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1047",
    className: "st23",
    d: "M632.5-803.5c-0.7,0.2-1.2,0.7-1.5,1.3c-0.3,1-0.1,1.9,0.4,2c0.5,0.1,1.1-0.6,1.3-1.4 c0.1-0.4,0.2-0.8,0.1-1.2C632.7-803.1,632.6-803.3,632.5-803.5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1048",
    className: "st23",
    d: "M636.9-799.1c-0.2-0.6-0.7-1-1.4-1.1c-0.9-0.1-1.6,0.2-1.6,0.6c0,0.4,0.7,0.8,1.4,0.9 C635.9-798.7,636.5-798.9,636.9-799.1"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1049",
    className: "st22",
    d: "M638.5-809.1c-0.3,0.1-0.5,0.2-0.7,0.3c-0.4,0.2-0.8,0.5-1.1,0.9 c-0.6,0.8-0.8,1.4-0.6,1.9c0.1,0.2,0.5,0.4,0.9,0.2c0.5-0.2,1-0.5,1.3-1c0.3-0.5,0.4-1,0.4-1.6 C638.7-808.6,638.6-808.9,638.5-809.1"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1050",
    className: "st28",
    d: "M701.1-787.7c-0.2-7.8,6.1-13.3,11.2-19c4-4.5,1.9-9,2.5-14.2c0.9-8.4,9-13.6,18.6-13.9 c9.1-0.3,19.3,3.8,21.6,11.8c1.9,6.6-0.2,13.4,2.3,20.1c2.8,7.1,9,13.4,10.5,20.9c1.3,6.5-3.6,11.3-9.5,14.8 c-9,5.4-19.6,8-29.7,2.9c-3.5-1.8-6-4.4-9.2-6.6c-3.5-2.5-7.7-4-11.5-6.1C703.9-779.4,701.2-783.4,701.1-787.7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1051",
    className: "st29",
    d: "M751.7-778.5c-3.5-1.7,3.5-13.9-5.2-13.9c-12.2-3.5-26.1,8.7-36.5-1.7 c-1.3-1.9-2.5-3.9-3.5-6c-3.1,3.7-5.5,7.6-5.3,12.5c0.1,4.3,2.8,8.2,6.9,10.6c3.8,2.1,8,3.6,11.5,6.1c3.1,2.2,5.6,4.8,9.2,6.6 c10,5.1,20.6,2.5,29.7-2.9c4.2-2.5,7.8-5.6,9.1-9.6C762.2-775.5,756.6-776.1,751.7-778.5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1052",
    className: "st26",
    d: "M731.3-717.9h4.1v-63.8c-1.3,0.7-2.7,1.2-4.1,1.6V-717.9z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1053",
    className: "st26",
    d: "M733.7-776.2c-0.1,0-0.2,0-0.3,0l0-1.5c5.1,0.3,9.7-2.7,11.5-7.5l1.4,0.6 C744.3-779.4,739.3-776,733.7-776.2"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1054",
    className: "st26",
    d: "M732.5-772.3c-5.4,0-9.6-1.5-12.4-4.4c-2.5-2.7-3.8-6.1-3.8-9.7l1.5,0 c0,3.2,1.3,6.3,3.4,8.6c2.5,2.6,6.3,3.9,11.3,3.9L732.5-772.3z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1055",
    className: "st26",
    d: "M733.4-757.6c5.4,0,9.6-1.5,12.4-4.4c2.5-2.7,3.8-6.1,3.8-9.7l-1.5,0 c0,3.2-1.3,6.3-3.4,8.6c-2.5,2.6-6.3,3.9-11.3,3.9L733.4-757.6z"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1697",
    x: 740.8,
    y: -784.9,
    className: "st26",
    width: 1.5,
    height: 5.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1698",
    x: 721.4,
    y: -785.7,
    className: "st26",
    width: 1.5,
    height: 9.8
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1056",
    className: "st28",
    d: "M747.4-836.5c0.1,0.5,0.2,1,0.2,1.5c0.1,0.9-0.1,1.9-0.5,2.7c-0.9,1.7-2,2.9-3.1,2.7 c-0.5-0.1-0.9-0.6-1-1.5c-0.1-1,0.1-2.1,0.6-3c0.5-0.9,1.3-1.6,2.3-2C746.4-836.3,746.9-836.4,747.4-836.5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1057",
    className: "st28",
    d: "M749.6-832.1c0.2,0.8,0.1,1.5-0.3,2.2c-0.6,0.9-1.5,1.4-2,1.1c-0.5-0.3-0.4-1.3,0.2-2.2 C748.1-831.6,748.8-832,749.6-832.1"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1058",
    className: "st28",
    d: "M737-837.2c0.8,0.5,1.4,1.4,1.6,2.3c0.3,1.3-0.1,2.4-0.7,2.6s-1.5-0.8-1.8-2.3 C736-835.5,736.3-836.5,737-837.2"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1059",
    className: "st28",
    d: "M732.2-838.1c0.9,0.2,1.6,0.8,2.1,1.6c0.6,1.1,0.6,2.3,0,2.7c-0.6,0.3-1.5-0.4-2.1-1.6 C731.9-836.2,731.9-837.2,732.2-838.1"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1060",
    className: "st28",
    d: "M711.6-818.4c1.3-0.5,2.7-0.6,4-0.1c1.7,0.6,2.9,1.9,2.7,2.9s-2,1.2-4.1,0.5 C712.9-815.9,712-817.1,711.6-818.4"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1061",
    className: "st28",
    d: "M712.7-822.6c0.2-0.1,0.4-0.2,0.7-0.3c0.5-0.2,1.1-0.1,1.5,0.1c1.1,0.6,1.5,1.6,1.1,2 c-0.4,0.4-1.2,0.2-2-0.3c-0.4-0.2-0.7-0.5-1-0.9C712.9-822.2,712.8-822.4,712.7-822.6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1062",
    className: "st28",
    d: "M708.5-806.9c0.3,0,0.7,0,1,0c0.7,0.1,1.4,0.5,1.9,1c1.1,1.3,1,3,0.3,3.2 c-0.8,0.2-1.6-0.5-2.4-1.5c-0.4-0.5-0.6-1.1-0.7-1.7C708.6-806.3,708.6-806.6,708.5-806.9"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1063",
    className: "st28",
    d: "M758.3-805.2c-0.1,1.2-0.6,2.2-1.4,3c-1.1,1.1-2.5,1.4-3.2,0.9c-0.6-0.6-0.1-2,1.2-3.2 C755.9-805.2,757.1-805.4,758.3-805.2"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1064",
    className: "st28",
    d: "M762.8-802.8c0,0.5,0,0.9-0.1,1.4c-0.1,0.9-0.5,1.8-1.2,2.5c-0.7,0.7-1.5,1.2-2.4,1.5 c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.4,0-0.6,0c-0.4-0.1-0.6-0.3-0.6-0.5c0-0.2,0.1-0.5,0.1-0.8c0-0.3,0-0.6,0.1-0.8 c0.3-0.8,0.8-1.4,1.4-2c0.7-0.6,1.5-1,2.5-1.2C761.9-802.8,762.4-802.9,762.8-802.8"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1065",
    className: "st28",
    d: "M764.4-798.3c-0.1,0.4-0.2,0.9-0.3,1.3c-0.2,0.8-0.6,1.5-1.2,2.1 c-1.2,1.2-2.4,1.8-3.3,1.4c-0.4-0.2-0.6-0.7-0.4-1.5c0.2-0.9,0.7-1.7,1.4-2.3c0.7-0.6,1.6-1,2.5-1 C763.5-798.4,763.9-798.4,764.4-798.3"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1066",
    className: "st29",
    d: "M739.1-796.6c0.3,0.3,0.6,0.7,0.8,1.1c0.5,0.8,0.7,1.8,0.6,2.7c-0.3,1.8-0.9,3.1-1.9,3.3 c-0.5,0.1-1-0.3-1.3-1c-0.4-0.9-0.5-1.9-0.4-2.8c0.2-0.9,0.6-1.7,1.2-2.4C738.4-796,738.8-796.4,739.1-796.6"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1067",
    className: "st29",
    d: "M742.9-797.1c0.3,0.3,0.5,0.6,0.6,1c0.4,0.7,0.4,1.6,0.2,2.4c-0.4,1.6-1.2,2.5-2.1,2.5 c-0.4,0-0.7-0.4-0.9-1c-0.2-0.8-0.2-1.6,0.1-2.3c0.2-0.7,0.6-1.3,1.2-1.8C742.2-796.6,742.5-796.8,742.9-797.1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1068",
    className: "st29",
    d: "M725.7-793.3c0.8,0.2,1.6,0.8,2,1.6c0.5,1.1,0.5,2.2-0.1,2.5s-1.4-0.4-2-1.6 c-0.2-0.5-0.3-1.1-0.2-1.6C725.6-792.8,725.6-793,725.7-793.3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1069",
    className: "st29",
    d: "M712.6-797.6c0.2,0.5,0.3,1,0.4,1.5c0.2,1,0.1,2-0.3,3c-0.9,1.9-2.1,3-3.2,2.9 c-0.5-0.1-0.9-0.7-1-1.5c-0.1-1,0.1-2.1,0.6-3c0.5-0.9,1.2-1.7,2.1-2.1C711.6-797.2,712.1-797.4,712.6-797.6"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1070",
    className: "st29",
    d: "M715.7-796.1c0.4,1.3,0.3,2.6-0.2,3.9c-0.9,1.6-2.4,2.6-3.2,2.2c-0.9-0.4-0.8-2.1,0.2-3.8 C713.2-795,714.4-795.8,715.7-796.1"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1071",
    className: "st29",
    d: "M698-781.7c0.2-0.5,0.5-0.9,0.8-1.4c0.6-0.9,1.5-1.5,2.5-1.9c1.1-0.3,2.2-0.3,3.3,0 c0.9,0.3,1.4,0.8,1.4,1.4c-0.1,0.7-0.5,1.2-1.1,1.6c-0.7,0.5-1.6,0.8-2.4,1.1c-1,0.3-2,0.2-3-0.1 C699-781.2,698.5-781.4,698-781.7"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1072",
    className: "st29",
    d: "M702-777.6c0-0.4,0.1-0.8,0.3-1.2c0.4-0.8,1.1-1.4,1.9-1.6c0.7-0.2,1.5-0.3,2.2-0.1 c0.5,0.1,0.9,0.3,1.1,0.7c0.2,0.3,0.1,0.9-0.5,1.3c-0.6,0.5-1.3,0.8-2,1c-0.6,0.1-1.3,0.1-2,0C702.5-777.6,702-777.6,702-777.6"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1073",
    className: "st29",
    d: "M711.6-771.6c0-0.3,0-0.7,0-1c0.1-0.7,0.4-1.3,0.9-1.8c1.1-0.9,2.3-1.2,2.8-0.7 s-0.1,1.8-1.1,2.6c-0.5,0.4-1,0.6-1.6,0.7C712.2-771.6,711.9-771.6,711.6-771.6"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1074",
    className: "st29",
    d: "M765.1-768.1c-0.4,0.1-0.9,0.1-1.3,0c-0.8-0.1-1.6-0.4-2.3-1c-1.3-1.3-1.7-2.1-1.6-3.1 c0.1-0.4,0.6-0.8,1.4-0.6c0.9,0.2,1.7,0.6,2.4,1.2c0.6,0.6,1,1.4,1.2,2.2C765-768.9,765-768.5,765.1-768.1"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1075",
    className: "st29",
    d: "M760.3-764.5c-0.8-0.1-1.7-0.5-2.3-1c-0.7-0.7-1.3-1.4-1.1-2.1c0.1-0.3,0.4-0.5,1-0.4 c0.7,0.1,1.3,0.4,1.8,0.9C760.2-766.5,760.5-765.5,760.3-764.5"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1076",
    className: "st30",
    d: "M722.4-818.7c0,0,0.6,0.2,1.2,0.5c0.7,0.3,1.3,0.7,1.9,1.2c1.1,1.2,1.7,2.6,1.1,3.3 c-0.5,0.7-2.3,0.4-3.6-1.1c-0.6-0.7-0.9-1.7-0.8-2.6C722.1-817.9,722.2-818.3,722.4-818.7"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1077",
    className: "st30",
    d: "M726.3-820.7c0.3,0.2,0.6,0.4,0.9,0.6c0.5,0.4,0.9,1,1.1,1.6c0.4,1.5,0.1,2.9-0.6,3 c-0.7,0.1-1.6-0.9-2-2.2c-0.2-0.7-0.1-1.4,0.2-2.1C726-820.1,726.1-820.4,726.3-820.7"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1078",
    className: "st30",
    d: "M729.8-823.8c0.9,0.8,1.6,1.9,1.7,3.1c0.1,1.7-0.5,3.2-1.4,3.2c-0.9,0-1.7-1.3-1.7-3.1 C728.4-821.8,728.9-822.9,729.8-823.8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1079",
    className: "st30",
    d: "M734.9-824.7c0.2,0.5,0.4,1,0.6,1.5c0.3,1,0.3,2,0.1,3c-0.2,0.8-0.6,1.6-1,2.3 c-0.3,0.5-0.8,0.9-1.4,1.1c-0.6,0.1-1.1-0.3-1.5-1.2c-0.4-1.1-0.4-2.2,0-3.3c0.3-1,1-1.9,1.9-2.6 C734-824.2,734.5-824.5,734.9-824.7"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1080",
    className: "st30",
    d: "M739.1-821.7c0.3,1,0.3,2,0,3c-0.6,1.3-1.4,2-2.2,1.9c-0.7-0.1-1-1.6-0.3-3.1 C737.3-820.7,738.1-821.4,739.1-821.7"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1081",
    className: "st30",
    d: "M742.5-819c0,0.2,0,0.4,0,0.6c0,0.4-0.1,0.7-0.2,1c-0.3,0.7-0.8,1.1-1.2,1 c-0.4,0-0.6-0.9-0.1-1.8c0.2-0.4,0.6-0.6,1-0.8C742.1-819,742.3-819,742.5-819"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1082",
    className: "st30",
    d: "M730.6-807.9c0.3,0.2,0.6,0.4,0.9,0.7c0.6,0.4,1,1,1.3,1.6c0.6,1.4,0.7,2.8,0,3.3 c-0.7,0.4-2-0.4-2.7-2.1c-0.3-0.8-0.3-1.6,0-2.4C730.2-807.2,730.4-807.6,730.6-807.9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1083",
    className: "st30",
    d: "M734.4-807.2c0.3,0.1,0.5,0.3,0.7,0.5c0.5,0.4,0.8,1,0.9,1.6c0.2,1.2-0.1,2.3-0.8,2.5 s-1.3-0.8-1.5-2.1c-0.1-0.5,0-1.1,0.2-1.6C734.1-806.7,734.2-807,734.4-807.2"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1084",
    className: "st30",
    d: "M741.6-811.3c-0.1-0.1-0.2-0.1-0.2,0c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.1,0.4 c0.1,0.3,0.2,0.7,0.4,1.2c0.3,1.1,0.4,2.3,0.1,3.4c-0.3,1-0.8,2-1.4,2.8c-0.4,0.6-1.1,0.9-1.8,1c-0.6,0.1-1.2-0.6-1.5-1.6 c-0.2-1.2-0.2-2.4,0.2-3.5c0.4-1.2,1.2-2.2,2.2-2.9c0.4-0.3,0.7-0.5,1.2-0.7c0.2-0.1,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1 C741.4-811.5,741.5-811.4,741.6-811.3"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1085",
    className: "st30",
    d: "M744.2-807.5c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.6,0.2,1.3,0,1.8c-0.2,0.7-0.7,1.2-1.3,1.6 c-0.2,0.2-0.5,0.2-0.8,0.2c-0.2,0-0.4-0.1-0.4-0.3c-0.2-0.8-0.1-1.7,0.3-2.5c0.2-0.6,0.6-1,1.2-1.4 C743.6-807.3,743.9-807.4,744.2-807.5"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1086",
    className: "st30",
    d: "M747-804.9c-0.1,0.5-0.4,1-0.8,1.4c-0.5,0.5-1.2,0.7-1.5,0.4s-0.1-1,0.6-1.6 c0.3-0.2,0.7-0.3,1.1-0.3C746.7-805,746.9-805,747-804.9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1087",
    className: "st30",
    d: "M728.4-802.9c0.1,0,0.3-0.1,0.5-0.1c0.3,0,0.6,0.1,0.9,0.3c0.6,0.5,0.6,1.3,0.3,1.4 c-0.3,0.1-0.7-0.2-1.1-0.5c-0.2-0.2-0.3-0.4-0.4-0.7C728.4-802.6,728.4-802.7,728.4-802.9"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1699",
    x: 645.6,
    y: -828.6,
    className: "st31",
    width: 85.8,
    height: 38.4
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1088",
    className: "st32",
    d: "M730.6-802.1l-42.3-28l-42.3,28h-0.2v0.1l-0.1,0.1h0.1v85.5H731v-85.7H730.6z"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1700",
    x: 645.6,
    y: -769.1,
    className: "st33",
    width: 85.5,
    height: 13.2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701",
    x: 645.7,
    y: -801,
    className: "st33",
    width: 3.5,
    height: 80.9
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702",
    x: 727.5,
    y: -800.4,
    className: "st33",
    width: 3.5,
    height: 80.9
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1089",
    className: "st34",
    d: "M688.2-827.7l-48.5,33.8l-3.8-2.2l52.4-36.4L688.2-827.7z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1090",
    className: "st34",
    d: "M688.2-827.7l48.5,33.8l3.8-2.2l-52.4-36.4L688.2-827.7z"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703",
    x: 671,
    y: -797.3,
    className: "st33",
    width: 34.6,
    height: 17.7
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1704",
    x: 673.4,
    y: -795.3,
    className: "st35",
    width: 30.6,
    height: 13.9
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1705",
    x: 674,
    y: -794.7,
    className: "st34",
    width: 29.4,
    height: 12.7
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1706",
    x: 675.7,
    y: -793.4,
    className: "st36",
    width: 25.4,
    height: 11.4
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1091",
    className: "st37",
    d: "M690.8-793.4l-8.7,11.4h-6.4v-6l4.1-5.4H690.8z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1092",
    className: "st37",
    d: "M689.5-782h-4.8l8.7-11.4h4.8L689.5-782z"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1707",
    x: 682,
    y: -793.8,
    className: "st34",
    width: 0.7,
    height: 11.8
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1708",
    x: 693.7,
    y: -793.8,
    className: "st34",
    width: 0.7,
    height: 11.8
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709",
    x: 672.6,
    y: -782.8,
    className: "st38",
    width: 32.1,
    height: 1.7
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1093",
    className: "st33",
    d: "M645.6-798.1l42.6-24.1l43,24.4l-43-29.9L645.6-798.1z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1094",
    className: "st39",
    d: "M684-809.5c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3 C685.9-813.7,684-811.8,684-809.5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1095",
    className: "st40",
    d: "M720.3-716.3c-0.2-2.9-0.2-8.2-2-10.7c-1.5-2.2-3-0.8-3.2,1.5c-1.1-2.8-2.4-5.2-5.2-2.3 c-0.4-1.9,0.3-4.1-0.2-6.2c-0.4-1.7-1.1-5.3-3.2-5.6c-0.8,1.7-0.2,4.2-1.9,5.4c0-0.2,0-0.4,0-0.7c-2.2-0.6-2.4,3-2.6,4.3 c-0.2-0.9-0.8-2.2-2-2c-1.2,0.2-1.7,2.2-2.3,3.1c-1-3.4-1.5-6.7-3.9-9.5c-1.1-1.3-1.5-1.7-3-0.8c-1.1,0.5-1.8,1.6-2,2.8 c1.6-1,0.3-5.6-0.2-7.1c-0.3-1-1.2-2.9-2.3-3.3c-1.4-0.5-0.8,0.3-1.8,0.9c-1.4,0.8-2.4-0.7-3.6,0.8c-1.5,1.9-1,5.3-0.2,7.3 c-0.8-1.5-2.4,1.9-2.7,2.6c-0.7,1.7-1,3.4-0.9,5.2c0.2-1.7-0.7-2.6-2.2-1.8c-1.3,0.7-1.9,3-1.8,4.5c-1-1.5-0.6-3.8-2.1-5.1 c-1.1-0.9-3.4-0.8-3.4,1.2c-1.7,0.1-1.9-4.9-3.3-6c-2-1.4-2.8,1.1-4,2.2c-0.1-1.5-0.5-2.9-1.3-4.1c-0.7-1-2.8-1.8-3.1-0.1 c-1.2-2-2.9-9.5-5.3-4.2c-0.5,1.3-0.8,2.7-1,4.1c-0.4,1.5,0.2,2.8,0,4.4c-0.9-0.5-2-0.3-2.7,0.5c-1.5,1.3-0.6,2.5-1.3,3.9 c-0.7,1.4-0.8,0.4-2,0.4c-1.8-0.1-2.2,1-3,2.4c-1.1,2-1.6,4.3-1.7,6.5c-0.2,1.9,0,3.6-0.5,5.4H720.3z"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710",
    x: 600.3,
    y: -801.8,
    className: "st41",
    width: 15.1,
    height: 26.3
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711",
    x: 599.6,
    y: -803.5,
    className: "st42",
    width: 16.5,
    height: 3.5
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1096",
    className: "st43",
    d: "M569.2-711.7h-51.2v-54.9l51.2-31.9L569.2-711.7z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1097",
    className: "st44",
    d: "M566.4-796.6l2.8-1.8v86.7h-2.8V-796.6z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1098",
    className: "st45",
    d: "M550.7-786.9l1-0.6v75.9h-1V-786.9z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1099",
    className: "st45",
    d: "M563.7-711.7h-1v-82.7l1-0.6V-711.7z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1100",
    className: "st45",
    d: "M544.8-783.2l1-0.6v72.1h-1V-783.2z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1101",
    className: "st45",
    d: "M556.7-790.6l1-0.6v79.6h-1V-790.6z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1102",
    className: "st45",
    d: "M520.9-768.3l1-0.6v57.3h-1V-768.3z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1103",
    className: "st45",
    d: "M526.9-772l1-0.6v61h-1V-772z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1104",
    className: "st45",
    d: "M532.8-775.7l1-0.6v64.7h-1V-775.7z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1105",
    className: "st45",
    d: "M538.8-779.4l1-0.6v68.4h-1V-779.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2884",
    transform: "translate(517.063 85.601)",
    className: "st46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2883",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1,
    y: -884,
    width: 51.2,
    height: 38.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061429679490017177120000012921009584199363255_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2882",
    style: {
      clipPath: "url(#SVGID_00000061429679490017177120000012921009584199363255_)"
    }
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1106",
    className: "st45",
    d: "M1-845.6v-5.8L52.2-884v5.8L1-845.6z"
  })))))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1107",
    className: "st44",
    d: "M563.7-782v26h-40v-6.5L563.7-782z"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713",
    x: 523.7,
    y: -752.6,
    className: "st44",
    width: 40,
    height: 31.6
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1714",
    x: 508.5,
    y: -786.2,
    transform: "matrix(0.8432 -0.5376 0.5376 0.8432 506.8684 170.0961)",
    className: "st45",
    width: 73,
    height: 4.9
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1108",
    className: "st48",
    d: "M563-756.2v-25.4l-38.8,20.2v5.2L563-756.2z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1109",
    className: "st36",
    d: "M562.1-757.1v-23l-37,19.2v3.8H562.1z"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715",
    x: 524.3,
    y: -752,
    className: "st48",
    width: 38.8,
    height: 29.9
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716",
    x: 525.1,
    y: -751.1,
    className: "st36",
    width: 37,
    height: 28.1
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1110",
    className: "st37",
    d: "M551.9-774.8l10.2,16.4v1.3h-13.3l-7.6-12.2L551.9-774.8z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1111",
    className: "st37",
    d: "M533.6-765.3l4.9-2.6l6.7,10.8h-6.5L533.6-765.3z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1112",
    className: "st37",
    d: "M547.8-751.1l14.4,23.1v5h-11l-17.5-28.1H547.8z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1113",
    className: "st37",
    d: "M525.1-748.6v-2.6h4.9l17.5,28.1H541L525.1-748.6z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1114",
    className: "st49",
    d: "M569.2-711.7h58.9v-54.9l-58.9-46V-711.7z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1115",
    className: "st45",
    d: "M590.1-711.7h-1v-84.7h0.9l0.1,0.1V-711.7z"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717",
    x: 577.1,
    y: -805.2,
    className: "st45",
    width: 1,
    height: 93.6
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1718",
    x: 571.1,
    y: -809.7,
    className: "st45",
    width: 1,
    height: 98
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1116",
    className: "st45",
    d: "M618.9-773.8l1,0.8v61.3h-1V-773.8z"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1719",
    x: 583.1,
    y: -800.8,
    className: "st45",
    width: 1,
    height: 89.2
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1117",
    className: "st45",
    d: "M601-787.5h0.3l0.7,0.6v75.3h-1L601-787.5z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1118",
    className: "st45",
    d: "M595-792h0.6l0.4,0.3v80h-1V-792z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1119",
    className: "st45",
    d: "M607-783.1l1,0.8v70.6h-1V-783.1z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1120",
    className: "st45",
    d: "M625.9-711.7h-1v-57.4l1,0.8V-711.7z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1121",
    className: "st45",
    d: "M612.9-778.4l1,0.8v66h-1V-778.4z"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720",
    x: 577.1,
    y: -753.6,
    className: "st44",
    width: 39.8,
    height: 39.4
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1122",
    className: "st44",
    d: "M616.9-763.9v8.9h-39.8v-39.1L616.9-763.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2887",
    transform: "translate(568.238 71.431)",
    className: "st50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2886",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116946467160420360380000001658688674935517830_",
    x: 1,
    y: -884,
    width: 58.9,
    height: 54.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067229055896764531400000009086569170590966946_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116946467160420360380000001658688674935517830_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2885",
    style: {
      clipPath: "url(#SVGID_00000067229055896764531400000009086569170590966946_)"
    }
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1123",
    className: "st43",
    d: "M1-876.4v-7.6l58.9,46.1v8.4L1-876.4z"
  })))))), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1722",
    x: 596.8,
    y: -829.8,
    transform: "matrix(0.623 -0.7822 0.7822 0.623 842.2877 171.5668)",
    className: "st45",
    width: 4.7,
    height: 83.6
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1124",
    className: "st48",
    d: "M616.2-756.6v-6.7l-38.5-28.9v35.6H616.2z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1125",
    className: "st36",
    d: "M578.6-757.5v-33l36.7,27.6v5.4H578.6z"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1723",
    x: 577.7,
    y: -752,
    className: "st48",
    width: 38.5,
    height: 36.6
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1724",
    x: 578.6,
    y: -751.1,
    className: "st36",
    width: 36.7,
    height: 34.8
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1126",
    className: "st37",
    d: "M578.6-774.4v-10.4l16.9,27.3H589L578.6-774.4z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1127",
    className: "st37",
    d: "M613.1-757.5h-14l-20.5-32.9l26.2,19.7L613.1-757.5z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1128",
    className: "st37",
    d: "M578.6-744.3v-6.8h3.1l17.3,34.8h-6.5L578.6-744.3z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1129",
    className: "st37",
    d: "M585.2-751.1h14l16.1,32.3v2.5h-12.8L585.2-751.1z"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1725",
    x: 591.8,
    y: -752.6,
    className: "st44",
    width: 1.1,
    height: 40.1
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1726",
    x: 516,
    y: -717.4,
    className: "st41",
    width: 114.6,
    height: 9.7
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1727",
    x: 516,
    y: -717.4,
    className: "st42",
    width: 114.6,
    height: 1.2
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1130",
    className: "st29",
    d: "M844.3-743.9c0.5-1.3,2.7-2.8,1.3-4.6c-1.1-1.4-2.5,0.2-3.2,1.1c0.4-0.9,0.1-1.9-0.8-2.4 c-0.2-0.1-0.4-0.2-0.6-0.2c-0.1-1.2,0.2-6.1-1.3-6.3c-1-0.2-2.1,3.9-3,4.6c-0.1-1.9,0.6-3.8,0.5-5.9c-0.1-2.3-0.2-4.5-1.3-6.5 c-2.1-3.8-5.1-2.2-4.7,2.2c-0.2-0.8-0.7-1.4-1.4-1.8c-1.2,1.7-1.2,4-1.7,6c-0.2-1.6-1.2-1.7-2.2-1c-1.5,1-0.7,2.5-1.4,3.7 c0.1-6.2-8.5-6.3-8.8,0.3c-1-3.9-5.6-2-4.4,2.2c-0.6-0.5-2.8-1.5-3.6-1.2c-1.1,0.5-1.7,1.9-1.1,3c0.1,0.3,0.4,0.6,0.6,0.8 c-1.5-0.1-2.9,0.6-3.7,1.9c-0.7,1.6,0.2,4.3,1.8,4L844.3-743.9z"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1728",
    x: 892.4,
    y: -823.7,
    className: "st52",
    width: 5.2,
    height: 12.6
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1729",
    x: 892.1,
    y: -824.1,
    className: "st53",
    width: 5.8,
    height: 1.6
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1730",
    x: 884,
    y: -821.3,
    className: "st52",
    width: 5.2,
    height: 12.6
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1731",
    x: 883.8,
    y: -821.8,
    className: "st53",
    width: 5.8,
    height: 1.6
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1732",
    x: 824.7,
    y: -795.2,
    className: "st52",
    width: 83.3,
    height: 49.3
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1733",
    x: 824.7,
    y: -795.2,
    className: "st53",
    width: 83.3,
    height: 7.6
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1734",
    x: 823.8,
    y: -756.6,
    className: "st54",
    width: 84.9,
    height: 10.7
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1735",
    x: 893.9,
    y: -783.2,
    className: "st53",
    width: 5.6,
    height: 19.1
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1736",
    x: 894.4,
    y: -780.7,
    className: "st18",
    width: 5,
    height: 13.8
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1737",
    x: 879.9,
    y: -783.2,
    className: "st53",
    width: 5.6,
    height: 19.1
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1738",
    x: 880.5,
    y: -780.7,
    className: "st18",
    width: 5,
    height: 13.8
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1739",
    x: 849,
    y: -783.2,
    className: "st53",
    width: 5.6,
    height: 19.1
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1740",
    x: 849.6,
    y: -780.7,
    className: "st18",
    width: 5,
    height: 13.8
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1741",
    x: 835,
    y: -783.2,
    className: "st53",
    width: 5.6,
    height: 19.1
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742",
    x: 835.6,
    y: -780.7,
    className: "st18",
    width: 5,
    height: 13.8
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1743",
    x: 823.8,
    y: -813.1,
    className: "st54",
    width: 87.3,
    height: 20.5
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1744",
    x: 823.8,
    y: -797.3,
    className: "st55",
    width: 87.3,
    height: 4.7
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1745",
    x: 859.8,
    y: -781.6,
    className: "st56",
    width: 15.4,
    height: 29.3
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1746",
    x: 860.8,
    y: -779.9,
    className: "st57",
    width: 13.3,
    height: 26.8
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1747",
    x: 858.3,
    y: -755,
    className: "st38",
    width: 18.4,
    height: 3.1
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1748",
    x: 856.8,
    y: -752,
    className: "st38",
    width: 21.3,
    height: 3.1
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1749",
    x: 855.6,
    y: -748.9,
    className: "st38",
    width: 23.7,
    height: 3.1
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1750",
    x: 861.9,
    y: -778.5,
    className: "st58",
    width: 11,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2890",
    transform: "translate(823.666 103.024)",
    className: "st46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2889"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132082166570052603480000000438781674781150857_",
    x: 1,
    y: -884,
    width: 53.7,
    height: 4.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147940221908716002740000014415554681332532900_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132082166570052603480000000438781674781150857_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2888",
    style: {
      clipPath: "url(#SVGID_00000147940221908716002740000014415554681332532900_)"
    }
  }, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1751",
    x: 1,
    y: -884,
    className: "st55",
    width: 53.7,
    height: 4.2
  })))))), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1753",
    x: 824.7,
    y: -782.1,
    className: "st38",
    width: 3.4,
    height: 36.2
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1754",
    x: 843.3,
    y: -782,
    className: "st38",
    width: 3.4,
    height: 36.2
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1755",
    x: 874.9,
    y: -782,
    className: "st38",
    width: 3.4,
    height: 36.2
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1756",
    x: 823.8,
    y: -789.7,
    className: "st54",
    width: 54.6,
    height: 8.7
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1757",
    x: 823.8,
    y: -783.6,
    className: "st55",
    width: 54.6,
    height: 2.6
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1758",
    x: 893.9,
    y: -767.3,
    className: "st38",
    width: 5.6,
    height: 3.1
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1759",
    x: 879.9,
    y: -767.2,
    className: "st38",
    width: 5.6,
    height: 3.1
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1760",
    x: 849,
    y: -767.2,
    className: "st38",
    width: 5.6,
    height: 3.1
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1761",
    x: 835,
    y: -767.2,
    className: "st38",
    width: 5.6,
    height: 3.1
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1131",
    className: "st21",
    d: "M814-743.3c6.4-2.9,27-5,51.5-5s45.1,2.1,51.5,5H814z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1132",
    className: "st29",
    d: "M884.9-743.5c-0.5-0.8-2.5-1.8-1.2-3c1-0.9,2.3,0.1,3,0.7c-0.6-0.9,0.3-1.5,1.3-1.7 c0.1-0.8-0.2-3.9,1.2-4.1c1-0.1,1.9,2.5,2.7,3c0.1-1.2-0.5-2.5-0.5-3.8c-0.1-1.5,0.3-3,1.2-4.2c1.9-2.5,4.7-1.5,4.4,1.4 c0.2-0.6,0.7-1,1.3-1.2c1.1,1.1,1.1,2.6,1.5,3.9c0.2-1,1.1-1.1,2.1-0.7c1.3,0.6,0.7,1.6,1.3,2.4c-0.1-4,7.9-4.1,8.1,0.2 c0.9-2.5,5.1-1.3,4.1,1.4c1-0.5,2.2-0.8,3.3-0.8c0.7,0.1,1.3,0.7,1.2,1.4c0,0.5-0.3,0.9-0.8,1.1c0.9-0.2,2.9,0.4,3.4,1.2 c0.5,0.9,0.1,1.9-0.7,2.4c-0.3,0.2-0.6,0.2-0.9,0.2L884.9-743.5z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1133",
    className: "st60",
    d: "M1100.4-796.1c-2.9-6,1.5-16,7-20.4c3.1-2.5,6-3.7,7.2-7.5c1.1-3.2-6.2-5.2-7.9-7.4 c-3.5-4.5,6.9-8.3,12.4-9.4c-4.6-7.8-4.5-20.8-0.3-27.9c4.9-8.2,30.9-24.8,34.6,7.2c0.8,7.1,7,9.5,13.4,10.9 c6.7,1.5,19.4,3.2,20,11.6c0.7,8.7-11.4,12.2-16.8,17.1c-5.8,5.4,8,8.7,11.6,10.4c7,3.3,11.7,8.3,6.7,15.3 c-10.4,14.8-31.8,5.3-47.1,7.7C1130.9-786.7,1110.8-774.4,1100.4-796.1"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1134",
    className: "st61",
    d: "M1177.4-826.8c-14.9-2.8-31.5,5.6-45.4,13.5c-3.2,1.8-11.7,3.1-11.7,1.6 c-3.3-9.4,20-7.8,8.3-15.7c-6.2-3.5-15.3-5.3-18-10.5c-3.5,1.7-6.1,4.1-4.1,6.6c1.7,2.2,9,4.1,7.9,7.4c-1.3,3.8-4.1,5-7.2,7.5 c-5.5,4.4-9.8,14.4-7,20.4c10.4,21.7,30.5,9.4,40.8,7.8c15.4-2.4,36.8,7.1,47.1-7.7c5-7.1,0.3-12.1-6.7-15.3 c-3.6-1.7-17.4-5.1-11.6-10.4C1172.3-823.7,1174.8-825.4,1177.4-826.8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1135",
    className: "st26",
    d: "M1136.4-720.7h5.2v-90.9c-1.7,0.9-3.4,1.7-5.2,2.3V-720.7z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1136",
    className: "st26",
    d: "M1139.5-803.7c-0.2,0-0.3,0-0.5,0l0.1-2.2c3.6,0.1,12.5-0.7,16.3-10.7l2,0.8 C1153.2-804.8,1143.2-803.7,1139.5-803.7"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1137",
    className: "st26",
    d: "M1139.1-787.8l0-2.2c29.9-0.2,33.3-20.1,33.3-20.3l2.2,0.3 C1174.5-809.7,1170.8-788,1139.1-787.8"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1138",
    className: "st26",
    d: "M1168.8-800.5c-5.8-4.7-4-10.1-3.9-10.4l2.1,0.7l-1-0.4l1,0.4c-0.1,0.2-1.3,4.3,3.2,7.9 L1168.8-800.5z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1139",
    className: "st26",
    d: "M1139.9-768.7c-7.7,0-13.6-2.1-17.7-6.3c-3.5-3.8-5.4-8.7-5.5-13.9l2.2,0.1 c0.1,4.6,1.8,8.9,4.9,12.3c3.6,3.7,9,5.6,16.1,5.6L1139.9-768.7z"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1762",
    x: 1149.6,
    y: -816.2,
    className: "st26",
    width: 2.2,
    height: 7.8
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    x: 1124.1,
    y: -787.7,
    className: "st26",
    width: 2.2,
    height: 14
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1140",
    className: "st60",
    d: "M1133-884.4c1.4,0.4,2.5,1.4,3.1,2.6c0.4,0.9,0.4,1.9,0.3,2.9c-0.2,0.8-0.6,1.3-1.1,1.3 c-0.6-0.1-1.1-0.4-1.4-0.8c-0.5-0.6-0.9-1.3-1.1-2C1132.4-881.8,1132.5-883.2,1133-884.4"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1141",
    className: "st60",
    d: "M1138-883.9c0.8,0.7,1.4,1.6,1.5,2.7c0.1,1.5-0.5,2.8-1.2,2.8c-0.8,0-1.4-1.2-1.5-2.7 C1136.8-882.1,1137.2-883.1,1138-883.9"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1142",
    className: "st60",
    d: "M1119.6-874.8c0.4,0,0.7,0,1.1,0c0.7,0.1,1.4,0.3,1.9,0.8c0.3,0.3,0.5,0.6,0.8,0.9 c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.3,0.1,0.5c0.1,0.7,0,1.1-0.4,1.2c-0.4,0.1-0.9,0-1.2-0.2c-0.5-0.3-1-0.6-1.4-1 c-0.5-0.5-0.8-1.1-1-1.8C1119.7-874.1,1119.6-874.4,1119.6-874.8"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1143",
    className: "st60",
    d: "M1111.1-850.8c0.2-0.5,0.5-1,1-1.3c0.9-0.8,2.2-1.2,3.4-1c1,0.2,2,0.5,2.8,1.1 c0.6,0.3,0.9,0.9,1,1.6c0,0.6-0.5,1.1-1.4,1.4c-1,0.2-2,0.3-3.1,0.1c-0.9-0.2-1.7-0.6-2.4-1.1 C1111.7-850.5,1111.1-850.8,1111.1-850.8"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1144",
    className: "st60",
    d: "M1113.8-857.9c0.3-0.2,0.7-0.3,1-0.3c0.8-0.1,1.6,0.1,2.2,0.5c1.4,1,1.9,2.7,1.2,3.1 c-0.7,0.4-1.8,0-2.9-0.8c-0.5-0.4-0.9-0.9-1.1-1.5C1113.9-857.4,1113.8-857.9,1113.8-857.9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1145",
    className: "st60",
    d: "M1161.6-856.3c0.4,0.3,0.8,0.6,1.1,0.9c0.7,0.6,1.2,1.4,1.5,2.4c0.5,2.1-0.2,4.2-1.2,4.1 c-0.6-0.1-1.2-0.4-1.5-1c-0.5-0.7-0.8-1.5-1-2.4c-0.2-1-0.1-2,0.4-2.8C1161.1-855.4,1161.3-855.9,1161.6-856.3"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1146",
    className: "st60",
    d: "M1166.2-854.7c0.8,0.8,1.2,1.9,1.3,3.1c0,1.5-0.7,2.8-1.6,2.8s-1.5-1.3-1.4-3.1 C1164.6-853,1165.3-854,1166.2-854.7"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1147",
    className: "st60",
    d: "M1181.9-849c0,0.4-0.1,0.8-0.2,1.1c-0.2,0.7-0.6,1.4-1.1,1.9c-1.2,1-2.3,1.4-3,0.9 c-0.7-0.4-0.2-2.1,1.1-3.2C1179.6-848.9,1180.8-849.1,1181.9-849"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1148",
    className: "st60",
    d: "M1184.7-847c0,0.7-0.3,1.5-0.8,2c-0.8,0.7-1.8,0.9-2.2,0.5c-0.4-0.4,0-1.3,0.9-2 C1183.1-846.9,1183.9-847,1184.7-847"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1149",
    className: "st60",
    d: "M1182.4-813.1c0.2,0.3,0.3,0.6,0.4,0.9c0.2,0.6,0.2,1.3,0,2c-0.5,1.2-1.1,2.1-1.8,2.1 c-0.4,0-0.6-0.3-0.8-0.9c-0.2-0.7-0.1-1.4,0.2-2.1c0.3-0.6,0.7-1.2,1.3-1.5C1181.8-812.8,1182.1-812.9,1182.4-813.1"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1150",
    className: "st60",
    d: "M1185.8-811.7c0.1,0.3,0.2,0.6,0.2,0.9c0.1,0.6,0,1.2-0.1,1.8c-0.5,1.2-1.3,2.1-2,1.9 c-0.7-0.2-0.9-1.5-0.4-2.8c0.3-0.6,0.8-1.1,1.4-1.4C1185.2-811.5,1185.5-811.6,1185.8-811.7"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1151",
    className: "st60",
    d: "M1097.6-813.4c0.5-0.1,1.1-0.1,1.7-0.1c1.1,0,2.1,0.4,3,1c1.8,1.3,2.7,2.7,2.4,3.8 c-0.2,0.6-0.8,0.9-1.8,0.9c-1.1-0.1-2.2-0.5-3.1-1.2c-0.9-0.7-1.5-1.7-1.8-2.8C1097.8-812.3,1097.7-812.9,1097.6-813.4"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1152",
    className: "st60",
    d: "M1096.3-805.6c0.4-0.2,0.8-0.3,1.2-0.4c0.7-0.2,1.5-0.3,2.3-0.1c1.7,0.5,3,1.8,2.6,2.5 c-0.3,0.4-0.8,0.7-1.3,0.7c-0.7,0.1-1.5,0-2.2-0.2c-0.8-0.3-1.5-0.8-2-1.5C1096.6-804.9,1096.5-805.2,1096.3-805.6"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1153",
    className: "st60",
    d: "M1112.6-809.9c0.3-0.3,0.7-0.5,1.1-0.7c0.8-0.4,1.7-0.6,2.5-0.4c0.9,0.2,1.8,0.7,2.4,1.4 c0.5,0.6,0.6,1.3,0.2,1.6c-0.4,0.3-0.9,0.4-1.4,0.4c-0.7,0-1.3,0-2-0.2c-0.8-0.2-1.5-0.6-2-1.2 C1113.1-809.3,1112.9-809.6,1112.6-809.9"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1154",
    className: "st60",
    d: "M1111.8-803.5c0.3-0.2,0.6-0.4,0.9-0.6c0.6-0.3,1.2-0.5,1.9-0.5c1.4,0,2.5,0.6,2.6,1.4 c0.1,0.7-1.2,1.3-2.7,1.3c-0.7-0.1-1.4-0.4-1.9-0.9C1112.3-803,1112-803.2,1111.8-803.5"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1155",
    className: "st60",
    d: "M1187.6-792c-0.4,0.1-0.9,0.1-1.3,0.2c-0.8,0.1-1.6,0-2.3-0.3c-1.6-0.7-2.8-1.9-2.4-2.8 c0.3-0.9,2-1.1,3.8-0.3c0.8,0.4,1.5,1.1,1.9,1.9C1187.4-792.8,1187.5-792.4,1187.6-792"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1156",
    className: "st60",
    d: "M1184-787.6c-0.8,0-1.6-0.3-2.3-0.7c-0.8-0.7-1.3-1.4-1.1-2c0.2-0.6,1.5-0.7,2.6,0.3 C1183.8-789.4,1184.1-788.5,1184-787.6"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1157",
    className: "st60",
    d: "M1106.3-782.8c-0.2-1.2,0-2.4,0.6-3.4c0.9-1.3,2-2.1,2.8-1.8c0.8,0.3,0.9,2.1-0.2,3.6 C1108.7-783.4,1107.5-782.8,1106.3-782.8"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1158",
    className: "st62",
    d: "M1169.7-840.2c0,0.5,0,1-0.1,1.5c-0.1,0.9-0.5,1.8-1.1,2.4c-1.1,1.6-2.8,2.4-3.7,1.8 c-0.9-0.6-0.6-2.4,0.8-4.2c0.7-0.7,1.6-1.2,2.6-1.4C1168.8-840.2,1169.2-840.2,1169.7-840.2"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1159",
    className: "st62",
    d: "M1163.6-842.2c0.3,0.3,0.6,0.6,0.8,1c0.5,0.7,0.6,1.6,0.5,2.5c-0.1,0.7-0.3,1.4-0.7,2 c-0.2,0.5-0.6,0.8-1.1,0.9c-0.5,0.1-0.9-0.2-1.2-0.9c-0.3-0.8-0.4-1.7-0.3-2.6c0.2-0.8,0.5-1.5,1.1-2.1 C1163-841.6,1163.3-841.9,1163.6-842.2"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1160",
    className: "st62",
    d: "M1157.7-842.4c0,0.1,1.7,1,2.1,2.5c0.5,1.5,0.3,3.1-0.7,3.5c-0.1-0.1-0.1-0.2-0.2-0.2 c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.5-0.5-0.8-1.2-1-1.9C1156.7-840.2,1157-841.4,1157.7-842.4"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1161",
    className: "st62",
    d: "M1154.2-836c0.2-0.2,0.3-0.3,0.6-0.4c0.5-0.2,1.1-0.2,1.5,0c1.1,0.6,1.3,1.8,0.9,2 c-0.5,0.2-1.1-0.1-1.8-0.4c-0.3-0.1-0.6-0.5-0.8-0.7C1154.4-835.8,1154.2-836,1154.2-836"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1162",
    className: "st62",
    d: "M1127-863c0.4,0,0.9,0.1,1.3,0.3c0.8,0.3,1.5,0.9,2,1.6c0.4,0.6,0.7,1.2,0.9,1.9 c0.2,0.5,0.1,1-0.1,1.5c-0.2,0.4-0.8,0.6-1.6,0.3c-0.9-0.4-1.6-1-2.1-1.8c-0.5-0.7-0.7-1.6-0.6-2.5 C1126.9-862.2,1126.9-862.6,1127-863"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1163",
    className: "st62",
    d: "M1131.7-865.4c1,0.5,1.8,1.4,2.1,2.5c0.4,1.6,0.1,3-0.7,3.2s-1.7-0.9-2.1-2.5 C1130.8-863.4,1131.1-864.5,1131.7-865.4"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1164",
    className: "st62",
    d: "M1137.8-865.9c0.2,0.3,0.4,0.6,0.6,1c0.3,0.7,0.4,1.5,0.3,2.3c-0.4,1.6-1.1,2.6-2,2.6 c-0.8,0-1.4-1.6-1-3.3c0.2-0.7,0.6-1.4,1.2-1.9C1137.1-865.4,1137.4-865.7,1137.8-865.9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1165",
    className: "st62",
    d: "M1142.3-862.4c0.1,0.9-0.1,1.8-0.6,2.6c-0.7,1.1-1.8,1.6-2.4,1.3s-0.4-1.6,0.4-2.7 C1140.5-862,1141.4-862.4,1142.3-862.4"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1166",
    className: "st62",
    d: "M1125-855.8c0.5-0.4,1-0.6,1.6-0.6c0.8,0,1.5,0.4,1.5,0.8c0,0.4-0.7,0.8-1.6,0.7 C1125.9-854.9,1125.3-855.3,1125-855.8"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1167",
    className: "st62",
    d: "M1128.4-836.6c0.3,0,0.6,0,0.9,0c0.6,0,1.2,0.2,1.7,0.5c0.5,0.3,0.9,0.8,1.2,1.3 c0.1,0.2,0.2,0.4,0.2,0.6v0.1c0.1,0.1-0.2,0-0.2,0.1c-0.1,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0-0.1,0.1-0.2,0.1 c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.4,0.1-0.7,0c-0.6-0.1-1.1-0.3-1.6-0.7c-0.5-0.4-0.9-0.9-1-1.5 C1128.5-836,1128.4-836.3,1128.4-836.6"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1168",
    className: "st62",
    d: "M1132.4-841.5c0.5,0.2,1,0.4,1.4,0.6c0.9,0.5,1.6,1.2,2.1,2.2c1,2.1,0.5,4.4-0.6,4.5 c-0.6,0-1.3-0.2-1.7-0.8c-0.6-0.7-1.1-1.4-1.4-2.2C1131.9-838.6,1131.9-840.1,1132.4-841.5"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1169",
    className: "st62",
    d: "M1138.7-841.6c0.3,0.3,0.5,0.7,0.7,1c0.5,0.7,0.7,1.5,0.8,2.3c0,0.9-0.2,1.7-0.6,2.4 c-0.2,0.3-0.4,0.5-0.7,0.7c-0.2,0.1-0.5,0.2-0.7,0.1c-0.8-0.4-1.3-1.5-1.3-3.3c0-0.9,0.3-1.7,0.9-2.3 C1138.1-841.1,1138.4-841.4,1138.7-841.6"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1170",
    className: "st62",
    d: "M1143.1-837.7c0.2,0.6,0.1,1.3-0.2,1.9c-0.5,0.9-1.3,1.4-1.7,1.1c-0.4-0.3-0.4-1.2,0.1-2 C1141.8-837.2,1142.4-837.6,1143.1-837.7"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1171",
    className: "st62",
    d: "M1145.9-834.8c0,0.4-0.1,0.8-0.3,1.1c-0.5,0.4-1,0.6-1.2,0.3c-0.2-0.2,0-0.7,0.4-1.1 C1145.1-834.6,1145.5-834.8,1145.9-834.8"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1172",
    className: "st60",
    d: "M1120.1-821.3c0.5,0,1,0,1.5,0.1c0.9,0.1,1.8,0.4,2.6,0.9c1.6,1.2,2.6,2.9,1.9,3.8 c-0.6,0.9-2.5,0.6-4.3-0.7c-0.8-0.7-1.4-1.6-1.5-2.6C1120.2-820.3,1120.1-820.8,1120.1-821.3"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1173",
    className: "st60",
    d: "M1125.2-823.1c0.3,0.1,0.7,0.3,1,0.5c0.6,0.3,1.1,0.8,1.4,1.4c0.7,1.2,0.8,2.6,0.2,3 c-0.6,0.5-1.8-0.3-2.7-1.7c-0.3-0.7-0.4-1.5-0.2-2.2C1125-822.5,1125.1-822.8,1125.2-823.1"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1174",
    className: "st61",
    d: "M1157.7-828c0.2,0.4,0.3,0.9,0.4,1.4c0.2,0.9,0.1,1.9-0.2,2.8c-0.3,0.8-0.7,1.5-1.2,2.1 c-0.3,0.5-0.9,0.8-1.5,0.8c-0.5,0-1-0.5-1.2-1.3c-0.2-1-0.1-2.1,0.3-3c0.4-0.9,1.1-1.7,2-2.2 C1156.8-827.6,1157.3-827.8,1157.7-828"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1175",
    className: "st61",
    d: "M1162.8-829c0.2,0.5,0.3,1,0.3,1.5c0.1,1,0,1.9-0.5,2.8c-0.4,0.8-0.9,1.4-1.5,2 c-0.2,0.2-0.4,0.3-0.7,0.3c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0.1-0.6,0-0.9-0.2c-0.3-0.3-0.4-0.8-0.4-1.2c0-1,0.2-2,0.7-2.9 c0.5-0.9,1.3-1.5,2.2-1.9C1161.9-828.7,1162.3-828.8,1162.8-829"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1176",
    className: "st29",
    d: "M1171.9-708.5c1.3-0.7,2.1-3.3,1.4-5.1c-0.8-2.4-1.7-1.1-2.9-0.1 c0.8-4.4,0.8-11.9-1.4-15.4c-1.9-3-5.6,0.5-6.9,3.5c-1-2-1.5-4.4-3.5-4.1c-1.3,0.2-2,2-3.2,2.5c0.8-4.4-1-12.2-4.1-13.7 c-3.7-1.8-5.1,4.4-5.1,8.5c-1.3-6.9-4.7-0.8-6.1,2.2c-0.8-1.1-1.2-3.1-2.7-2.5c-0.9,0.4-1.7,2.4-1.8,3.7 c-0.5-4.8-4.7-11.8-8.3-10.3c-3.4,1.5-3.4,6.8-3.4,11.1c-1-3-4.4-2.5-5.7-0.4c-1.2,2-1.1,6.7,0,8.9c-1.7-2.2-3.4-6.6-6.1-4.8 c-3.4,2.3-0.9,7.6-0.2,11.2c-0.4-2.2-5.4-1.8-5.7,0.8c-0.2,2.2,2.6,3.9,3.9,4.1L1171.9-708.5z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1177",
    className: "st29",
    d: "M1347-709c1.3-0.7,2.1-3.3,1.4-5.1c-0.8-2.4-1.7-1.1-2.9-0.1c0.8-4.4,0.8-11.9-1.4-15.4 c-1.9-3-5.6,0.5-6.9,3.5c-1-2-1.5-4.4-3.5-4.1c-1.3,0.2-2,2-3.2,2.5c0.8-4.4-1-12.2-4.1-13.7c-3.7-1.8-5.1,4.4-5.1,8.5 c-1.3-6.9-4.7-0.8-6.1,2.2c-0.8-1.1-1.2-3.1-2.7-2.5c-0.9,0.4-1.7,2.4-1.8,3.7c-0.5-4.8-4.7-11.8-8.3-10.3 c-3.4,1.5-3.4,6.8-3.4,11.1c-1-3-4.4-2.5-5.7-0.4c-1.2,2-1.1,6.7,0,8.9c-1.7-2.2-3.4-6.6-6.1-4.8c-3.4,2.3-0.9,7.6-0.2,11.2 c-0.4-2.2-5.4-1.8-5.6,0.8c-0.2,2.2,2.6,3.9,3.9,4.1L1347-709z"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    x: 1257.2,
    y: -771.7,
    className: "st63",
    width: 57.9,
    height: 63.3
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1765",
    x: 1257.2,
    y: -771.7,
    className: "st64",
    width: 57.9,
    height: 13.1
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1178",
    className: "st64",
    d: "M1305.3-708.5l1.2-45.6h-41.4v45.6H1305.3z"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1766",
    x: 1267.8,
    y: -751.2,
    className: "st42",
    width: 35,
    height: 42.8
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1767",
    x: 1153.5,
    y: -821.5,
    className: "st65",
    width: 103.7,
    height: 113.1
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1768",
    x: 1179.6,
    y: -772.6,
    className: "st33",
    width: 52.8,
    height: 64.2
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1769",
    x: 1179.6,
    y: -772.6,
    className: "st66",
    width: 52.8,
    height: 21.4
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1770",
    x: 1153.5,
    y: -821.5,
    className: "st66",
    width: 103.7,
    height: 8.9
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1179",
    className: "st41",
    d: "M1150.4-816.8h110l-4-31.7h-102L1150.4-816.8z"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1771",
    x: 1148.7,
    y: -819,
    className: "st42",
    width: 113.3,
    height: 3.4
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1180",
    className: "st32",
    d: "M1177-816.8l28.4-31.5l28.3,31.5h0.1v0.2l0.1,0.1c-0.1,0-0.1,48.1-0.1,48.1h-57.2v-48.3 H1177z"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1772",
    x: 1176.7,
    y: -816,
    className: "st19",
    width: 57.1,
    height: 5.4
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1773",
    x: 1227.8,
    y: -755.8,
    className: "st19",
    width: 6,
    height: 44.6
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1774",
    x: 1224.8,
    y: -724.1,
    className: "st38",
    width: 11.8,
    height: 15.6
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1775",
    x: 1176.6,
    y: -755.8,
    className: "st19",
    width: 6,
    height: 44.6
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1776",
    x: 1227.8,
    y: -755.8,
    className: "st38",
    width: 6,
    height: 5.1
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1777",
    x: 1176.6,
    y: -755.8,
    className: "st38",
    width: 6,
    height: 5.1
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1778",
    x: 1173.6,
    y: -724.1,
    className: "st38",
    width: 11.8,
    height: 15.6
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1181",
    className: "st41",
    d: "M1257.2-760.1h61.7l-4.1-28.1h-57.6V-760.1z"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1779",
    x: 1257.2,
    y: -790.1,
    className: "st42",
    width: 57.9,
    height: 4.3
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1780",
    x: 1257.2,
    y: -763.3,
    className: "st42",
    width: 62.7,
    height: 3.2
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1781",
    x: 1268.8,
    y: -750.1,
    className: "st41",
    width: 32.9,
    height: 41.6
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1182",
    className: "st41",
    d: "M1174.7-755.8h61l-2-18.3h-57L1174.7-755.8z"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1782",
    x: 1235.4,
    y: -859.4,
    className: "st42",
    width: 10.3,
    height: 24.9
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1783",
    x: 1235.4,
    y: -853.2,
    className: "st67",
    width: 10.3,
    height: 18.8
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1784",
    x: 1234.9,
    y: -860.3,
    className: "st41",
    width: 11.5,
    height: 3.2
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1785",
    x: 1268.8,
    y: -726.6,
    className: "st42",
    width: 32.9,
    height: 1.2
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1786",
    x: 1268.8,
    y: -720.1,
    className: "st42",
    width: 32.9,
    height: 1.2
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1787",
    x: 1268.8,
    y: -713.6,
    className: "st42",
    width: 32.9,
    height: 1.2
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1788",
    x: 1268.8,
    y: -746.1,
    className: "st42",
    width: 32.9,
    height: 1.2
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1789",
    x: 1268.8,
    y: -733.1,
    className: "st42",
    width: 32.9,
    height: 1.2
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1790",
    x: 1268.8,
    y: -739.6,
    className: "st42",
    width: 32.9,
    height: 1.2
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1791",
    x: 1237.4,
    y: -807,
    className: "st66",
    width: 14.7,
    height: 22.8
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1792",
    x: 1238.5,
    y: -805,
    className: "st41",
    width: 12.3,
    height: 20.7
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1793",
    x: 1239.5,
    y: -803.8,
    className: "st36",
    width: 10.4,
    height: 17.9
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1183",
    className: "st37",
    d: "M1249.9-793.2l-10.4-6.1v-4.5h5.4l4.9,2.9V-793.2z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1184",
    className: "st37",
    d: "M1239.5-794v-3.4l10.4,6.1v3.4L1239.5-794z"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1794",
    x: 1239.5,
    y: -799.1,
    className: "st41",
    width: 10.8,
    height: 0.6
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1795",
    x: 1237.4,
    y: -749.2,
    className: "st66",
    width: 14.7,
    height: 22.8
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1796",
    x: 1238.5,
    y: -747.2,
    className: "st41",
    width: 12.3,
    height: 20.8
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1797",
    x: 1239.5,
    y: -746,
    className: "st36",
    width: 10.4,
    height: 17.9
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1185",
    className: "st37",
    d: "M1249.9-735.3l-10.4-6.1v-4.5h5.4l4.9,2.9V-735.3z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1186",
    className: "st37",
    d: "M1239.5-736.2v-3.4l10.4,6.1v3.4L1239.5-736.2z"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1798",
    x: 1239.5,
    y: -741.3,
    className: "st41",
    width: 10.8,
    height: 0.6
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1799",
    x: 1158.1,
    y: -806,
    className: "st66",
    width: 14.7,
    height: 22.8
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1800",
    x: 1159.2,
    y: -804,
    className: "st41",
    width: 12.3,
    height: 20.8
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1801",
    x: 1160.2,
    y: -802.8,
    className: "st36",
    width: 10.4,
    height: 17.9
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1187",
    className: "st37",
    d: "M1170.5-792.2l-10.3-6.1v-4.5h5.5l4.9,2.9L1170.5-792.2z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1188",
    className: "st37",
    d: "M1160.2-793v-3.4l10.3,6.1v3.4L1160.2-793z"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1802",
    x: 1160.2,
    y: -798.1,
    className: "st41",
    width: 10.8,
    height: 0.6
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1803",
    x: 1158.1,
    y: -749.2,
    className: "st66",
    width: 14.7,
    height: 22.8
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1804",
    x: 1159.2,
    y: -747.2,
    className: "st41",
    width: 12.3,
    height: 20.8
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1805",
    x: 1160.2,
    y: -746,
    className: "st36",
    width: 10.4,
    height: 17.9
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1189",
    className: "st37",
    d: "M1170.5-735.3l-10.4-6.1v-4.5h5.5l4.9,2.9L1170.5-735.3z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1190",
    className: "st37",
    d: "M1160.2-736.2v-3.4l10.4,6.1v3.4L1160.2-736.2z"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1806",
    x: 1160.2,
    y: -741.3,
    className: "st41",
    width: 10.8,
    height: 0.6
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1191",
    className: "st42",
    d: "M1205.4-845.8l32.5,36.1l2.6-2.3l-35.1-38.9V-845.8z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1192",
    className: "st42",
    d: "M1205.4-845.8l-32.5,36.1l-2.6-2.3l35.1-38.9L1205.4-845.8z"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1807",
    x: 1307.6,
    y: -748.6,
    className: "st41",
    width: 4,
    height: 15.9
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1808",
    x: 1308.6,
    y: -747.2,
    className: "st36",
    width: 2,
    height: 13.1
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1193",
    className: "st66",
    d: "M1214.5-782.2V-798c0-5-4.1-9.1-9.1-9.1c-5,0-9.1,4.1-9.1,9.1v15.8H1214.5z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1194",
    className: "st41",
    d: "M1205.4-805.7c4.2,0,7.7,3.4,7.7,7.7c0,0,0,0,0,0v14.4h-15.4V-798 C1197.7-802.2,1201.1-805.7,1205.4-805.7C1205.4-805.7,1205.4-805.7,1205.4-805.7"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1195",
    className: "st36",
    d: "M1211.1-784.8l-0.1-13.2c0-3.1-2.6-5.7-5.7-5.7c-3.1,0-5.7,2.6-5.7,5.7l0.1,13.2H1211.1z"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1809",
    x: 1205,
    y: -804.2,
    className: "st41",
    width: 0.8,
    height: 19.6
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1196",
    className: "st39",
    d: "M1201.1-826.6c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3 C1203-830.8,1201.1-828.9,1201.1-826.6"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1810",
    x: 1174.6,
    y: -758.6,
    className: "st42",
    width: 61.6,
    height: 4.4
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1811",
    x: 1195,
    y: -783.6,
    className: "st19",
    width: 20.8,
    height: 2.8
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1812",
    x: 1158.1,
    y: -783.3,
    className: "st19",
    width: 14.7,
    height: 2.8
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1813",
    x: 1237.4,
    y: -784.4,
    className: "st19",
    width: 14.7,
    height: 2.8
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1814",
    x: 1237.4,
    y: -726.5,
    className: "st19",
    width: 14.7,
    height: 2.8
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1815",
    x: 1158,
    y: -726.5,
    className: "st19",
    width: 14.7,
    height: 2.8
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1197",
    className: "st65",
    d: "M1233.9-814.2l-28.5-26.5l-28.7,26.8l28.7-31.8L1233.9-814.2z"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1816",
    x: 1195.7,
    y: -748.2,
    className: "st56",
    width: 19.2,
    height: 36.5
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1817",
    x: 1197,
    y: -746.1,
    className: "st57",
    width: 16.6,
    height: 33.4
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1818",
    x: 1193.9,
    y: -715.1,
    className: "st38",
    width: 22.9,
    height: 6.7
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1819",
    x: 1198.4,
    y: -744.3,
    className: "st58",
    width: 13.7,
    height: 7.5
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1198",
    className: "st32",
    d: "M1190.4-737.2c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8v-7.1c0-1-0.8-1.8-1.8-1.8 c-1,0-1.8,0.8-1.8,1.8V-737.2z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1199",
    className: "st32",
    d: "M1216.5-737.2c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8v-7.1c0-1-0.8-1.8-1.8-1.8 c-1,0-1.8,0.8-1.8,1.8V-737.2z"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1820",
    x: 1230.2,
    y: -749.2,
    className: "st38",
    width: 1.5,
    height: 28.8
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1821",
    x: 1178.8,
    y: -749.2,
    className: "st38",
    width: 1.5,
    height: 28.8
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1822",
    x: 1224.8,
    y: -724.1,
    className: "st68",
    width: 11.8,
    height: 2.8
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1823",
    x: 1173.6,
    y: -724.1,
    className: "st68",
    width: 11.8,
    height: 2.8
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1824",
    x: 1176.7,
    y: -776.1,
    className: "st65",
    width: 57.2,
    height: 3.5
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1825",
    x: 1199.5,
    y: -716.7,
    className: "st19",
    width: 4.9,
    height: 16.1
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1826",
    x: 1189.4,
    y: -716.7,
    className: "st19",
    width: 4.9,
    height: 16.1
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1827",
    x: 1178.3,
    y: -716.7,
    className: "st19",
    width: 4.9,
    height: 16.1
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1828",
    x: 1168.3,
    y: -716.7,
    className: "st19",
    width: 4.9,
    height: 16.1
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1829",
    x: 1158.2,
    y: -716.7,
    className: "st19",
    width: 4.9,
    height: 16.1
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1830",
    x: 1147,
    y: -716.7,
    className: "st19",
    width: 4.9,
    height: 16.1
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1831",
    x: 1147,
    y: -713.2,
    className: "st19",
    width: 57.3,
    height: 1.5
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1200",
    className: "st19",
    d: "M1198.9-719.8c0,1.7,1.4,3,3,3s3-1.4,3-3c0-1.7-1.4-3-3-3c0,0,0,0,0,0 C1200.2-722.8,1198.9-721.4,1198.9-719.8"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1201",
    className: "st19",
    d: "M1188.9-719.8c0,1.7,1.4,3,3,3s3-1.4,3-3c0-1.7-1.4-3-3-3c0,0,0,0,0,0 C1190.2-722.8,1188.9-721.4,1188.9-719.8"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1202",
    className: "st19",
    d: "M1177.7-719.8c0,1.7,1.4,3,3,3s3-1.4,3-3c0-1.7-1.4-3-3-3c0,0,0,0,0,0 C1179.1-722.8,1177.7-721.4,1177.7-719.8"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1203",
    className: "st19",
    d: "M1167.7-719.8c0,1.7,1.4,3,3,3c1.7,0,3-1.4,3-3s-1.4-3-3-3c0,0,0,0,0,0 C1169.1-722.8,1167.7-721.4,1167.7-719.8"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1204",
    className: "st19",
    d: "M1157.7-719.8c0,1.7,1.4,3,3,3s3-1.4,3-3c0-1.7-1.4-3-3-3c0,0,0,0,0,0 C1159-722.8,1157.7-721.4,1157.7-719.8"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1205",
    className: "st19",
    d: "M1146.5-719.8c0,1.7,1.4,3,3,3c1.7,0,3-1.4,3-3s-1.4-3-3-3c0,0,0,0,0,0 C1147.8-722.8,1146.5-721.4,1146.5-719.8"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1832",
    x: 259.7,
    y: -796.8,
    className: "st69",
    width: 11,
    height: 12.9
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1833",
    x: 258.9,
    y: -799.9,
    className: "st70",
    width: 12.6,
    height: 4.8
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1834",
    x: 314.7,
    y: -808.1,
    className: "st71",
    width: 3.7,
    height: 11.4
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1835",
    x: 308.7,
    y: -810.7,
    className: "st71",
    width: 3.4,
    height: 17.4
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1206",
    className: "st72",
    d: "M221.6-742h109.7v-56.2l-109.7,25.9V-742z"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1836",
    x: 221.6,
    y: -765,
    className: "st73",
    width: 109.7,
    height: 1.3
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1207",
    className: "st73",
    d: "M260.7-780.4v-1.2l0.6-0.2h69.9v1.3H260.7z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1208",
    className: "st73",
    d: "M331.3-788.7h-40.1l5.6-1.3h34.5L331.3-788.7z"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1837",
    x: 221.6,
    y: -756.6,
    className: "st73",
    width: 109.7,
    height: 1.3
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1209",
    className: "st73",
    d: "M331.3-772H221.6v-0.3l4.3-1h105.4V-772z"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1838",
    x: 266.8,
    y: -775,
    className: "st73",
    width: 20.7,
    height: 30.1
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1839",
    x: 268.5,
    y: -774.1,
    className: "st74",
    width: 17.4,
    height: 28.3
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1840",
    x: 308.7,
    y: -781.7,
    className: "st73",
    width: 4.9,
    height: 15.2
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1841",
    x: 309.4,
    y: -781.7,
    className: "st74",
    width: 3.5,
    height: 15.2
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1842",
    x: 315.5,
    y: -781.7,
    className: "st73",
    width: 4.9,
    height: 15.2
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1843",
    x: 316.2,
    y: -781.7,
    className: "st74",
    width: 3.5,
    height: 15.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2893",
    transform: "translate(224.958 85.793)",
    className: "st75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2892",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119085457992906556390000002313514028364888997_",
    x: 1,
    y: -884,
    width: 105.3,
    height: 24.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152952541420649133710000017549764429149149078_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119085457992906556390000002313514028364888997_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2891",
    style: {
      clipPath: "url(#SVGID_00000152952541420649133710000017549764429149149078_)"
    }
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1210",
    className: "st74",
    d: "M106.4-884v24.9H1L106.4-884z"
  })))))), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1845",
    x: 292.4,
    y: -790,
    className: "st73",
    width: 4.2,
    height: 48.6
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1846",
    x: 296.6,
    y: -790,
    className: "st77",
    width: 1.4,
    height: 48.6
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1847",
    x: 255.8,
    y: -782.1,
    className: "st73",
    width: 4.2,
    height: 40.8
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1848",
    x: 260,
    y: -782.1,
    className: "st77",
    width: 1.2,
    height: 40.8
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1849",
    x: 220.3,
    y: -774.7,
    className: "st73",
    width: 4.2,
    height: 33.4
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1850",
    x: 224.5,
    y: -774.7,
    className: "st77",
    width: 1.3,
    height: 33.4
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1851",
    x: 337.4,
    y: -799.9,
    className: "st73",
    width: 2.9,
    height: 58.5
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1852",
    x: 340.3,
    y: -799.9,
    className: "st77",
    width: 2.1,
    height: 58.5
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1211",
    className: "st77",
    d: "M216-769.7l127.6-28.9l-1.2-4.8l-127.6,28.9L216-769.7z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1212",
    className: "st78",
    d: "M285.7-750.7c66.9,0,121.1,12.8,121.1,28.6H164.6C164.6-737.9,218.8-750.7,285.7-750.7"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1466",
    className: "st79",
    d: "M85-697.7l1441.2-0.7v35.1L85-662.6V-697.7z"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1854",
    x: 85,
    y: -681,
    className: "st80",
    width: 1441.2,
    height: 4.9
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1213",
    className: "st28",
    d: "M942.2-787.1c0.3-8.9-7-15.2-12.9-21.8c-4.6-5.2-2.2-10.3-2.8-16.3 c-1.1-9.6-10.3-15.6-21.3-15.9c-10.5-0.3-22.1,4.3-24.7,13.6c-2.2,7.6,0.3,15.4-2.7,23c-3.2,8.2-10.3,15.4-12,23.9 c-1.5,7.4,4.1,12.9,10.9,17c10.4,6.2,22.5,9.2,34,3.3c4.1-2.1,6.9-5.1,10.5-7.6c4-2.9,8.9-4.5,13.2-7 C939-777.7,942.1-782.2,942.2-787.1"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1214",
    className: "st29",
    d: "M884.2-776.6c4-2-4-15.9,6-15.9c14-4,29.9,10,41.9-2c1.5-2.2,2.9-4.5,4-6.9 c3.5,4.2,6.3,8.7,6.1,14.3c-0.1,4.9-3.2,9.4-8,12.1c-4.3,2.5-9.2,4.1-13.2,7c-3.6,2.5-6.4,5.6-10.5,7.6 c-11.5,5.8-23.7,2.9-34-3.3c-4.8-2.9-9-6.5-10.5-11C872.1-773.4,878.2-773.5,884.2-776.6"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1215",
    className: "st26",
    d: "M907.6-707.1h-4.8v-73.2c1.5,0.7,3.1,1.4,4.8,1.9V-707.1z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1216",
    className: "st26",
    d: "M904.8-774c0.1,0,0.3,0,0.4,0l0-1.8c-2.9,0.1-10.1-0.6-13.2-8.6l-1.6,0.6 C893.8-774.8,901.9-774,904.8-774"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1217",
    className: "st26",
    d: "M906.2-769.6c6.2,0,11-1.7,14.2-5.1c2.8-3,4.4-7,4.4-11.2l-1.8,0.1 c-0.1,3.7-1.4,7.2-3.9,9.9c-2.9,3-7.3,4.5-13,4.5L906.2-769.6z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1218",
    className: "st26",
    d: "M905.2-752.6c-6.2,0-11-1.7-14.2-5.1c-2.8-3-4.4-7-4.4-11.2l1.8,0.1 c0.1,3.7,1.4,7.2,3.9,9.9c2.9,3,7.3,4.5,13,4.5L905.2-752.6z"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1855",
    x: 895,
    y: -784,
    className: "st26",
    width: 1.8,
    height: 6.3
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1856",
    x: 917.2,
    y: -784.8,
    className: "st26",
    width: 1.8,
    height: 11.3
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1219",
    className: "st28",
    d: "M889.1-843.1c-0.1,0.6-0.2,1.1-0.2,1.7c-0.1,1.1,0.1,2.1,0.5,3.1c1,1.9,2.3,3.3,3.5,3.1 c0.6-0.1,1-0.7,1.1-1.7c0.1-1.2-0.1-2.4-0.7-3.4c-0.6-1-1.5-1.9-2.6-2.3C890.3-842.9,889.7-843,889.1-843.1"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1220",
    className: "st28",
    d: "M886.6-838.1c-0.2,0.9-0.1,1.8,0.3,2.6c0.7,1,1.7,1.6,2.3,1.3s0.5-1.4-0.3-2.5 C888.3-837.5,887.5-837.9,886.6-838.1"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1221",
    className: "st28",
    d: "M901.1-844c-0.9,0.6-1.6,1.6-1.9,2.6c-0.3,1.4,0.1,2.8,0.8,3c0.8,0.3,1.7-0.9,2-2.6 C902.2-842,901.8-843.1,901.1-844"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1222",
    className: "st28",
    d: "M906.5-844.9c-1,0.3-1.9,0.9-2.5,1.8c-0.7,1.3-0.7,2.7,0,3.1c0.7,0.4,1.8-0.4,2.5-1.8 C906.9-842.8,906.9-843.9,906.5-844.9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1223",
    className: "st28",
    d: "M930.2-822.4c0,0-2.6-1.1-4.6-0.2c-2,0.7-3.3,2.1-3.1,3.3c0.2,1.1,2.3,1.4,4.7,0.5 C928.7-819.5,929.7-820.8,930.2-822.4"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1224",
    className: "st28",
    d: "M928.9-827.2c-0.2-0.1-0.5-0.2-0.8-0.3c-0.6-0.2-1.2-0.1-1.8,0.1 c-1.2,0.6-1.7,1.8-1.3,2.2c0.4,0.4,1.4,0.2,2.3-0.3c0.4-0.3,0.8-0.6,1.1-1C928.6-826.7,928.8-826.9,928.9-827.2"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1225",
    className: "st28",
    d: "M933.7-809.2c-0.4-0.1-0.8-0.1-1.2,0c-0.9,0.1-1.6,0.5-2.2,1.2c-1.3,1.5-1.2,3.5-0.4,3.6 c0.9,0.2,1.9-0.6,2.8-1.7c0.4-0.6,0.7-1.2,0.8-1.9C933.6-808.5,933.7-808.9,933.7-809.2"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1226",
    className: "st28",
    d: "M876.6-807.3c0.1,1.3,0.7,2.6,1.6,3.5c1.3,1.2,2.9,1.6,3.6,1c0.7-0.6,0.1-2.3-1.4-3.7 C879.3-807.2,877.9-807.5,876.6-807.3"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1227",
    className: "st28",
    d: "M871.4-804.5c0,0.5,0,1.1,0.1,1.6c0.1,1.1,0.6,2.1,1.4,2.9c0.8,0.8,1.7,1.4,2.8,1.7 c0.2,0.1,0.5,0.1,0.7,0.1c0.2,0,0.5,0,0.7,0c0.5-0.1,0.7-0.3,0.7-0.6c0-0.3-0.1-0.6-0.1-0.9c0-0.3,0-0.6-0.2-0.9 c-0.4-0.9-0.9-1.7-1.6-2.3c-0.8-0.7-1.8-1.2-2.8-1.3C872.5-804.5,872-804.6,871.4-804.5"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1228",
    className: "st28",
    d: "M869.6-799.3c0.1,0.5,0.2,1,0.3,1.5c0.2,0.9,0.7,1.8,1.3,2.4c1.4,1.4,2.7,2,3.8,1.6 c0.5-0.2,0.7-0.8,0.5-1.7c-0.3-1-0.8-2-1.6-2.7c-0.8-0.7-1.8-1.1-2.9-1.2C870.7-799.4,870.1-799.4,869.6-799.3"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1229",
    className: "st29",
    d: "M898.6-797.4c-0.4,0.4-0.7,0.8-0.9,1.3c-0.5,0.9-0.8,2-0.7,3.1c0.3,2.1,1,3.6,2.2,3.8 c0.6,0.1,1.1-0.3,1.5-1.1c0.5-1,0.6-2.1,0.4-3.2c-0.2-1-0.7-2-1.4-2.7C899.4-796.7,899-797.1,898.6-797.4"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1230",
    className: "st29",
    d: "M894.3-797.9c-0.3,0.3-0.5,0.7-0.7,1.1c-0.4,0.8-0.5,1.8-0.3,2.7c0.5,1.8,1.4,2.9,2.4,2.9 c0.5,0,0.9-0.4,1.1-1.2c0.2-0.9,0.2-1.8-0.1-2.7c-0.3-0.8-0.7-1.5-1.4-2.1C895-797.4,894.7-797.7,894.3-797.9"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1231",
    className: "st29",
    d: "M914-793.6c-1,0.3-1.8,0.9-2.3,1.8c-0.6,1.2-0.6,2.5,0.1,2.8c0.6,0.4,1.6-0.4,2.3-1.8 c0.2-0.6,0.3-1.2,0.2-1.9C914.2-793,914.1-793.3,914-793.6"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1232",
    className: "st29",
    d: "M929.1-798.5c-0.2,0.5-0.4,1.1-0.5,1.7c-0.2,1.1-0.1,2.3,0.4,3.4c1,2.2,2.4,3.5,3.7,3.3 c0.6-0.1,1-0.8,1.2-1.7c0.1-1.2-0.1-2.4-0.7-3.5c-0.5-1-1.4-1.9-2.5-2.4C930.2-798.1,929.6-798.3,929.1-798.5"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1233",
    className: "st29",
    d: "M925.5-796.8c0,0-0.8,2.6,0.2,4.4s2.7,3,3.7,2.5c1-0.5,0.9-2.5-0.2-4.4 C928.3-795.5,927-796.4,925.5-796.8"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1234",
    className: "st29",
    d: "M945.8-780.2c-0.3-0.5-0.6-1.1-1-1.6c-0.7-1-1.7-1.8-2.9-2.2c-1.2-0.4-2.6-0.4-3.8,0 c-1,0.4-1.6,0.9-1.6,1.6c0.1,0.8,0.6,1.4,1.3,1.8c0.9,0.5,1.8,1,2.8,1.2c1.1,0.3,2.3,0.3,3.5-0.1 C944.7-779.7,945.2-779.9,945.8-780.2"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1235",
    className: "st29",
    d: "M941.2-775.6c0-0.5-0.1-0.9-0.3-1.3c-0.5-0.9-1.3-1.6-2.2-1.9c-0.8-0.2-1.7-0.3-2.5-0.1 c-0.5,0.1-1,0.4-1.3,0.8c-0.3,0.4-0.1,1,0.5,1.5c0.7,0.5,1.4,0.9,2.3,1.1c0.7,0.2,1.5,0.2,2.2,0 C940.6-775.6,941.2-775.6,941.2-775.6"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1236",
    className: "st29",
    d: "M930.2-768.7c0.1-0.4,0-0.8,0-1.1c-0.1-0.8-0.5-1.5-1.1-2.1c-1.3-1.1-2.6-1.3-3.2-0.8 c-0.6,0.6,0.1,2,1.3,3c0.5,0.4,1.2,0.7,1.9,0.8C929.4-768.7,929.8-768.7,930.2-768.7"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1237",
    className: "st29",
    d: "M868.9-764.7c0.5,0.1,1,0.1,1.5,0c1-0.1,1.9-0.5,2.6-1.1c1.5-1.5,1.9-2.4,1.8-3.5 c-0.1-0.5-0.7-0.9-1.7-0.7c-1,0.2-2,0.7-2.7,1.4c-0.7,0.7-1.2,1.6-1.3,2.5C869-765.6,868.9-765.1,868.9-764.7"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1238",
    className: "st29",
    d: "M874.4-760.6c1-0.1,1.9-0.5,2.7-1.1c0.8-0.9,1.5-1.6,1.2-2.4c-0.1-0.3-0.5-0.5-1.1-0.5 c-0.8,0.1-1.5,0.4-2,1C874.4-762.8,874.1-761.7,874.4-760.6"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1239",
    className: "st30",
    d: "M917.8-822.8c0,0-0.6,0.2-1.4,0.6c-0.8,0.3-1.5,0.8-2.1,1.4c-1.2,1.4-1.9,2.9-1.3,3.8 c0.6,0.8,2.6,0.4,4.2-1.3c0.7-0.8,1-1.9,0.9-3C918.1-821.8,918-822.3,917.8-822.8"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1240",
    className: "st30",
    d: "M913.3-825c-0.3,0.2-0.7,0.4-1,0.7c-0.6,0.5-1,1.1-1.3,1.8c-0.5,1.7-0.1,3.3,0.7,3.4 c0.8,0.1,1.8-1,2.2-2.5c0.2-0.8,0.1-1.6-0.2-2.4C913.7-824.4,913.5-824.7,913.3-825"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1241",
    className: "st30",
    d: "M909.3-828.5c-1.1,0.9-1.8,2.1-2,3.5c-0.1,2,0.6,3.7,1.6,3.7s1.9-1.5,2-3.5 C910.9-826.2,910.3-827.6,909.3-828.5"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1242",
    className: "st30",
    d: "M903.4-829.6c-0.3,0.5-0.5,1.1-0.7,1.7c-0.3,1.1-0.4,2.3-0.1,3.4c0.2,1,0.6,1.9,1.2,2.7 c0.3,0.6,0.9,1.1,1.6,1.3c0.6,0.1,1.3-0.4,1.7-1.4c0.4-1.2,0.4-2.6,0-3.8c-0.4-1.2-1.2-2.2-2.2-2.9 C904.5-829.1,904-829.4,903.4-829.6"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1243",
    className: "st30",
    d: "M898.6-826.1c-0.4,1.1-0.4,2.3,0,3.4c0.7,1.4,1.6,2.3,2.5,2.2c0.8-0.1,1.1-1.9,0.3-3.5 C900.7-825.1,899.7-825.8,898.6-826.1"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1244",
    className: "st30",
    d: "M894.8-823.1c0,0.2,0,0.5,0,0.7c0,0.4,0.1,0.8,0.2,1.2c0.4,0.8,0.9,1.3,1.4,1.2 c0.5-0.1,0.7-1,0.2-2c-0.2-0.4-0.6-0.7-1.1-0.9C895.2-823.1,895-823.1,894.8-823.1"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1245",
    className: "st30",
    d: "M908.3-810.3c-0.4,0.2-0.7,0.5-1.1,0.8c-0.7,0.5-1.2,1.1-1.5,1.8c-0.7,1.6-0.8,3.3,0,3.7 c0.8,0.5,2.3-0.5,3.1-2.4c0.3-0.9,0.3-1.9,0-2.8C908.8-809.6,908.6-810,908.3-810.3"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1246",
    className: "st30",
    d: "M904.1-809.6c-0.3,0.2-0.6,0.3-0.8,0.6c-0.5,0.5-0.9,1.1-1.1,1.8 c-0.3,1.4,0.2,2.7,0.9,2.8c0.7,0.1,1.5-0.9,1.7-2.4c0.1-0.6,0-1.3-0.3-1.8C904.4-809,904.2-809.3,904.1-809.6"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1247",
    className: "st30",
    d: "M895.8-814.3c0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1-0.1,0.3-0.1,0.4 c-0.1,0.3-0.3,0.8-0.4,1.4c-0.4,1.3-0.4,2.6-0.1,3.9c0.3,1.2,0.9,2.3,1.6,3.2c0.5,0.6,1.2,1,2,1.1c0.7,0.1,1.4-0.7,1.7-1.8 c0.3-1.4,0.2-2.8-0.2-4.1c-0.5-1.3-1.4-2.5-2.5-3.3c-0.4-0.3-0.9-0.6-1.3-0.8c-0.2-0.1-0.4-0.1-0.5-0.2c-0.1,0-0.2-0.1-0.2-0.1 C896-814.4,895.9-814.4,895.8-814.3"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1248",
    className: "st30",
    d: "M892.8-809.9c-0.1,0.3-0.3,0.7-0.4,1c-0.2,0.7-0.2,1.4,0,2.1c0.3,0.8,0.8,1.4,1.5,1.9 c0.3,0.2,0.6,0.3,0.9,0.3c0.2,0,0.4-0.1,0.5-0.3c0.2-0.9,0.1-1.9-0.3-2.8c-0.3-0.6-0.7-1.2-1.3-1.6 C893.5-809.6,893.2-809.8,892.8-809.9"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1249",
    className: "st30",
    d: "M889.5-806.9c0.1,0.6,0.4,1.2,0.9,1.6c0.6,0.6,1.4,0.8,1.8,0.5s0.1-1.1-0.7-1.8 c-0.4-0.3-0.8-0.4-1.3-0.4C889.9-807,889.7-807,889.5-806.9"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1250",
    className: "st30",
    d: "M910.9-804.6c-0.2,0-0.3-0.1-0.5-0.1c-0.4,0-0.7,0.1-1,0.4c-0.6,0.6-0.7,1.5-0.3,1.6 c0.4,0.1,0.8-0.2,1.3-0.6c0.2-0.2,0.4-0.5,0.5-0.8C910.9-804.2,910.9-804.4,910.9-804.6"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1251",
    className: "st20",
    d: "M867.5-699.1c14.9-13.7,62.7-23.7,119.4-23.7c56.7,0,104.5,10,119.5,23.7H867.5z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1252",
    className: "st29",
    d: "M1072.8-766.7c0.6-0.2,1.2-0.5,1.9-0.8c8-3.8,14-14.4,10.9-23.2c-1.7-4.6-6.9-6.7-7.7-12 c-0.9-6.6-6.7-11.4-12.1-4.8c-5.9,7.2-18.3,3.9-22.4,12.9c-2.1,4.6,2.8,13.2-5.2,13.2c-4.9,0-17.5,6-6.9,10.1 C1043.6-766.3,1059.8-761.6,1072.8-766.7"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1253",
    className: "st81",
    d: "M1036-781c5.1,3.3,10.1,4.9,13.3,1.7c12.7-9.1,22-13,36-11.7c0,0.1,0.1,0.2,0.2,0.4 c3.2,8.7-2.9,19.4-10.9,23.2c-0.6,0.3-1.2,0.6-1.9,0.8c-13,5-29.2,0.3-41.5-4.5C1022-774.8,1030.5-779.8,1036-781"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1254",
    className: "st26",
    d: "M1065.4-719.1l-6.9,1.4v-107.1c1.2,1,2.6,2,4,2.7L1065.4-719.1z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1255",
    className: "st29",
    d: "M1056.3-859.7c15-6,19.8,17.8,12.8,18.3C1063.3-841,1046.8-855.9,1056.3-859.7"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1256",
    className: "st29",
    d: "M1063.2-811.7c3.3-1.3,6.4-2.9,9.2-5c2.8-1.9,7.8-5.9,5.1-9.7c-3-4.2-9.1-5.2-12.5-9.9 c-3.4-4.7-9.3-3.5-11.9,1.4c-2.5,4.7-2.1,7.8-8,8.8c-5.4,0.9-10.3,3.7-9.8,9.9c1.1,12.4,14.9,8.1,22.9,6 C1059.9-810.5,1061.5-811.1,1063.2-811.7"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1257",
    className: "st81",
    d: "M1037.6-822.8c0.9,3.7,4.4,6.8,7.9,9.1c11.3,3.2,19.9-7.2,30.4-5.9 c-1.1,1.1-2.3,2-3.5,2.9c-2.9,2-6,3.7-9.2,5c-1.6,0.6-3.3,1.2-4.9,1.6c-8,2-21.8,6.4-22.9-6 C1035-818.6,1035.8-821.1,1037.6-822.8"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1258",
    className: "st26",
    d: "M1061.9-780.5c6.2-0.3,11.1-5.5,10.8-11.8l-1.9,0.2c0.1,2.5-0.8,4.9-2.5,6.7 c-1.6,1.9-4,3-6.5,3l0,1.9C1061.8-780.5,1061.8-780.5,1061.9-780.5"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1259",
    className: "st26",
    d: "M1071.2-785.7c1.4,0,4.2-0.2,5.7-1.8c0.7-0.8,1-1.8,0.8-2.8l-1.9,0.3c0.1,0.5,0,1-0.3,1.3 c-0.8,0.9-2.8,1.2-4.4,1.2l0,1.9L1071.2-785.7"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1260",
    className: "st26",
    d: "M1058.9-770c0.2,0,0.4,0,0.6,0l-0.2-1.9c-2,0.2-4.3-1.1-5.7-2.6c-1.4-1.5-1.6-3-1.6-5.5 l-1.9,0c0,2.4,0.1,4.7,2.1,6.9C1053.9-771.3,1056.3-770.1,1058.9-770"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1261",
    className: "st26",
    d: "M1059.6-805.5c0.2,0,0.3,0,0.5,0l-0.2-1.9c-2.1,0.2-4.9-1.4-6.3-3c-2-2.3-1.7-6.1-1.3-8.8 l-1.9-0.3c-0.5,3.1-0.8,7.5,1.7,10.3C1054.2-807.1,1056.8-805.7,1059.6-805.5"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1262",
    className: "st26",
    d: "M1062.3-836.3c0-4.7,0.2-9.1,0.5-13.3l-3-0.2c-0.3,4.3-0.5,8.7-0.5,13.5L1062.3-836.3z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1263",
    className: "st26",
    d: "M1063.2-843c0.5,0,1-0.1,1.5-0.3c2.1-1,3.3-3.7,3.7-5.2l-1.8-0.5c-0.4,1.5-1.4,3.4-2.6,4 c-0.5,0.2-1,0.2-1.5,0l-0.8,1.7C1062.1-843.1,1062.6-843,1063.2-843"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1264",
    className: "st29",
    d: "M1050.7-837.6c-0.4,1.2-0.4,2.4,0.1,3.6c0.9,1.6,2.3,2.6,3,2.1c0.7-0.5,0.7-2.1-0.1-3.6 C1052.9-836.6,1051.9-837.3,1050.7-837.6"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1265",
    className: "st29",
    d: "M1049.2-831.9c0,0.3-0.1,0.7,0,1c0,0.6,0.1,1.2,0.4,1.8c0.7,1.2,2.1,2,2.6,1.5 c0.5-0.5,0.3-1.6-0.4-2.8C1051.1-831.3,1050.2-831.8,1049.2-831.9"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1266",
    className: "st29",
    d: "M1046.7-827.8c0,0.6,0.2,1.1,0.5,1.5c0.5,0.5,1.2,0.7,1.5,0.5c0.3-0.3,0.1-0.9-0.5-1.5 C1047.8-827.7,1047.3-827.8,1046.7-827.8"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1267",
    className: "st29",
    d: "M1071.7-835.5c-1.1,0.1-2.2,0.6-3,1.5c-1,1.3-1.3,2.8-0.6,3.4c0.7,0.5,2-0.1,3-1.5 C1071.7-833.2,1071.9-834.4,1071.7-835.5"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1268",
    className: "st29",
    d: "M1075.4-831.7c-0.3-0.1-0.6-0.1-0.9,0c-0.6,0-1.1,0.2-1.6,0.5c-0.9,0.7-1.4,1.3-1.3,1.9 c0.1,0.6,1.5,0.7,2.6-0.1c0.4-0.4,0.8-0.9,0.9-1.4C1075.3-831.2,1075.4-831.4,1075.4-831.7"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1269",
    className: "st29",
    d: "M1076.6-827c-0.5,0.1-1,0.3-1.4,0.5c-0.5,0.4-1,0.9-0.8,1.3c0.2,0.3,0.9,0.4,1.7-0.1 C1076.6-825.7,1076.8-826.4,1076.6-827"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1270",
    className: "st29",
    d: "M1061.4-862.9c-0.5,1-0.6,2.1-0.4,3.2c0.5,1.4,1.2,2.4,2,2.4c0.8,0,1.3-1.6,0.8-3.3 C1063.3-861.7,1062.5-862.5,1061.4-862.9"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1271",
    className: "st29",
    d: "M1056.1-862.2c-0.3,0.9-0.3,1.9,0.1,2.8c0.6,1.2,1.7,1.9,2.3,1.6c0.6-0.3,0.6-1.5-0.1-2.8 C1057.9-861.4,1057.1-862,1056.1-862.2"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1272",
    className: "st29",
    d: "M1054.4-861.8c0,0.4-0.1,0.8,0,1.2c0,0.7,0.2,1.4,0.5,2c0.7,1.2,1.5,2.1,2.4,2 c0.4-0.1,0.7-0.5,0.8-1.1c0.1-0.8-0.1-1.6-0.6-2.3c-0.4-0.7-1.1-1.2-1.9-1.5C1055.2-861.7,1054.8-861.7,1054.4-861.8"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1273",
    className: "st29",
    d: "M1052.5-858.4c0.2,0.6,0.5,1.2,1,1.5c0.7,0.4,1.4,0.6,1.7,0.3c0.4-0.3,0-1.2-0.9-1.7 C1053.8-858.6,1053.1-858.6,1052.5-858.4"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1274",
    className: "st29",
    d: "M1075.8-853.3c-0.3-0.4-0.7-0.7-1.1-1c-0.9-0.6-2-0.9-3.1-0.7c-2.3,0.5-3.7,1.7-3.5,2.8 c0.2,1.1,2.2,1.5,4.2,1.1c0.9-0.2,1.7-0.6,2.4-1.2C1075.1-852.7,1075.4-853,1075.8-853.3"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1275",
    className: "st29",
    d: "M1075.1-847.7c-0.2-0.3-0.4-0.5-0.6-0.7c-0.5-0.5-1.2-0.7-1.8-0.7c-1.5,0.1-2.5,1-2.3,1.6 c0.2,0.7,1.3,0.9,2.5,0.8c0.6,0,1.1-0.2,1.6-0.5C1074.6-847.3,1074.9-847.5,1075.1-847.7"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1276",
    className: "st81",
    d: "M1031.8-819.7c0.1,0.3,0.3,0.7,0.5,1c0.3,0.6,0.8,1.1,1.3,1.4c1.3,0.7,2.6,0.8,3,0.2 c0.4-0.7-0.4-1.8-1.7-2.5C1034-820.2,1032.8-820.1,1031.8-819.7"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1277",
    className: "st81",
    d: "M1033.2-814.9c0,0,0.2,0.3,0.5,0.6c0.3,0.4,0.6,0.7,1.1,0.9c1,0.4,2.2,0.2,2.3-0.3 c0-0.6-0.5-1.1-1.5-1.6c-0.5-0.2-1.1-0.2-1.6,0C1033.7-815.2,1033.4-815,1033.2-814.9"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1278",
    className: "st81",
    d: "M1036.2-810.3c0.6,0.5,1.4,0.7,2.2,0.6c1.1-0.2,1.9-0.8,1.8-1.4s-1.1-0.8-2.2-0.6 C1037.3-811.4,1036.7-810.9,1036.2-810.3"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1279",
    className: "st29",
    d: "M1079.5-803.1c-0.8-0.3-1.6-0.4-2.4-0.1c-1.2,0.6-1.8,1.5-1.5,2c0.3,0.5,1.4,0.5,2.4,0 C1078.6-801.6,1079.2-802.3,1079.5-803.1"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1280",
    className: "st29",
    d: "M1078.5-808c-0.3,0-0.6,0-0.9,0.1c-0.5,0.1-1.1,0.3-1.5,0.7c-0.8,0.8-1.1,1.3-1.1,2 c0,0.3,0.4,0.5,0.9,0.5c0.6-0.1,1.2-0.4,1.7-0.8c0.4-0.4,0.7-1,0.8-1.5C1078.5-807.5,1078.5-807.7,1078.5-808"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1281",
    className: "st29",
    d: "M1076-811.1c-0.8,0.1-1.5,0.4-2.1,1c-0.7,0.9-0.9,1.9-0.5,2.3s1.4-0.1,2.1-1 C1076-809.5,1076.1-810.3,1076-811.1"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1282",
    className: "st29",
    d: "M1085.8-796c-0.2-0.3-0.5-0.6-0.8-0.8c-0.7-0.5-1.4-0.8-2.3-0.8c-1.8,0.1-3.1,1-3,1.8 c0.1,0.8,1.5,1.4,3.1,1.3c0.7,0,1.4-0.3,2-0.7C1085.2-795.5,1085.5-795.7,1085.8-796"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1283",
    className: "st29",
    d: "M1044.5-802.2c0,0.4,0,0.8,0.1,1.2c0.1,0.7,0.4,1.4,0.8,1.9c1.1,1.2,2.4,1.8,3,1.2 c0.6-0.6,0.3-2-0.8-3.2c-0.6-0.6-1.3-0.9-2.1-1.1C1045.2-802.2,1044.8-802.2,1044.5-802.2"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1284",
    className: "st29",
    d: "M1042.2-797.6c0,0.3,0.1,0.7,0.2,1c0.2,0.6,0.5,1.2,1.1,1.7c1.2,1,3,1,3.1,0.3 c0-0.4-0.1-0.8-0.3-1.2c-0.3-0.5-0.7-0.9-1.2-1.2c-0.5-0.4-1.2-0.6-1.9-0.6C1042.9-797.6,1042.6-797.6,1042.2-797.6"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1285",
    className: "st29",
    d: "M1041.4-788.3l0.1,0.3c0.1,0.2,0.1,0.4,0.1,0.6c0,0.6,0.1,1.1,0.4,1.6 c0.6,1.1,1.9,2,2.4,1.5c0.5-0.5,0.5-1.5-0.2-2.8c-0.4-0.6-1-1.1-1.8-1.3C1042.1-788.5,1041.7-788.5,1041.4-788.3"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1286",
    className: "st29",
    d: "M1040.3-785.1c0,0,0.1,0.4,0.3,0.8c0.2,0.5,0.4,0.9,0.8,1.2c0.8,0.7,1.9,1.2,2.3,0.7 c0.4-0.5,0.1-1.4-0.8-2.3c-0.5-0.4-1.1-0.6-1.7-0.6C1040.8-785.3,1040.6-785.2,1040.3-785.1"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1287",
    className: "st81",
    d: "M1025.4-777.5c0,0,0.3,0.3,0.7,0.7c0.4,0.4,0.9,0.7,1.4,0.9c1.1,0.4,2.4,0.4,2.7-0.2 c0.3-0.6-0.4-1.6-1.9-2.1c-0.7-0.2-1.4-0.1-2.1,0.2C1025.9-777.9,1025.7-777.7,1025.4-777.5"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1288",
    className: "st81",
    d: "M1026.2-772.2c0,0,0.4,0.1,0.8,0.1c0.5,0.1,0.9,0,1.4-0.1c0.9-0.2,1.7-0.5,1.8-1.1 c0.1-0.3-0.2-0.6-0.6-0.8c-0.6-0.3-1.2-0.3-1.8-0.1C1026.9-773.9,1026.3-773.1,1026.2-772.2"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1289",
    className: "st81",
    d: "M1089.1-785.2c-0.6-0.6-1.3-1-2.2-1c-1.1,0-2.1,0.5-2.1,1.1c0,0.6,0.9,1.1,2.2,1 C1087.8-784.2,1088.6-784.6,1089.1-785.2"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1290",
    className: "st81",
    d: "M1087.9-779.5c0-0.3-0.1-0.5-0.2-0.7c-0.3-0.5-0.7-0.9-1.3-1.1c-1.2-0.3-2.1-0.1-2.3,0.4 c-0.2,0.5,0.7,1.2,1.7,1.5c0.4,0.1,0.9,0.1,1.3,0C1087.6-779.5,1087.9-779.5,1087.9-779.5"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1291",
    className: "st81",
    d: "M1072.8-765.6c0.7-0.6,1-1.5,1-2.3c-0.1-1.2-0.6-2.1-1.3-2.1c-0.6-0.1-1.1,1-1,2.3 c0.1,0.5,0.3,1,0.6,1.5C1072.4-766,1072.6-765.8,1072.8-765.6"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1292",
    className: "st81",
    d: "M1076.8-766.2c0,0-0.1-0.4-0.2-0.8c-0.1-0.5-0.2-0.9-0.5-1.3c-0.6-0.8-1.3-1.3-1.9-1.1 c-0.5,0.1-0.6,1.4,0.2,2.4c0.4,0.5,0.9,0.8,1.5,0.8C1076.3-766.1,1076.6-766.1,1076.8-766.2"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1293",
    className: "st81",
    d: "M1079-768.4c-0.1-0.8-0.5-1.5-1.1-2c-0.9-0.7-1.9-0.9-2.3-0.4s0.1,1.4,1,2.1 C1077.4-768.3,1078.3-768.2,1079-768.4"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1294",
    className: "st82",
    d: "M1064.5-823.3c-0.8-0.3-1.8-0.3-2.6,0c-1.2,0.6-1.9,1.7-1.5,2.2c0.4,0.5,1.5,0.5,2.6-0.1 C1063.7-821.7,1064.3-822.4,1064.5-823.3"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1295",
    className: "st82",
    d: "M1060.6-827c-1,0.5-1.8,1.3-2.1,2.4c-0.4,1.5-0.3,2.3,0.3,2.9c0.3,0.3,0.8,0.2,1.3-0.2 c0.6-0.5,1-1.2,1.2-2c0.2-0.7,0.1-1.5-0.2-2.1C1060.9-826.4,1060.8-826.7,1060.6-827"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1296",
    className: "st82",
    d: "M1056.4-826.4c-0.2,0.2-0.4,0.5-0.5,0.7c-0.3,0.4-0.5,1-0.5,1.5c0.1,1.3,0.6,2.3,1.2,2.2 c0.6-0.1,1-1.1,1-2.2C1057.6-825.1,1057.1-825.9,1056.4-826.4"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1297",
    className: "st82",
    d: "M1052.4-824.4c-0.1,0.4,0,0.9,0.2,1.3c0.4,0.5,0.9,0.8,1.2,0.7c0.3-0.2,0.2-0.8-0.2-1.3 C1053.3-824.1,1052.9-824.3,1052.4-824.4"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1298",
    className: "st82",
    d: "M1072.4-800.2c-0.4,0.1-0.7,0.2-1.1,0.3c-0.7,0.3-1.3,0.9-1.6,1.6 c-0.7,1.4-0.7,2.6-0.1,3.1c0.3,0.3,0.8,0.2,1.3-0.2c0.6-0.4,1.1-1.1,1.4-1.8c0.3-0.7,0.4-1.4,0.2-2.1 C1072.5-799.5,1072.5-799.9,1072.4-800.2"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1299",
    className: "st82",
    d: "M1067.3-800.3c-0.2,0.2-0.3,0.4-0.5,0.7c-0.3,0.4-0.4,0.9-0.4,1.4c0,1.1,0.4,2,1,2.1 c0.6,0,1.1-0.9,1.1-2.1C1068.4-799.1,1067.9-799.8,1067.3-800.3"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1300",
    className: "st82",
    d: "M1064.7-798.2c-0.4,0.5-0.5,1.2-0.3,1.7c0.3,0.8,0.8,1.2,1.3,1.2s0.5-0.9,0.2-1.7 C1065.6-797.6,1065.2-798,1064.7-798.2"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1301",
    className: "st82",
    d: "M1052.4-792.4c0,0,0,0.4,0.1,1c0,0.6,0.2,1.1,0.5,1.6c0.7,1,1.4,1.6,2.1,1.5 c0.3-0.1,0.5-0.4,0.6-1c0-0.7-0.2-1.4-0.6-1.9c-0.4-0.6-1-1-1.7-1.1C1053.1-792.5,1052.7-792.5,1052.4-792.4"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1302",
    className: "st82",
    d: "M1050.5-789.7c0,0.7,0.3,1.4,0.8,1.9c0.6,0.7,1.5,0.9,1.9,0.6c0.4-0.3,0.2-1.2-0.7-2 C1052-789.7,1051.2-789.8,1050.5-789.7"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1303",
    className: "st82",
    d: "M1048.7-786.8c0.1,0.1,0.2,0.3,0.3,0.4c0.2,0.3,0.4,0.5,0.6,0.6c0.5,0.3,1,0.5,1.3,0.3 c0.3-0.2,0.1-1-0.6-1.4C1049.8-787.1,1049.2-787.1,1048.7-786.8"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1304",
    className: "st82",
    d: "M1044.6-820.9c-0.1,0.2-0.1,0.4-0.2,0.7c-0.1,0.4-0.1,0.8,0,1.2c0.2,0.8,0.6,1.4,1.1,1.5 c0.5,0.1,1-0.9,0.6-2c-0.2-0.5-0.5-0.9-0.9-1.1C1045.1-820.7,1044.8-820.8,1044.6-820.9"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1305",
    className: "st82",
    d: "M1041.9-820.4c-0.1,0.6,0,1.3,0.3,1.8c0.6,0.8,1.6,1.1,1.8,0.7s0-1-0.5-1.7 C1043.1-820,1042.5-820.3,1041.9-820.4"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1306",
    className: "st81",
    d: "M1066.4-819.9c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0-0.5,0-0.8,0.1c-0.7,0.3-1.3,0.8-1.6,1.5 c-0.7,1.5-0.3,3.2,0.5,3.2c0.8,0,1.5-0.8,2.1-2.1S1066.2-819.8,1066.4-819.9"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1307",
    className: "st81",
    d: "M1060.9-818c-0.5,0.5-0.8,1.1-0.9,1.9c0,1,0.4,1.8,0.9,1.8s0.9-0.8,0.9-1.8 C1061.7-816.9,1061.4-817.5,1060.9-818"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1308",
    className: "st81",
    d: "M1042.9-780c-0.1,0.3-0.1,0.7-0.1,1c0,0.6,0.1,1.2,0.4,1.8c0.6,1.1,1.3,1.8,2,1.8 c0.7,0,1.1-1.6,0.3-3c-0.4-0.6-0.9-1.1-1.6-1.3C1043.6-779.9,1043.2-780,1042.9-780"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1309",
    className: "st81",
    d: "M1046.2-779.7c-0.3,0.6-0.3,1.4-0.1,2c0.5,0.9,1.2,1.5,1.7,1.2c0.4-0.3,0.4-1.2,0-2 C1047.5-779,1046.9-779.5,1046.2-779.7"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1310",
    className: "st40",
    d: "M1078.2-711.4c1.3-0.7,2-3.2,1.4-4.9c-0.8-2.3-1.6-1.1-2.8-0.1c0.8-4.2,0.8-11.4-1.4-14.7 c-1.8-2.8-5.4,0.5-6.6,3.3c-0.9-1.9-1.4-4.2-3.4-3.9c-1.2,0.2-1.9,1.9-3.1,2.4c0.8-4.2-1-11.7-3.9-13.1c-3.6-1.7-4.9,4.2-4.9,8.2 c-1.2-6.6-4.5-0.8-5.8,2.1c-0.8-1.1-1.2-3-2.5-2.4c-0.9,0.3-1.6,2.3-1.8,3.6c-0.5-4.6-4.5-11.4-7.9-9.9 c-3.3,1.4-3.2,6.5-3.3,10.7c-0.9-2.8-4.2-2.4-5.4-0.4c-1.2,1.9-1.1,6.4,0,8.5c-1.7-2.1-3.3-6.3-5.8-4.6 c-3.3,2.2-0.8,7.3-0.2,10.7c-0.4-2.1-5.2-1.7-5.4,0.7c-0.2,2.1,2.5,3.7,3.8,3.9H1078.2z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1311",
    className: "st83",
    d: "M947.3-815.6l18.5-11.9v-24.9l-18.5,11.9V-815.6z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1312",
    className: "st84",
    d: "M947.3-815.6l18.5-11.9v-18.7l-18.5,11.9V-815.6z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1313",
    className: "st41",
    d: "M946-838.2l21.2-11.9v-3.2L946-841.4V-838.2z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1314",
    className: "st84",
    d: "M934.1-815l48.6-33.9l48.6,33.9h0.2v0.2l0.1,0.1h-0.1v103.4h-97.9V-815H934.1z"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1857",
    x: 1009.3,
    y: -828.1,
    className: "st83",
    width: 3.2,
    height: 55.8
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1858",
    x: 952.7,
    y: -828.1,
    className: "st83",
    width: 3.2,
    height: 55.8
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1859",
    x: 933.6,
    y: -778.9,
    className: "st83",
    width: 98,
    height: 15.2
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1860",
    x: 1027.4,
    y: -815.6,
    className: "st83",
    width: 4,
    height: 92.8
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1861",
    x: 933.6,
    y: -814.8,
    className: "st83",
    width: 4,
    height: 92.8
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1862",
    x: 1014.1,
    y: -752.4,
    className: "st83",
    width: 1.8,
    height: 12.8
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1863",
    x: 991.2,
    y: -752.4,
    className: "st83",
    width: 1.8,
    height: 12.8
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1864",
    x: 932.4,
    y: -724.7,
    className: "st83",
    width: 101.4,
    height: 13.3
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1865",
    x: 993.9,
    y: -751.1,
    className: "st85",
    width: 19.1,
    height: 36.4
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1866",
    x: 995.2,
    y: -749,
    className: "st41",
    width: 16.6,
    height: 33.4
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1867",
    x: 992.1,
    y: -718,
    className: "st38",
    width: 22.8,
    height: 6.7
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1868",
    x: 996.6,
    y: -747.2,
    className: "st36",
    width: 13.7,
    height: 9.1
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1315",
    className: "st37",
    d: "M1000.1-747.2h7.6l2.6,4.1v5h-4.4L1000.1-747.2z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1316",
    className: "st37",
    d: "M996.6-744.5v-2.7h1.7l5.9,9.1h-3.4L996.6-744.5z"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1869",
    x: 1003.1,
    y: -747.7,
    className: "st41",
    width: 0.8,
    height: 11
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1870",
    x: 996.1,
    y: -742.9,
    className: "st41",
    width: 14.8,
    height: 0.7
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1317",
    className: "st41",
    d: "M982.7-846.2l55.7,38.8l4.4-2.5l-60.1-41.8L982.7-846.2z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1318",
    className: "st41",
    d: "M982.7-846.2L927-807.4l-4.4-2.5l60.1-41.8L982.7-846.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2896",
    transform: "translate(989.319 129.312)",
    className: "st86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2895",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000108284523424211137770000007909753021719284886_",
    x: 1,
    y: -884,
    width: 26.4,
    height: 7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048496529106773915090000014131730370959251112_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108284523424211137770000007909753021719284886_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2894",
    style: {
      clipPath: "url(#SVGID_00000048496529106773915090000014131730370959251112_)"
    }
  }, _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1871",
    x: 1,
    y: -884,
    className: "st88",
    width: 26.4,
    height: 7
  })))))), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1873",
    x: 942.6,
    y: -754.7,
    className: "st83",
    width: 39.7,
    height: 20.3
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1874",
    x: 944.5,
    y: -752.4,
    className: "st85",
    width: 35.1,
    height: 16
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1875",
    x: 945.2,
    y: -751.7,
    className: "st41",
    width: 33.7,
    height: 14.6
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1876",
    x: 947.7,
    y: -750.2,
    className: "st36",
    width: 29.2,
    height: 13.1
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1319",
    className: "st37",
    d: "M959.6-750.2l9.9,13.1h7.3v-6.9l-4.7-6.2L959.6-750.2z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1320",
    className: "st37",
    d: "M961-737.2h5.6l-9.9-13.1h-5.6L961-737.2z"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1877",
    x: 968.8,
    y: -750.7,
    className: "st41",
    width: 0.8,
    height: 13.6
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1878",
    x: 955.4,
    y: -750.7,
    className: "st41",
    width: 0.8,
    height: 13.6
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1879",
    x: 943.6,
    y: -738.6,
    className: "st38",
    width: 36.8,
    height: 1.9
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1321",
    className: "st83",
    d: "M999.3-788v-27.7l-16.6-13.2l-16.7,13.2v27.7H999.3z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1322",
    className: "st85",
    d: "M997.3-789.9v-24.8l-14.7-11.7l-14.8,11.7v24.8H997.3z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1323",
    className: "st41",
    d: "M982.6-823.9l12.8,10.2v22h-25.7v-22L982.6-823.9z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1324",
    className: "st36",
    d: "M994.5-792.7v-20.6l-11.9-9.4l-11.9,9.4v20.6H994.5z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1325",
    className: "st37",
    d: "M970.7-813.3l1.7-1.3l22.1,16.9v5h-0.7l-23.1-17.6V-813.3z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1326",
    className: "st37",
    d: "M980-820.7l14.4,11v9.4L974-815.9L980-820.7z"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1880",
    x: 990.3,
    y: -761.1,
    className: "st89",
    width: 26.4,
    height: 10.9
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1881",
    x: 989.9,
    y: -751.7,
    className: "st38",
    width: 27.3,
    height: 2.1
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1327",
    className: "st83",
    d: "M1031.6-812.2l-48.9-27.6l-49.3,28l49.3-34.3L1031.6-812.2z"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1882",
    x: 1006.9,
    y: -774.4,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1883",
    x: 1000.9,
    y: -772,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1884",
    x: 961,
    y: -776,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1885",
    x: 971,
    y: -772.9,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1886",
    x: 942.6,
    y: -772.3,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1887",
    x: 948.1,
    y: -770,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1888",
    x: 959.4,
    y: -722.5,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1889",
    x: 965.4,
    y: -720.1,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1890",
    x: 982.3,
    y: -722.5,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1891",
    x: 942.6,
    y: -718.1,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1892",
    x: 1023.8,
    y: -720.4,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1893",
    x: 1018.3,
    y: -718.1,
    className: "st84",
    width: 7.2,
    height: 3.1
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1894",
    x: 982,
    y: -822.7,
    className: "st41",
    width: 1.1,
    height: 30.8
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1328",
    className: "st29",
    d: "M965-711.4c0.8-1.9,3.9-4.2,1.9-6.8c-1.6-2.1-3.6,0.2-4.7,1.7c0.7-1.3,0.2-2.9-1.2-3.6 c-0.3-0.1-0.6-0.2-0.9-0.3c-0.2-1.8,0.4-9.1-1.9-9.5c-1.5-0.3-3,5.8-4.3,6.8c-0.2-2.8,0.8-5.7,0.7-8.9c-0.1-3.4-0.3-6.7-1.8-9.7 c-3-5.7-7.4-3.4-6.9,3.3c-0.3-1.1-1-2.1-2-2.7c-1.7,2.6-1.7,6-2.4,9.1c-0.3-2.4-1.8-2.6-3.3-1.5c-2.1,1.5-1,3.7-2,5.5 c0.1-9.3-12.4-9.4-12.7,0.5c-1.4-5.8-8.1-3.1-6.4,3.3c-0.9-0.7-4.1-2.3-5.2-1.9c-2.3,0.9-2.5,4-0.7,5.8c-1.4-0.4-4.6,1-5.4,2.9 c-1,2.4,0.3,6.4,2.6,6L965-711.4z"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1895",
    x: 1069.7,
    y: -724.6,
    className: "st19",
    width: 4.9,
    height: 25.5
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1896",
    x: 1059.7,
    y: -724.6,
    className: "st19",
    width: 4.9,
    height: 25.5
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1897",
    x: 1048.6,
    y: -724.6,
    className: "st19",
    width: 4.9,
    height: 25.5
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1898",
    x: 1038.6,
    y: -724.6,
    className: "st19",
    width: 4.9,
    height: 25.5
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1899",
    x: 1028.5,
    y: -724.6,
    className: "st19",
    width: 4.9,
    height: 25.5
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1900",
    x: 1017.3,
    y: -724.6,
    className: "st19",
    width: 4.9,
    height: 25.5
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1901",
    x: 1017.3,
    y: -719.1,
    className: "st19",
    width: 57.3,
    height: 2.4
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1329",
    className: "st23",
    d: "M311.2-699.4c5.9-2.6-1.3-16.5-5.6-6.9c-0.5-1.9-1.4-4.1-3-5.2c-0.8,0.3-1.5,0.9-2,1.6 c-0.7-3.2-1.9-8.1-4.7-10c-2.5-1.8-6.1-1.3-7.9,1.2c-0.2,0.3-0.4,0.6-0.6,1c0.4-2.9-2.1-5.1-4.5-3c-2.8,2.3-1.8,5.7-3.3,8.3 c-1.5-5.5-9.1,0.2-9.3,3.9c-2.4-3.8-6.2,3.9-6,6.1c-3.8-0.7-1.8,3.9-1,2.9L311.2-699.4z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1330",
    className: "st90",
    d: "M315.8-699.3C330.7-713,378.5-723,435.2-723s104.5,10,119.4,23.7L315.8-699.3z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1331",
    className: "st22",
    d: "M472.8-752c7.1-0.9,13.3-4.4,14.5-10.7c1.5-8.1-7.8-14.8-5.3-22.9 c1.5-4.7,4.7-8.6,2.8-12.9c-2.4-5.7-8.2-11.1-10.1-16.9c-1.4-4.4-6.3-9.6-12.6-7.9c-6.4,1.7-6.5,9.5-9.8,13.5 c-3.8,4.5-11.3,7.5-11.5,13.7c-0.2,5.9,7.2,10,7,15.6c-0.2,6-9.2,9.3-8.7,15.9c0.9,11,22.1,13.3,31.6,12.8 C471.5-751.8,472.2-751.9,472.8-752"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1332",
    className: "st91",
    d: "M464.9-716.4l-5.4-3.7l3.5-82.9c0.9,0.6,3.3,8.4,2,22.8V-716.4z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1333",
    className: "st22",
    d: "M498.4-739.5c4.8-0.6,9.1-3,9.9-7.3c1-5.6-5.3-10.1-3.6-15.6c1-3.2,3.2-5.9,1.9-8.8 c-1.7-3.9-5.6-7.6-6.9-11.5c-1-3-4.3-6.6-8.6-5.4c-4.4,1.2-4.4,6.5-6.7,9.2c-2.6,3.1-7.7,5.1-7.8,9.3c-0.1,4,4.9,6.8,4.8,10.7 c-0.2,4.1-6.3,6.4-5.9,10.9c0.6,7.5,15.1,9.1,21.6,8.7C497.5-739.4,498-739.4,498.4-739.5"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1334",
    className: "st23",
    d: "M496.3-751.3c8.6-2.9,0.9-18.3,7.7-24.3c1,1.4,1.9,2.9,2.7,4.4c1.3,3-0.9,5.6-1.9,8.8 c-1.7,5.5,4.6,10,3.6,15.6c-0.8,4.3-5,6.7-9.9,7.3c-0.4,0.1-0.9,0.1-1.3,0.1c-6.5,0.4-21-1.2-21.6-8.7c-0.1-1.5,0.5-3,1.5-4.1 C483.9-753.8,491.2-750,496.3-751.3"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1335",
    className: "st91",
    d: "M493-715.2l-3.7-2.5l1.2-51.5c0.6,0.4,2.5,5.9,2.5,10.6L493-715.2z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1336",
    className: "st91",
    d: "M492.7-752.5c2.3,0,4.9-0.9,5.9-3.1c1.1-2.4,0.8-5.2,0.6-7.8c-0.2-1.4-0.2-2.8-0.1-4.2 l-1.6-0.1c-0.1,1.5,0,3,0.2,4.5c0.2,2.4,0.4,5-0.5,7c-0.7,1.6-3,2.2-4.9,2.1l-0.1,1.6C492.3-752.5,492.5-752.5,492.7-752.5"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1337",
    className: "st91",
    d: "M490.8-741.4l1-1.3c-0.8-0.6-1.8-0.9-2.9-0.9c-1.2-0.1-1.9-0.2-2.4-0.8 c-0.7-0.9-0.5-2.1-0.3-3.3c0.1-0.7,0.2-1.3,0.1-2l-1.6,0.1c0,0.6,0,1.2-0.1,1.7c-0.2,1.4-0.4,3.1,0.6,4.5c0.9,1,2.2,1.6,3.5,1.5 C489.5-741.9,490.2-741.7,490.8-741.4"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1338",
    className: "st91",
    d: "M494.6-731.7c2,0,4-0.3,5.3-2.3c1-1.6,1.1-3.9,1.3-5.9c0-0.5,0.1-1,0.1-1.4 c0.1-1.1,0.1-2.1,0.2-3.2c0-0.9,0-1.9,0.1-2.8l-1.6-0.1c-0.1,1-0.1,1.9-0.1,2.9c0,1-0.1,2.1-0.2,3.1c0,0.4-0.1,0.9-0.1,1.5 c-0.1,1.8-0.2,3.8-1,5.1c-1,1.6-2.9,1.6-5,1.5c-0.5,0-1,0-1.5,0l0,1.6c0.4,0,0.9,0,1.4,0C493.9-731.7,494.3-731.7,494.6-731.7"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1339",
    className: "st91",
    d: "M503-739.9c0.9,0.1,1.8-0.4,2.2-1.2c0.9-1.6,0.6-4.6,0.3-5.8l-1.6,0.4 c0.3,1.2,0.4,3.6-0.1,4.6c-0.2,0.4-0.5,0.4-1.5,0.3c-0.5-0.1-1-0.1-1.5,0l0.3,1.6c0.3,0,0.7,0,1,0 C502.3-739.9,502.6-739.9,503-739.9"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1340",
    className: "st91",
    d: "M490.2-763.8l0.6-1.5c-0.2-0.1-0.4-0.2-0.7-0.2c-1.3-0.5-2-0.8-2.3-1.9 c-0.2-1-0.3-2-0.2-3c0-0.3,0.1-0.6,0.2-1c0.2-0.6,0.2-1.2,0.2-1.8l-1.6,0.1c0,0.4-0.1,0.9-0.2,1.3c-0.1,0.4-0.2,0.8-0.2,1.2 c-0.2,1.2-0.1,2.5,0.2,3.7c0.6,2,2,2.5,3.3,2.9L490.2-763.8z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1341",
    className: "st91",
    d: "M464.5-785.2c2.3,0,5.2-0.3,6.6-2.3c0.8-1.4,1.3-2.9,1.4-4.5l0-0.6c0.2-2.3,0.2-4.7,0-7 l-1.6,0.2c0.2,2.2,0.2,4.5,0,6.7l0,0.6c-0.1,1.3-0.5,2.5-1.1,3.7c-1,1.4-3.3,1.6-5.3,1.6C464.5-786.9,464.5-785.2,464.5-785.2"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1342",
    className: "st91",
    d: "M463.1-794c0.1,0,0.3,0,0.4,0l-0.2-1.6c-1,0-2-0.4-2.6-1.2c-0.7-1-0.6-2.6-0.5-4.2 c0-0.7,0.1-1.3,0.1-1.9l-1.6,0c0,0.5,0,1.1-0.1,1.7c-0.1,1.7-0.3,3.7,0.8,5.3C460.2-794.7,461.6-794,463.1-794"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1343",
    className: "st91",
    d: "M463-764l0-1.6c-1.1,0-2.3-0.2-3.4-0.5c-0.3-0.1-0.6-0.2-1-0.3c-1.2-0.2-2.3-0.7-3.3-1.5 c-1-0.9-1.2-2.3-1.3-3.8c-0.2-2.1-0.2-4.2-0.1-6.2v-0.2l-1.6,0v0.2c0,2.1,0,4.3,0.1,6.4c0.2,1.8,0.4,3.7,1.8,4.9 c1.2,0.9,2.5,1.5,3.9,1.8c0.3,0.1,0.6,0.2,0.9,0.3C460.4-764.2,461.7-764,463-764"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1344",
    className: "st91",
    d: "M452.7-770.4c0.1,0,0.1,0,0.2,0l-0.1-1.6c-0.5,0-0.9-0.1-1.3-0.4c-1.1-1-1.1-3.5-1.2-4.3 l-1.6,0.1c0.1,1.7,0.3,4.1,1.7,5.4C451.1-770.7,451.9-770.4,452.7-770.4"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1345",
    className: "st91",
    d: "M469-748.6c1,0,2.1-0.2,3-0.6c1.8-0.9,2.9-2.7,2.9-4.8l0-0.2c0.3-2.1,0.2-4.2-0.3-6.3 L473-760c0.4,1.9,0.5,3.8,0.2,5.7l0,0.2c0,1.4-0.8,2.7-2,3.4c-1.6,0.7-3.9,0.3-6,0c-0.6-0.1-1.1-0.2-1.7-0.3l-0.2,1.6 c0.5,0.1,1,0.2,1.6,0.3C466.3-748.8,467.6-748.6,469-748.6"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1346",
    className: "st91",
    d: "M475.3-754.9c1.1,0,2.2-0.5,3-1.2c1-1.3,1.3-3.1,0.7-4.7l-1.4,0.8c0.2,1,0.1,2-0.5,2.8 c-0.6,0.5-1.3,0.7-2.1,0.7l-1.1,1.2C474.3-755,474.8-754.9,475.3-754.9"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1347",
    className: "st23",
    d: "M508.6-775.7c-0.4,0.2-0.8,0.3-1.2,0.5c-0.7,0.3-1.4,0.8-1.9,1.5c-1,1.5-1.2,3.5-0.3,3.8 c0.5,0.2,1.1,0,1.5-0.3c0.7-0.4,1.2-1,1.6-1.6c0.5-0.8,0.7-1.7,0.6-2.6C508.9-774.8,508.8-775.3,508.6-775.7"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1348",
    className: "st23",
    d: "M507.9-767.4c-0.4,0-0.7,0.1-1.1,0.2c-0.7,0.2-1.4,0.6-1.9,1.1c-1,1.2-1.4,2.3-0.9,3 c0.4,0.7,2.1,0.3,3.2-1.1c0.5-0.6,0.7-1.3,0.8-2.1C508-766.7,508-767.1,507.9-767.4"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1349",
    className: "st23",
    d: "M508.9-755.7c-0.9-0.4-2-0.3-2.9,0.2c-1.3,0.8-1.8,2.3-1.2,2.7c0.4,0.2,0.8,0.2,1.2,0.1 c0.5-0.2,1-0.4,1.4-0.7C508.2-754,508.7-754.8,508.9-755.7"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1350",
    className: "st23",
    d: "M509.9-749.6c-0.4-0.3-0.9-0.3-1.4-0.2c-0.7,0.3-1.1,0.9-0.9,1.1c0.2,0.3,0.8,0.3,1.4,0 C509.5-748.8,509.9-749.6,509.9-749.6"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1351",
    className: "st23",
    d: "M474.6-745.9c0.2,0.2,0.5,0.4,0.8,0.5c0.5,0.3,1,0.5,1.6,0.6c1.3,0.1,2.7-0.7,2.4-1.3 c-0.1-0.4-0.4-0.6-0.8-0.8c-0.5-0.2-1-0.3-1.5-0.3c-0.7,0-1.3,0.2-1.8,0.6C475-746.4,474.8-746.1,474.6-745.9"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1352",
    className: "st23",
    d: "M476.4-740.8c0.4,0.2,0.8,0.4,1.2,0.6c0.8,0.4,1.7,0.5,2.6,0.3c2-0.5,3.4-2,2.9-2.8 c-0.5-0.9-2-1-3.7-0.6c-0.8,0.2-1.6,0.7-2.2,1.4C476.9-741.6,476.6-741.2,476.4-740.8"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1353",
    className: "st23",
    d: "M474.8-750.2c0.4,0.6,1,1.1,1.7,1.2c1,0.2,1.8-0.1,2-0.6c0.1-0.5-0.6-1-1.7-1.2 C476.1-750.8,475.4-750.6,474.8-750.2"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1354",
    className: "st23",
    d: "M484.8-755.6c-0.2,0.2-0.4,0.4-0.5,0.7c-0.3,0.5-0.5,1.1-0.5,1.7c0,1.2,0.6,2.1,1.2,2.2 s1.1-1,1-2.3c-0.1-0.6-0.3-1.1-0.6-1.5C485.2-755.2,485-755.4,484.8-755.6"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1355",
    className: "st30",
    d: "M472.7-811.4c-0.3,0.2-0.6,0.4-0.8,0.6c-0.5,0.4-0.9,0.8-1.2,1.4 c-0.5,1.2-0.6,2.6,0.1,2.9c0.7,0.3,1.7-0.5,2.3-1.8c0.3-0.7,0.3-1.4,0-2.1C473-810.8,472.9-811.1,472.7-811.4"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1356",
    className: "st30",
    d: "M468-815.9c-0.3,0.3-0.7,0.6-0.9,1c-0.5,0.7-0.9,1.5-1.1,2.3c-0.1,0.7-0.1,1.4,0,2.1 c0,0.5,0.3,1,0.7,1.4c0.4,0.3,1,0.2,1.6-0.4c0.7-0.7,1.1-1.7,1.2-2.7c0.1-1-0.2-1.9-0.7-2.7C468.6-815.2,468.3-815.6,468-815.9"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1357",
    className: "st30",
    d: "M463.2-815.7c-0.7,0.7-1,1.7-0.9,2.7c0.3,1.4,1.1,2.5,1.7,2.3s1-1.4,0.8-2.7 C464.6-814.3,464-815.2,463.2-815.7"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1358",
    className: "st30",
    d: "M457.5-791.8c0,0-0.2,0.6-0.3,1.2c-0.2,0.7-0.2,1.4-0.1,2.2c0.3,1.5,0.9,2.8,1.8,2.9 c0.9,0.1,1.7-1.5,1.4-3.5c-0.2-0.9-0.8-1.7-1.6-2.2C458.3-791.5,457.9-791.7,457.5-791.8"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1359",
    className: "st30",
    d: "M453-791.2c-0.1,0.4-0.2,0.9-0.2,1.3c-0.1,0.8,0,1.7,0.3,2.5c0.7,1.7,2.1,3,2.9,2.5 s1-2.1,0.3-3.9c-0.4-0.9-1.1-1.6-2-2C453.9-791,453.4-791.1,453-791.2"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1360",
    className: "st30",
    d: "M449.3-788.3c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.6,0.1,1.2,0.4,1.8c0.8,1.2,2.3,1.8,2.6,1.2 c0.2-0.3,0.2-0.7,0.1-1.1c-0.1-0.5-0.4-1-0.7-1.4c-0.4-0.5-0.9-0.9-1.4-1.1C449.9-788.2,449.6-788.3,449.3-788.3"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1361",
    className: "st30",
    d: "M476.4-784.3c-1.4,0.5-2.6,1.4-3.3,2.6c-0.9,1.9-0.8,3.7,0.1,4.2s2.4-0.7,3.3-2.6 C477-781.4,477-782.9,476.4-784.3"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1362",
    className: "st30",
    d: "M479.4-781.4c0,0-0.4,0.1-0.9,0.3c-0.6,0.2-1.1,0.5-1.5,1c-0.4,0.5-0.7,1.2-0.7,1.9 c0,0.6,0.3,1,0.6,1c0.4,0,0.7-0.1,1-0.4c0.4-0.3,0.8-0.7,1.1-1.1c0.4-0.5,0.5-1.2,0.5-1.8C479.6-780.8,479.5-781.1,479.4-781.4"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1363",
    className: "st30",
    d: "M481.5-798.2c-0.4,0-0.7,0-1,0.2c-0.7,0.3-1.2,0.9-1.5,1.6c-0.5,1.4-0.4,2.3,0.1,2.8 c0.3,0.2,0.7,0.2,1.2-0.2c0.5-0.4,0.9-1,1.2-1.7c0.2-0.6,0.2-1.2,0.1-1.8C481.5-797.7,481.5-798.2,481.5-798.2"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1364",
    className: "st30",
    d: "M447.4-764.7c0,0.3,0,0.6,0.1,0.9c0.1,0.6,0.2,1.1,0.5,1.6c0.6,0.9,1.4,1.6,2.1,1.4 c0.6-0.2,0.7-1.5-0.1-2.7c-0.4-0.5-1-0.9-1.6-1C448-764.7,447.7-764.7,447.4-764.7"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1365",
    className: "st30",
    d: "M443.1-763.3c0.1,0.3,0.1,0.7,0.2,1c0.2,0.6,0.5,1.2,1,1.6c1.2,0.9,2.4,1.2,2.9,0.7 s-0.1-1.8-1.2-2.7c-0.6-0.4-1.3-0.6-2-0.7C443.7-763.4,443.4-763.4,443.1-763.3"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1366",
    className: "st22",
    d: "M502.6-785c-0.5,0-0.9,0.1-1.3,0.3c-0.9,0.3-1.7,0.8-2.3,1.6c-1.1,1.8-1.2,3.7-0.3,4.1 s2.4-0.5,3.3-2.1c0.5-0.7,0.7-1.6,0.7-2.5C502.7-784.1,502.6-784.6,502.6-785"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1367",
    className: "st22",
    d: "M498.7-789.2c-0.4,0.2-0.7,0.5-1.1,0.7c-0.6,0.5-1.1,1.2-1.4,2c-0.5,1.6-0.6,2.8,0.1,3.5 c0.4,0.3,0.9,0.2,1.5-0.2c0.7-0.6,1.3-1.4,1.6-2.3C499.7-786.7,499.5-788.1,498.7-789.2"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1368",
    className: "st22",
    d: "M483.4-783c0,0,0,0.5,0.1,1.1c0,0.7,0.2,1.3,0.6,1.9c0.7,1.2,1.5,2,2.4,1.9 c0.4-0.1,0.7-0.5,0.7-1.1c0-0.8-0.2-1.6-0.6-2.3c-0.5-0.7-1.2-1.2-2-1.4C484.2-783,483.8-783,483.4-783"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1369",
    className: "st22",
    d: "M480.4-777.4c-0.3,0.8-0.3,1.6,0.1,2.4c0.6,0.9,1.1,1.5,1.8,1.4c0.3-0.1,0.5-0.4,0.5-0.8 c0-0.6-0.1-1.1-0.4-1.6C481.8-776.7,481.1-777.2,480.4-777.4"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1370",
    className: "st22",
    d: "M474.8-767.2c0.1,0.3,0.3,0.6,0.5,0.9c0.3,0.5,0.8,1,1.3,1.3c1.1,0.6,2.3,0.9,2.8,0.3 c0.5-0.5-0.1-1.9-1.5-2.6c-0.6-0.3-1.4-0.4-2.1-0.2C475.4-767.5,475.1-767.4,474.8-767.2"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1371",
    className: "st25",
    d: "M498.2-780.8c-0.7,0.6-1.2,1.4-1.4,2.3c-0.1,1.2,0,2.2,0.6,2.5c0.6,0.3,1.7-0.7,1.8-2.2 C499.3-779.2,499-780.1,498.2-780.8"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1372",
    className: "st25",
    d: "M495.2-780.8c-0.8,0.7-1.2,1.7-1.3,2.7c0,1.4,0.6,2.5,1.3,2.6s1.4-1.1,1.4-2.7 c0-0.7-0.3-1.3-0.7-1.8C495.7-780.3,495.5-780.6,495.2-780.8"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1373",
    className: "st25",
    d: "M490.9-779.3c0,0.6,0.1,1.3,0.3,1.9c0.4,0.8,1,1.4,1.5,1.2c0.5-0.1,0.7-1.1,0.1-2.1 C492.4-778.9,491.7-779.3,490.9-779.3"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1374",
    className: "st25",
    d: "M489.2-778.4c-0.1,0.6-0.1,1.2,0.2,1.7c0.4,0.7,1.1,1.1,1.5,0.8s0.3-1-0.2-1.7 C490.3-778,489.7-778.3,489.2-778.4"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1375",
    className: "st25",
    d: "M501.2-777.3c0,0-0.2,0.2-0.4,0.4c-0.2,0.2-0.5,0.4-0.6,0.7c-0.3,0.6-0.5,1.3-0.2,1.5 c0.3,0.2,1-0.1,1.4-0.8c0.2-0.4,0.2-0.8,0.1-1.2C501.4-777,501.3-777.1,501.2-777.3"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1376",
    className: "st25",
    d: "M495.9-771.8c-0.7,0.6-1.2,1.4-1.5,2.3c-0.2,1.2-0.1,2.1,0.5,2.5c0.3,0.2,0.7,0.1,1.1-0.3 c0.5-0.5,0.8-1.2,0.9-1.8C497-770.1,496.6-771.1,495.9-771.8"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1377",
    className: "st25",
    d: "M492-771.5c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.4-0.2,0.9-0.1,1.4c0.1,0.9,0.7,1.7,1.2,1.7 c0.5,0,0.8-1,0.6-2.1c-0.2-0.5-0.5-0.9-0.9-1.2C492.5-771.2,492.3-771.4,492-771.5"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1378",
    className: "st22",
    d: "M482.4-807.7c-0.4,0-0.7,0.1-1.1,0.3c-0.7,0.3-1.3,0.7-1.7,1.3c-0.8,1.2-1.2,2.3-0.7,3 c0.3,0.3,0.7,0.4,1.3,0.1c0.7-0.3,1.3-0.8,1.8-1.5c0.4-0.6,0.6-1.4,0.5-2.1C482.5-806.9,482.5-807.3,482.4-807.7"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1379",
    className: "st22",
    d: "M479.5-809.6c-0.2,0.2-0.4,0.4-0.6,0.5c-0.4,0.2-0.7,0.6-1,1c-0.3,0.5-0.5,1.1-0.4,1.7 c0.1,0.6,0.4,0.9,0.7,0.8c0.3-0.1,0.6-0.3,0.8-0.5c0.3-0.3,0.6-0.6,0.8-1c0.3-0.5,0.3-1.2,0.2-1.8 C479.9-809.1,479.7-809.3,479.5-809.6"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1380",
    className: "st22",
    d: "M477-813.2c-0.2,0.1-0.4,0.2-0.5,0.4c-0.3,0.3-0.6,0.7-0.7,1.2c-0.2,0.9,0.1,1.7,0.6,1.8 c0.5,0.1,1-0.6,1.1-1.6c0.1-0.4,0-0.8-0.2-1.2C477.2-812.8,477.1-813,477-813.2"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1381",
    className: "st22",
    d: "M451.6-811c0,0.4,0.1,0.7,0.1,1.1c0.1,0.7,0.3,1.3,0.7,1.9c0.8,1.1,1.8,2,2.6,1.7 c0.7-0.3,0.9-1.8-0.2-3.4c-0.5-0.7-1.2-1.1-2-1.2C452.3-811,452-811.1,451.6-811"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1382",
    className: "st22",
    d: "M447.8-809.5c0.1,0.3,0.1,0.6,0.2,0.8c0.2,0.5,0.4,1,0.8,1.3c0.9,0.8,2.1,1.1,2.4,0.6 c0.3-0.5,0-1.4-0.9-2.3C449.6-809.5,448.7-809.7,447.8-809.5"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1383",
    className: "st22",
    d: "M459.4-824.8c-0.1,0.3-0.3,0.6-0.3,0.9c-0.2,0.6-0.2,1.3,0,1.9c0.1,0.5,0.4,1,0.6,1.4 c0.2,0.4,0.5,0.6,0.9,0.7c0.4,0,0.7-0.2,0.9-0.8c0.3-0.7,0.3-1.5,0-2.2c-0.2-0.7-0.7-1.2-1.3-1.6 C460-824.5,459.7-824.6,459.4-824.8"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1384",
    className: "st22",
    d: "M463.5-825.1c-1.1,0.8-1.3,2.3-0.5,3.4c0.1,0.1,0.1,0.2,0.2,0.3c0.4,0.3,0.8,0.4,1,0.2 c0.2-0.2,0.3-0.5,0.3-0.8c0.1-0.4,0.1-0.8,0-1.2C464.3-823.9,464-824.6,463.5-825.1"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1385",
    className: "st22",
    d: "M467.6-826c-0.3,0-0.6,0-0.9,0.1c-0.6,0.2-1.1,0.7-1.3,1.3c-0.5,1.3-0.1,2.6,0.5,2.6 s1.2-0.8,1.6-1.8c0.2-0.5,0.2-1,0.1-1.4C467.6-825.6,467.6-826,467.6-826"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1386",
    className: "st22",
    d: "M445.4-780.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.5,0.3,0.9,0.6,1.3 c0.7,0.8,1.4,1.3,2,1.1c0.7-0.1,0.6-1.6-0.3-2.6c-0.5-0.5-1.2-0.8-1.9-0.8c-0.3,0-0.6,0.1-0.8,0.3 C445.5-780.3,445.4-780.2,445.4-780.1"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1387",
    className: "st22",
    d: "M443.3-776.9c0.1,0.3,0.3,0.5,0.4,0.8c0.1,0.5,0.4,1,0.7,1.4c0.4,0.4,0.9,0.8,1.5,1 c0.2,0.1,0.5,0.1,0.8,0.1c0.2,0,0.3-0.1,0.4-0.3c0-0.2,0.1-0.3,0-0.5c0-0.2,0-0.4-0.1-0.5c-0.2-0.5-0.5-1-0.9-1.4 c-0.5-0.5-1.2-0.7-1.9-0.8c-0.2,0-0.5,0-0.7,0.1C443.5-776.9,443.4-776.9,443.3-776.9"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1388",
    className: "st22",
    d: "M440.7-774.5c0.1,0.2,0.1,0.4,0.2,0.6c0.2,0.4,0.5,0.7,0.9,0.9c0.9,0.5,2.1,0.3,2-0.2 c0-0.5-0.4-0.9-1.2-1.3c-0.4-0.2-0.8-0.2-1.2-0.2C441.1-774.6,440.9-774.6,440.7-774.5"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1389",
    className: "st22",
    d: "M486.9-792.6c-0.3-0.2-0.5-0.3-0.8-0.4c-0.6-0.2-1.2-0.2-1.9-0.1c-1.3,0.5-2.1,1.4-1.8,2 c0.3,0.6,1.4,0.7,2.6,0.2c0.5-0.2,1-0.6,1.3-1C486.6-792.1,486.8-792.3,486.9-792.6"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1902",
    x: 372.6,
    y: -759.3,
    className: "st92",
    width: 97.2,
    height: 49.2
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1903",
    x: 372.6,
    y: -759.3,
    className: "st93",
    width: 97.2,
    height: 8.4
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1390",
    className: "st41",
    d: "M346.9-754.8h125.8l-4.6-29.7H351.5L346.9-754.8z"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1904",
    x: 368.1,
    y: -756.9,
    className: "st42",
    width: 106.2,
    height: 3.2
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1905",
    x: 449.4,
    y: -794.8,
    className: "st83",
    width: 9.7,
    height: 23.3
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1906",
    x: 449.4,
    y: -789,
    className: "st84",
    width: 9.7,
    height: 17.6
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1907",
    x: 448.9,
    y: -795.7,
    className: "st41",
    width: 10.7,
    height: 3
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1391",
    className: "st84",
    d: "M348.2-755.3l26.6-29.5l26.6,29.5h0.1v0.1l0.1,0.1c-0.1,0-0.1,45-0.1,45h-53.6v-45.3 H348.2z"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1908",
    x: 347.9,
    y: -718.7,
    className: "st94",
    width: 121.9,
    height: 8.6
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1909",
    x: 347.9,
    y: -754.6,
    className: "st92",
    width: 53.5,
    height: 5
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1392",
    className: "st19",
    d: "M351.1-710.1h-3.2v-45.3l3.2-2.9V-710.1z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1393",
    className: "st19",
    d: "M401.5-710.1h-3.2v-48.2l3.2,2.2V-710.1z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1394",
    className: "st42",
    d: "M374.7-782.5l30.5,33.8l2.4-2.2l-32.9-36.4L374.7-782.5z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1395",
    className: "st42",
    d: "M374.7-782.5l-30.5,33.8l-2.4-2.2l32.9-36.4L374.7-782.5z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1396",
    className: "st93",
    d: "M383.2-723v-14.8c0-4.7-3.8-8.5-8.5-8.5c-4.7,0-8.5,3.8-8.5,8.5v14.8H383.2z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1397",
    className: "st19",
    d: "M374.7-745c4,0,7.2,3.2,7.2,7.2c0,0,0,0,0,0v13.5h-14.4v-13.5 C367.5-741.7,370.7-745,374.7-745C374.7-745,374.7-745,374.7-745"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1398",
    className: "st36",
    d: "M380.1-725.4l0-12.3c0-3-2.4-5.3-5.4-5.3c-2.9,0-5.3,2.4-5.3,5.3l0.1,12.3H380.1z"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1910",
    x: 374.4,
    y: -743.6,
    className: "st19",
    width: 0.7,
    height: 18.4
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1911",
    x: 365,
    y: -724.3,
    className: "st19",
    width: 19.5,
    height: 2.6
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1399",
    className: "st83",
    d: "M401.5-752.9l-26.7-24.9l-26.9,25.1l26.9-29.8L401.5-752.9z"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1912",
    x: 417.1,
    y: -770.2,
    className: "st93",
    width: 49.4,
    height: 21.9
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1913",
    x: 462.3,
    y: -754.5,
    className: "st19",
    width: 5.6,
    height: 41.8
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1914",
    x: 459.5,
    y: -724.7,
    className: "st38",
    width: 11.1,
    height: 14.6
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1915",
    x: 414.3,
    y: -754.5,
    className: "st19",
    width: 5.6,
    height: 41.8
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1916",
    x: 462.3,
    y: -754.5,
    className: "st38",
    width: 5.6,
    height: 4.8
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1917",
    x: 414.3,
    y: -754.5,
    className: "st38",
    width: 5.6,
    height: 4.8
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1918",
    x: 411.5,
    y: -724.7,
    className: "st38",
    width: 11.1,
    height: 14.6
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1400",
    className: "st41",
    d: "M412.5-752.7h57.2l-1.9-19h-53.4L412.5-752.7z"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1919",
    x: 412.4,
    y: -755.5,
    className: "st42",
    width: 57.7,
    height: 4.6
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1920",
    x: 464.5,
    y: -748.3,
    className: "st38",
    width: 1.4,
    height: 27
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1921",
    x: 416.3,
    y: -748.3,
    className: "st38",
    width: 1.4,
    height: 27
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1922",
    x: 459.5,
    y: -724.7,
    className: "st68",
    width: 11.1,
    height: 2.7
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1923",
    x: 411.5,
    y: -724.7,
    className: "st68",
    width: 11.1,
    height: 2.7
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1924",
    x: 432.3,
    y: -747.3,
    className: "st93",
    width: 17.9,
    height: 34.2
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1925",
    x: 433.5,
    y: -745.3,
    className: "st19",
    width: 15.5,
    height: 31.3
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1926",
    x: 430.6,
    y: -716.3,
    className: "st38",
    width: 21.4,
    height: 6.2
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1927",
    x: 434.8,
    y: -743.6,
    className: "st36",
    width: 12.9,
    height: 8.5
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1401",
    className: "st37",
    d: "M438.1-743.6h7.1l2.5,3.8v4.7h-4.1L438.1-743.6z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1402",
    className: "st37",
    d: "M434.8-741.1v-2.5h1.5l5.5,8.5h-3.2L434.8-741.1z"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1928",
    x: 440.9,
    y: -744.1,
    className: "st19",
    width: 0.8,
    height: 10.3
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1929",
    x: 434.3,
    y: -739.7,
    className: "st19",
    width: 13.8,
    height: 0.6
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1403",
    className: "st29",
    d: "M512.2-709.8c-0.2-2.3-0.2-6.4-1.7-8.4c-1.3-1.7-2.6-0.6-2.7,1.1 c-0.9-2.2-2.1-4.1-4.4-1.8c-0.4-1.5,0.2-3.2-0.2-4.8c-0.3-1.3-1-4.1-2.7-4.4c-0.7,1.4-0.1,3.3-1.6,4.2c0-0.2,0-0.3,0-0.5 c-1.9-0.5-2,2.3-2.2,3.4c-0.2-0.7-0.7-1.7-1.7-1.6c-1.1,0.2-1.5,1.7-2,2.4c-0.9-2.7-1.3-5.2-3.3-7.4c-1-1.1-1.3-1.4-2.5-0.7 c-0.9,0.4-1.5,1.2-1.7,2.2c1.3-0.8,0.3-4.4-0.2-5.5c-0.3-0.8-1-2.3-2-2.6c-1.2-0.4-0.7,0.3-1.5,0.7c-1.2,0.7-2-0.5-3.1,0.7 c-1.3,1.5-0.8,4.1-0.2,5.8c-0.7-1.2-2,1.5-2.3,2c-0.6,1.3-0.8,2.7-0.8,4.1c0.1-1.3-0.6-2-1.8-1.4c-1.1,0.6-1.6,2.4-1.5,3.5 c-0.9-1.2-0.5-3-1.8-4c-0.9-0.7-2.9-0.6-2.8,0.9c-1.4,0.1-1.6-3.9-2.8-4.7c-1.7-1.1-2.3,0.8-3.4,1.8c-0.1-1.2-0.5-2.3-1.1-3.2 c-0.6-0.7-2.4-1.4-2.7-0.1c-1.1-1.6-2.5-7.4-4.5-3.3c-0.4,1-0.7,2.1-0.9,3.2c-0.3,1.2,0.1,2.2,0,3.4c-0.8-0.4-1.7-0.2-2.3,0.4 c-1.3,1-0.5,1.9-1.1,3c-0.6,1.1-0.7,0.3-1.7,0.3c-1.5-0.1-1.8,0.8-2.5,1.9c-0.9,1.6-1.4,3.3-1.4,5.1c0,1.4-0.1,2.9-0.4,4.3 L512.2-709.8z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1404",
    className: "st95",
    d: "M677.3-699.2c2.7-1.7,0.3-16-4.8-11.4c-0.4-1.8-1.5-3.3-3-4.2c-1.7-0.8-2.3-0.1-3.6,1.1 c1.4-3.8-2-11.1-6.5-11c-1.8,0.2-3.4,1.2-4.2,2.8c-1,2.1-0.3,2.8-3.2,3.5c0.6-5.3-5.4-4.1-4.6-0.3c0.3-5.1-5.1-3.2-5.7,0.7 c-1.2-4-2-9.3-5.7-11.9c-3.5-2.4-4,1.2-5.7,3.3c0.3-2.6-2.6-3.2-4.4-2.3c-2.2,1.1-1.8,2.5-2.1,4.5c-2.9-3.3-3.4,1.2-3.8,3.5 c-0.5-2.5-3.1-3.5-4.7-1.8c-1.3,1.3-1.9,4.6-1.7,6.4c-0.6-3.9-3.7,2.7-3.4,2.6c-0.3-1.5-1.5-2.7-2.9-3.1c0.2,1-0.2,2.1-1.1,2.8 c-0.2-1.9-1.4-4.5-2.8-5.4c-2.4-1.5-4.5-0.4-5.8,1.8c0-1.7,0.2-3.9-1.2-5.3c-1.1-1.1-2.9-1.7-3.5,0.3c-0.7-3.9-7.4-5.1-6.6-0.4 c-2.7-3.8-5.5,0.7-5.4,3.7c-2.9-4.1-4.9,1.1-5,4.2c-1.9-0.2-5.6,2.8-6.6,5c-2.5,5.5,2.2,9.9,3.1,11L677.3-699.2z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1405",
    className: "st90",
    d: "M660.3-698.9c22.3-10.8,68.3-18.3,121.3-18.3s99,7.4,121.3,18.3H660.3z"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1930",
    x: 709.3,
    y: -793.4,
    className: "st96",
    width: 8.2,
    height: 28.8
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1931",
    x: 709.3,
    y: -793.4,
    className: "st97",
    width: 8.2,
    height: 4.4
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1932",
    x: 715.4,
    y: -796.7,
    className: "st97",
    width: 0.7,
    height: 5.5
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1933",
    x: 710.7,
    y: -796.7,
    className: "st97",
    width: 0.7,
    height: 5.5
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1406",
    className: "st96",
    d: "M717.9-795.4l-4.6-4.5l-4.6,4.5H717.9z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1407",
    className: "st28",
    d: "M831.2-749.3c7.1-2.5,13.1-7.3,14.5-15.7c1.2-7.3-3-13-7.8-17.9 c-3.1-3.2-2.1-7.2-3.1-11.3c-1.2-4.9-5.5-9.3-10.7-9.8c-5.2-0.5-6.3,4.3-8.5,7.8c-3,4.8-8,5.4-12.5,8c-5.3,3.1-1.4,10-3.1,15 c-1.8,5.3-4.6,8.5-2.6,14.3c2.6,7.5,12.7,11.5,19.2,11.6C821.6-747,826.5-747.8,831.2-749.3"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1408",
    className: "st29",
    d: "M802.9-787.9c7.1,2.5,8.6,5.9,10,19c2,9.8,19.7-2,29.5,3.9c0.7,0.7,1.8,1.5,2.7,2.3 c-2.1,6.9-7.5,11.1-13.9,13.3c-4.7,1.5-9.6,2.3-14.6,2.2c-6.5-0.1-16.5-4.1-19.2-11.6c-2-5.8,0.7-9,2.6-14.3 C801.8-778.1,798-784.8,802.9-787.9"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1409",
    className: "st26",
    d: "M825-713.5h-6.6l1.4-49.7c-0.5-12.3,2.6-14.3,3.7-13.9L825-713.5z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1410",
    className: "st26",
    d: "M822.4-756c2.7-0.4,5.4-0.9,7.2-3.2c2-2.6,2-6.3,2-9.6c0-0.7,0-1.4,0-2.1l-2-0.1 c0,0.7,0,1.4,0,2.2c0,2.9,0,6.3-1.6,8.4c-1.3,1.7-3.5,2.1-5.9,2.4L822.4-756z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1411",
    className: "st26",
    d: "M820.8-741.1c0.2,0,0.4,0,0.6,0l-0.1-2c-3.2,0.1-6.1-1.7-7.4-4.5c-1.5-3.5-1.8-7.3-1-11 l-1.9-0.3c-0.8,4.7-0.4,8.7,1.2,12.2C813.6-743.4,817-741.2,820.8-741.1"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1412",
    className: "st26",
    d: "M811.1-749.9c0.1,0,0.2,0,0.3,0l-0.2-2c-1.1-0.1-2.2-0.7-2.9-1.7c-0.5-0.9-0.9-2-1-3.1 c-0.1-0.4,0-0.9,0-1.3c0.1-0.5,0.1-1.1,0.1-1.6l-2,0.2c0,0.4,0,0.8,0,1.1c-0.1,0.6-0.1,1.3,0,1.9c0.2,1.3,0.6,2.6,1.3,3.8 C807.7-751,809.3-750.1,811.1-749.9"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1413",
    className: "st26",
    d: "M819.9-770.3l0.8-1.8c-0.9-0.3-1.8-0.8-2.5-1.5c-1-1.2-0.7-3.2,0-4.6l-1.7-0.9 c-1,1.9-1.3,4.8,0.2,6.8C817.5-771.5,818.6-770.7,819.9-770.3"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1414",
    className: "st28",
    d: "M847.2-705.7c1-2.8-2.3-8.6-5.5-8.5c-0.4,0.8-0.5,1.6-0.4,2.5c0.2-1.7-0.7-4.6-2.3-5.1 c-0.2,0.3-0.5,0.5-0.6,0.8c-1.3-2.3-0.9-5.3-3.7-6.8c-2-1.1-5.1,0.3-4.6,2.9c-1.2-2-3.1-5.7-6.1-4.3c-2.5,1.2-2.2,4.6-2.3,6.8 c-0.7-2.2-2.5-2.7-4.1-1.1c-1.7,1.7-1.4,4.1-1.4,6.3c-2.4-3.5-4.8,1.7-4.7,4c-1-0.5-1.7-1.6-2.6-0.1c-0.2,0.8-0.1,1.7,0.3,2.5 L847.2-705.7z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1415",
    className: "st29",
    d: "M797.8-784.8c-0.1,0.5,0,1,0,1.4c0.1,1,0.6,1.9,1.3,2.6c1.4,1.3,2.6,2,3.6,1.6 c0.5-0.2,0.7-0.8,0.5-1.6c-0.2-1-0.7-1.9-1.5-2.6c-0.7-0.6-1.6-1.1-2.5-1.2C798.8-784.7,798.3-784.8,797.8-784.8"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1416",
    className: "st29",
    d: "M797.3-779.2c0,0.4,0.1,0.8,0.2,1.2c0.2,0.8,0.5,1.5,1.1,2.1c1.2,1.2,2.8,1.9,3.4,1.2 c0.6-0.7,0.2-2.2-1.1-3.5c-0.6-0.6-1.5-1-2.3-1.1C798.1-779.3,797.7-779.3,797.3-779.2"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1417",
    className: "st29",
    d: "M811.7-783.5c-0.3,0.1-0.6,0.2-0.9,0.4c-0.5,0.2-1,0.6-1.3,1.1c-0.6,1.2-0.7,2.5-0.1,2.7 c0.6,0.2,1.6-0.5,2.1-1.5c0.3-0.6,0.4-1.2,0.3-1.8C811.9-782.9,811.8-783.2,811.7-783.5"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1418",
    className: "st29",
    d: "M840.6-771c0,0-0.5,0.4-1.2,0.9c-0.8,0.5-1.4,1.2-1.8,2c-0.5,0.9-0.7,2-0.6,3 c0.1,0.9,0.6,1.5,1.1,1.5c0.6,0,1.2-0.3,1.5-0.8c0.6-0.6,1.1-1.3,1.5-2.1c0.4-1,0.5-2.1,0.2-3.1C841.2-770.2,841-770.6,840.6-771 "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1419",
    className: "st29",
    d: "M844.3-756c-0.2-0.4-0.4-0.7-0.6-1c-0.6-0.7-1.4-1.1-2.3-1.1c-1.9,0-3.3,0.8-3.2,1.7 c0.1,0.9,1.5,1.4,3,1.4c0.7,0,1.4-0.2,2-0.5C843.6-755.7,844-755.8,844.3-756"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1420",
    className: "st29",
    d: "M839.4-751.3c-0.1-0.3-0.2-0.7-0.3-1c-0.4-0.7-1-1.1-1.7-1.4c-1.5-0.4-2.6-0.1-2.9,0.6 c-0.3,0.7,0.8,1.7,2.2,2c0.6,0.1,1.2,0.1,1.8,0C838.9-751.2,839.4-751.3,839.4-751.3"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1421",
    className: "st29",
    d: "M795.9-754.9c0.3,0,0.7,0,1,0.1c0.6,0.2,1.2,0.2,1.8,0.1c0.7-0.1,1.4-0.4,1.9-0.9 c0.5-0.4,0.7-1,0.5-1.3c-0.5-0.6-1.4-0.9-3-0.6c-0.8,0.2-1.5,0.7-1.9,1.4C796-755.7,795.9-755.3,795.9-754.9"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1422",
    className: "st29",
    d: "M800.6-751.3c0.8,0.1,1.5,0,2.2-0.4c0.3-0.2,0.6-0.3,0.9-0.6c0.3-0.2,0.5-0.4,0.6-0.7 c0.1-0.3-0.1-0.6-0.6-0.8c-0.6-0.2-1.3-0.1-1.9,0.2C801-753,800.6-752.2,800.6-751.3"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1423",
    className: "st28",
    d: "M838.9-789c-1.3-0.2-2.6,0.2-3.5,1c-1.2,1.1-1.8,2.6-1.2,3.3c0.5,0.8,2.1,0.3,3.5-1 c0.6-0.6,0.9-1.3,1.1-2.1C838.8-788.1,838.9-788.5,838.9-789"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1424",
    className: "st28",
    d: "M835.7-797.9c0,0-0.4,0.4-1,0.9c-0.6,0.4-1.2,1-1.7,1.6c-0.9,1.3-1.6,2.9-0.9,3.7 c0.6,0.7,2.5,0.4,3.9-1.6c0.6-0.9,0.7-2.1,0.4-3.2C836.3-797.1,836-797.6,835.7-797.9"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1425",
    className: "st28",
    d: "M830.5-808.1c-0.4,0.3-0.8,0.7-1.2,1.1c-0.7,0.7-1.2,1.6-1.4,2.6 c-0.4,2.1-0.2,3.9,0.9,4.4c0.5,0.2,1.2,0,1.8-0.6c0.7-0.8,1.2-1.8,1.4-2.9c0.2-1.1,0-2.3-0.6-3.2 C831.2-807.2,830.9-807.7,830.5-808.1"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1426",
    className: "st28",
    d: "M815-800.3c-0.6,1.2-0.7,2.5-0.4,3.8c0.6,1.7,1.8,2.9,2.7,2.6c0.9-0.3,1.1-2,0.4-3.8 C817.2-798.9,816.2-799.8,815-800.3"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1427",
    className: "st28",
    d: "M810.7-795.7c-0.3,1.2-0.1,2.4,0.6,3.5c1,1.4,2.4,2.1,3.1,1.6c0.7-0.5,0.5-2.1-0.6-3.5 C813.1-795,811.9-795.6,810.7-795.7"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1428",
    className: "st28",
    d: "M822.3-806.8c-1,1-1.5,2.4-1.4,3.8c0.1,1,0.5,1.9,1.2,2.6c0.6,0.6,1.1,0.8,1.5,0.6 c0.5-0.3,0.8-0.9,0.8-1.4c0.1-0.8,0.1-1.6,0-2.3c-0.2-0.8-0.6-1.6-1.2-2.3C822.7-806.3,822.3-806.8,822.3-806.8"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1429",
    className: "st30",
    d: "M833.2-783.2c-0.3,0.2-0.5,0.4-0.7,0.7c-0.4,0.4-0.7,0.9-0.9,1.5 c-0.3,1.2-0.3,2.2,0.3,2.7c0.6,0.4,1.8-0.4,2.2-2c0.2-0.7,0.1-1.4-0.3-2.1C833.6-782.7,833.4-782.9,833.2-783.2"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1430",
    className: "st30",
    d: "M829.1-786.8c-0.3,0.3-0.5,0.7-0.7,1c-0.5,0.6-0.8,1.3-0.9,2.1c0,0.4,0,0.9,0,1.3 c0,0.4,0.2,0.8,0.3,1.2c0.4,0.7,0.8,1,1.2,0.9c0.5-0.2,0.8-0.6,1-1.1c0.3-0.6,0.5-1.3,0.6-2.1c0-0.9-0.2-1.8-0.8-2.5 C829.7-786.3,829.5-786.6,829.1-786.8"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1431",
    className: "st30",
    d: "M824.1-785.2c0,0,0,0.4,0,0.9c0,0.5,0.1,1,0.3,1.4c0.5,0.9,1.5,1.8,2,1.4 c0.5-0.4,0.6-1.3,0-2.5c-0.3-0.6-0.8-1-1.4-1.1C824.7-785.2,824.4-785.2,824.1-785.2"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1432",
    className: "st30",
    d: "M819.7-784.8c0,0,0.1,0.3,0.3,0.8c0.1,0.5,0.3,0.9,0.6,1.3c0.7,0.9,2,1.5,2.3,0.9 c0.3-0.5,0.2-1.3-0.6-2.3c-0.4-0.5-1-0.8-1.7-0.8C820.2-784.9,819.9-784.9,819.7-784.8"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1433",
    className: "st30",
    d: "M826.6-798.1c-0.2,0.2-0.4,0.4-0.6,0.7c-0.3,0.5-0.5,1-0.6,1.5c-0.1,0.4,0,0.8,0,1.3 c0,0.3,0.1,0.6,0.4,0.9c0.2,0.2,0.6,0.2,1.1-0.1c0.5-0.5,0.8-1.1,0.8-1.8c0-0.6-0.1-1.2-0.5-1.7 C827-797.7,826.8-797.9,826.6-798.1"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1434",
    className: "st30",
    d: "M822.5-798.8c0,0,0,0.5-0.1,0.9c-0.2,0.5-0.3,1-0.3,1.5c0,0.7,0.2,1.3,0.5,1.9 c0.3,0.5,0.9,0.7,1.1,0.5c0.3-0.2,0.5-0.6,0.6-0.9c0.2-0.5,0.3-1,0.3-1.6c0-0.8-0.4-1.5-1-1.9 C823.2-798.7,822.8-798.8,822.5-798.8"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1435",
    className: "st30",
    d: "M818.9-796.2c-0.1,0.6,0,1.3,0.3,1.9c0.6,0.8,1.3,1.2,1.7,0.8c0.3-0.3,0.2-1.2-0.3-1.9 C820.1-795.8,819.5-796.1,818.9-796.2"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1934",
    x: 687.9,
    y: -756.6,
    className: "st98",
    width: 128.5,
    height: 50.9
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1935",
    x: 687.9,
    y: -756.6,
    className: "st99",
    width: 128.5,
    height: 3.6
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1936",
    x: 724.3,
    y: -747.2,
    className: "st100",
    width: 25.6,
    height: 37.9
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1937",
    x: 730.2,
    y: -744,
    className: "st85",
    width: 13.2,
    height: 25.1
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1938",
    x: 731.1,
    y: -742.6,
    className: "st41",
    width: 11.4,
    height: 23
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1939",
    x: 732.1,
    y: -741.4,
    className: "st36",
    width: 9.5,
    height: 6.3
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1436",
    className: "st37",
    d: "M734.4-741.4h5.3l1.8,2.8v3.5h-3L734.4-741.4z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1437",
    className: "st37",
    d: "M732.1-739.5v-1.8h1.1l4.1,6.3h-2.3L732.1-739.5z"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1940",
    x: 736.5,
    y: -741.7,
    className: "st41",
    width: 0.6,
    height: 7.6
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1941",
    x: 731.7,
    y: -738.5,
    className: "st41",
    width: 10.2,
    height: 0.5
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1942",
    x: 685.9,
    y: -784.2,
    className: "st34",
    width: 132.5,
    height: 29.1
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1943",
    x: 783.8,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1944",
    x: 774.6,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1945",
    x: 802.1,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1946",
    x: 756.2,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1947",
    x: 792.9,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1948",
    x: 811.3,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1949",
    x: 765.4,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1950",
    x: 701,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1951",
    x: 710.2,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1952",
    x: 691.8,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1953",
    x: 728.6,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1954",
    x: 737.8,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1955",
    x: 719.4,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1956",
    x: 747,
    y: -784.2,
    className: "st101",
    width: 1.2,
    height: 29.1
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1957",
    x: 685.9,
    y: -758.1,
    className: "st102",
    width: 132.5,
    height: 3.1
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1438",
    className: "st103",
    d: "M761.8-755l28.3-36.8l28.2,36.8v49.3h-56.5V-755z"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1958",
    x: 772.3,
    y: -751.3,
    className: "st98",
    width: 35.5,
    height: 42.7
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1959",
    x: 773.5,
    y: -743.6,
    className: "st41",
    width: 33,
    height: 27.9
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1960",
    x: 774.3,
    y: -742.6,
    className: "st36",
    width: 31.1,
    height: 26
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1439",
    className: "st37",
    d: "M777.4-742.6h4.3l21.1,26h-4.3L777.4-742.6z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1440",
    className: "st37",
    d: "M805.4-725.1v7.9l-20.5-25.4h6.4L805.4-725.1z"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1961",
    x: 761.8,
    y: -753.7,
    className: "st104",
    width: 56.5,
    height: 3.8
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1962",
    x: 806.6,
    y: -768.7,
    className: "st104",
    width: 2.5,
    height: 63
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1963",
    x: 771,
    y: -768.7,
    className: "st104",
    width: 2.5,
    height: 63
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1964",
    x: 761.8,
    y: -753.7,
    className: "st105",
    width: 56.5,
    height: 1.4
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1965",
    x: 787.8,
    y: -775.6,
    className: "st98",
    width: 4.4,
    height: 14.9
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1966",
    x: 788.4,
    y: -773.6,
    className: "st106",
    width: 3.2,
    height: 10.9
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1967",
    x: 788.4,
    y: -771.2,
    className: "st36",
    width: 3.2,
    height: 8.5
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1441",
    className: "st102",
    d: "M819.5-750.9l2.3-1.8l-31.7-41.5l-31.6,41l2.3,1.8l29.2-38L819.5-750.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2899",
    transform: "translate(761.615 94.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2898",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000134220838222426269010000015538956534106561175_",
    x: 1,
    y: -884,
    width: 54.7,
    height: 35.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058580863051856619120000006311818932526334382_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134220838222426269010000015538956534106561175_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2897",
    style: {
      clipPath: "url(#SVGID_00000058580863051856619120000006311818932526334382_)"
    }
  }, _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1442",
    className: "st98",
    d: "M55.7-848.3l-27.1-31.2L1-848.3L28.5-884L55.7-848.3z"
  })))))), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1969",
    x: 687.9,
    y: -711.5,
    className: "st34",
    width: 130.8,
    height: 5.8
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1970",
    x: 698.7,
    y: -746.3,
    className: "st99",
    width: 13.6,
    height: 21
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1971",
    x: 699.7,
    y: -744.4,
    className: "st41",
    width: 11.4,
    height: 19.1
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1972",
    x: 700.7,
    y: -743.3,
    className: "st36",
    width: 9.5,
    height: 16.5
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1443",
    className: "st37",
    d: "M710.2-733.5l-9.5-5.6v-4.1h5l4.5,2.7V-733.5z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1444",
    className: "st37",
    d: "M700.7-734.3v-3.2l9.5,5.6v3.2L700.7-734.3z"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1973",
    x: 700.7,
    y: -739,
    className: "st41",
    width: 10,
    height: 0.6
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1974",
    x: 698.7,
    y: -725.3,
    className: "st103",
    width: 13.6,
    height: 2.6
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1445",
    className: "st34",
    d: "M753.9-743.7l-16.9-14.4l-16.9,14.4H753.9z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1446",
    className: "st102",
    d: "M720.8-743l16.3-13.9l16.3,13.9l1.2-1.4l-17.5-14.9l-17.5,14.9L720.8-743z"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1975",
    x: 726.9,
    y: -719.9,
    className: "st103",
    width: 19.8,
    height: 14.2
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1976",
    x: 726.9,
    y: -709.3,
    className: "st100",
    width: 19.8,
    height: 0.9
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1977",
    x: 726.9,
    y: -713.5,
    className: "st100",
    width: 19.8,
    height: 0.9
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1978",
    x: 726.9,
    y: -717.8,
    className: "st100",
    width: 19.8,
    height: 0.9
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1979",
    x: 747.9,
    y: -744,
    className: "st34",
    width: 3.1,
    height: 25.1
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1980",
    x: 746.3,
    y: -720.6,
    className: "st101",
    width: 6.2,
    height: 14.9
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1981",
    x: 746,
    y: -720.6,
    className: "st108",
    width: 6.8,
    height: 1.6
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1982",
    x: 723.2,
    y: -744,
    className: "st34",
    width: 3.1,
    height: 25.1
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1983",
    x: 721.6,
    y: -720.6,
    className: "st101",
    width: 6.2,
    height: 14.9
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1984",
    x: 721.3,
    y: -720.6,
    className: "st108",
    width: 6.8,
    height: 1.6
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2990",
    transform: "translate(-249.398 -15.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    className: "st19",
    d: "M308.3,15.4c13.8,0,25,11.2,25,25v19.2c0,12.3-8.9,22.7-21,24.7l-6.5,5.8l-6-5.5h-25.5 c-13.8,0-25-11.2-25-25V40.4c0-13.8,11.2-25,25-25H308.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-forward",
    className: "st109",
    d: "M298.8,53.8c-0.4-0.4-1.1-0.4-1.5,0l-4.9,4.9V38.3 c0-0.6-0.5-1-1.1-1c-0.6,0-1,0.5-1,1v20.4l-4.9-4.9c-0.4-0.4-1.1-0.4-1.5,0c-0.4,0.4-0.4,1.1,0,1.5l6.7,6.7l0,0 c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.3,0.1,0.4,0.1c0.3,0,0.5-0.1,0.7-0.3l6.7-6.7C299.2,54.9,299.2,54.2,298.8,53.8 C298.8,53.8,298.8,53.8,298.8,53.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2Arrow);
export default __webpack_public_path__ + "static/media/section2Arrow.3be549f492c68bec63c152a2739d233b.svg";
export { ForwardRef as ReactComponent };